module.exports = {
	"Entlebuch": {
		"y": "46.9627",
		"population": "3293",
		"x": "8.03135",
		"ID": "710"
	},
	"Merishausen": {
		"y": "47.7601",
		"population": "858",
		"x": "8.61053",
		"ID": "980"
	},
	"Sutz-Lattrigen": {
		"y": "47.09832",
		"population": "1390",
		"x": "7.22008",
		"ID": "334"
	},
	"Lavizzara": {
		"y": "46.42053",
		"population": "536",
		"x": "8.64263",
		"ID": "988"
	},
	"Dorflingen": {
		"y": "47.70604",
		"population": "962",
		"x": "8.72241",
		"ID": "1046"
	},
	"Daniken": {
		"y": "47.35321",
		"population": "2732",
		"x": "7.98737",
		"ID": "718"
	},
	"Penthereaz": {
		"y": "46.68171",
		"population": "389",
		"x": "6.6039",
		"ID": "82"
	},
	"Herisau": {
		"y": "47.38615",
		"population": "15383",
		"x": "9.27916",
		"ID": "1308"
	},
	"Biasca": {
		"y": "46.35972",
		"population": "6079",
		"x": "8.96965",
		"ID": "1160"
	},
	"Monte Carasso": {
		"y": "46.18649",
		"population": "2826",
		"x": "8.99892",
		"ID": "1157"
	},
	"Neunkirch": {
		"y": "47.69012",
		"population": "2044",
		"x": "8.49981",
		"ID": "914"
	},
	"La Sarraz": {
		"y": "46.65863",
		"population": "2516",
		"x": "6.51077",
		"ID": "71"
	},
	"Urtenen-Schonbuhl": {
		"y": "47.02088",
		"population": "6148",
		"x": "7.49989",
		"ID": "452"
	},
	"Trun": {
		"y": "46.74292",
		"population": "1173",
		"x": "8.98716",
		"ID": "1168"
	},
	"Bauma": {
		"y": "47.36745",
		"population": "4764",
		"x": "8.87905",
		"ID": "1108"
	},
	"Gonten": {
		"y": "47.32725",
		"population": "1376",
		"x": "9.34705",
		"ID": "1333"
	},
	"Ruschlikon": {
		"y": "47.30688",
		"population": "5583",
		"x": "8.55135",
		"ID": "938"
	},
	"Udligenswil": {
		"y": "47.09005",
		"population": "2258",
		"x": "8.40335",
		"ID": "874"
	},
	"Kusnacht (ZH)": {
		"y": "47.31805",
		"population": "13556",
		"x": "8.58401",
		"ID": "972"
	},
	"Courtetelle": {
		"y": "47.34074",
		"population": "2564",
		"x": "7.31827",
		"ID": "368"
	},
	"Freienbach": {
		"y": "47.20534",
		"population": "15786",
		"x": "8.75842",
		"ID": "1037"
	},
	"Kilchberg (ZH)": {
		"y": "47.32438",
		"population": "8057",
		"x": "8.54548",
		"ID": "938"
	},
	"Daillens": {
		"y": "46.62115",
		"population": "940",
		"x": "6.54871",
		"ID": "81"
	},
	"Chatel-Saint-Denis": {
		"y": "46.52691",
		"population": "6379",
		"x": "6.90083",
		"ID": "166"
	},
	"Disentis/Muster": {
		"y": "46.70341",
		"population": "2021",
		"x": "8.8509",
		"ID": "1095"
	},
	"Abtwil": {
		"y": "47.17397",
		"population": "961",
		"x": "8.35374",
		"ID": "850"
	},
	"Saint-Oyens": {
		"y": "46.49937",
		"population": "346",
		"x": "6.30334",
		"ID": "44"
	},
	"Itingen": {
		"y": "47.46651",
		"population": "2041",
		"x": "7.78502",
		"ID": "592"
	},
	"Hermrigen": {
		"y": "47.08166",
		"population": "300",
		"x": "7.24158",
		"ID": "334"
	},
	"Hochdorf": {
		"y": "47.15196",
		"population": "9339",
		"x": "8.26148",
		"ID": "825"
	},
	"Cugy (VD)": {
		"y": "46.58624",
		"population": "2712",
		"x": "6.64089",
		"ID": "92"
	},
	"La Tour-de-Peilz": {
		"y": "46.45312",
		"population": "11382",
		"x": "6.85856",
		"ID": "165"
	},
	"Oberkirch": {
		"y": "47.15642",
		"population": "4277",
		"x": "8.11567",
		"ID": "773"
	},
	"Arosa": {
		"y": "46.77793",
		"population": "3162",
		"x": "9.67621",
		"ID": "1456"
	},
	"Gsteig": {
		"y": "46.38585",
		"population": "967",
		"x": "7.26751",
		"ID": "350"
	},
	"Filisur": {
		"y": "46.67215",
		"population": "436",
		"x": "9.68801",
		"ID": "1454"
	},
	"Hirzel": {
		"y": "47.21667",
		"population": "2136",
		"x": "8.6",
		"ID": "970"
	},
	"Wolfisberg": {
		"y": "47.27485",
		"population": "187",
		"x": "7.65993",
		"ID": "555"
	},
	"Corminboeuf": {
		"y": "46.81237",
		"population": "2309",
		"x": "7.10492",
		"ID": "264"
	},
	"Sorens": {
		"y": "46.66846",
		"population": "1080",
		"x": "7.05693",
		"ID": "229"
	},
	"Val-de-Charmey": {
		"y": "46.61622",
		"population": "2346",
		"x": "7.16814",
		"ID": "293"
	},
	"Sarzens": {
		"y": "46.68134",
		"population": "80",
		"x": "6.84738",
		"ID": "147"
	},
	"Buchberg": {
		"y": "47.57282",
		"population": "823",
		"x": "8.56281",
		"ID": "943"
	},
	"Guggisberg": {
		"y": "46.76756",
		"population": "1525",
		"x": "7.32946",
		"ID": "388"
	},
	"Wynau": {
		"y": "47.2557",
		"population": "1596",
		"x": "7.81626",
		"ID": "621"
	},
	"Neunforn": {
		"y": "47.60232",
		"population": "947",
		"x": "8.77196",
		"ID": "1044"
	},
	"Dallenwil": {
		"y": "46.9242",
		"population": "1783",
		"x": "8.38785",
		"ID": "871"
	},
	"Gurzelen": {
		"y": "46.77644",
		"population": "845",
		"x": "7.54264",
		"ID": "479"
	},
	"Leuggern": {
		"y": "47.58195",
		"population": "2112",
		"x": "8.21945",
		"ID": "808"
	},
	"Buetigen": {
		"y": "47.10656",
		"population": "823",
		"x": "7.34119",
		"ID": "394"
	},
	"Tolochenaz": {
		"y": "46.50504",
		"population": "1852",
		"x": "6.47279",
		"ID": "68"
	},
	"Scheuren": {
		"y": "47.13471",
		"population": "447",
		"x": "7.32089",
		"ID": "364"
	},
	"Galmiz": {
		"y": "46.94875",
		"population": "636",
		"x": "7.15804",
		"ID": "300"
	},
	"Arnex-sur-Nyon": {
		"y": "46.3729",
		"population": "219",
		"x": "6.18989",
		"ID": "24"
	},
	"Hefenhofen": {
		"y": "47.56",
		"population": "1213",
		"x": "9.31366",
		"ID": "1337"
	},
	"Rorschacherberg": {
		"y": "47.47313",
		"population": "7127",
		"x": "9.51116",
		"ID": "1407"
	},
	"Albula/Alvra": {
		"y": "46.55",
		"population": "1313",
		"x": "9.8",
		"ID": "1481"
	},
	"Chur": {
		"y": "46.84986",
		"population": "34004",
		"x": "9.53287",
		"ID": "1395"
	},
	"Cornol": {
		"y": "47.40752",
		"population": "1016",
		"x": "7.16247",
		"ID": "308"
	},
	"Amriswil": {
		"y": "47.54699",
		"population": "12892",
		"x": "9.29586",
		"ID": "1311"
	},
	"Oberwil-Lieli": {
		"y": "47.33382",
		"population": "2194",
		"x": "8.38123",
		"ID": "853"
	},
	"Saint-Brais": {
		"y": "47.30611",
		"population": "234",
		"x": "7.11368",
		"ID": "274"
	},
	"Salvenach": {
		"y": "46.91412",
		"population": "590",
		"x": "7.15229",
		"ID": "299"
	},
	"Pohlern": {
		"y": "46.72515",
		"population": "251",
		"x": "7.53525",
		"ID": "478"
	},
	"Lohn-Ammannsegg": {
		"y": "47.17139",
		"population": "2690",
		"x": "7.52941",
		"ID": "487"
	},
	"Attinghausen": {
		"y": "46.86255",
		"population": "1612",
		"x": "8.63036",
		"ID": "963"
	},
	"Agarn": {
		"y": "46.29749",
		"population": "763",
		"x": "7.66322",
		"ID": "536"
	},
	"Leysin": {
		"y": "46.34183",
		"population": "2674",
		"x": "7.01151",
		"ID": "223"
	},
	"Bussnang": {
		"y": "47.55678",
		"population": "2244",
		"x": "9.08157",
		"ID": "1220"
	},
	"Volken": {
		"y": "47.57482",
		"population": "334",
		"x": "8.62579",
		"ID": "977"
	},
	"Killwangen": {
		"y": "47.43182",
		"population": "1940",
		"x": "8.34805",
		"ID": "855"
	},
	"Brenles": {
		"y": "46.67114",
		"population": "142",
		"x": "6.8538",
		"ID": "147"
	},
	"Boniswil": {
		"y": "47.31725",
		"population": "1400",
		"x": "8.18963",
		"ID": "803"
	},
	"Kesswil": {
		"y": "47.5935",
		"population": "996",
		"x": "9.31723",
		"ID": "1338"
	},
	"Berolle": {
		"y": "46.55857",
		"population": "291",
		"x": "6.33628",
		"ID": "45"
	},
	"Vordemwald": {
		"y": "47.27585",
		"population": "1879",
		"x": "7.90114",
		"ID": "654"
	},
	"Mezzovico-Vira": {
		"y": "46.09694",
		"population": "1336",
		"x": "8.91134",
		"ID": "1120"
	},
	"Egnach": {
		"y": "47.54268",
		"population": "4519",
		"x": "9.38048",
		"ID": "1359"
	},
	"Gansbrunnen": {
		"y": "47.26123",
		"population": "94",
		"x": "7.46856",
		"ID": "457"
	},
	"Isorno": {
		"y": "46.18333",
		"population": "298",
		"x": "8.71667",
		"ID": "1017"
	},
	"Massonnens": {
		"y": "46.69661",
		"population": "509",
		"x": "6.97624",
		"ID": "197"
	},
	"Zufikon": {
		"y": "47.34756",
		"population": "4339",
		"x": "8.36029",
		"ID": "853"
	},
	"Gempenach": {
		"y": "46.943",
		"population": "305",
		"x": "7.19924",
		"ID": "331"
	},
	"Le Glebe": {
		"y": "46.71134",
		"population": "1255",
		"x": "7.02824",
		"ID": "230"
	},
	"Cunter": {
		"y": "46.60959",
		"population": "254",
		"x": "9.58978",
		"ID": "1415"
	},
	"Uster": {
		"y": "47.34713",
		"population": "33462",
		"x": "8.72091",
		"ID": "1039"
	},
	"Baltschieder": {
		"y": "46.30888",
		"population": "1299",
		"x": "7.8657",
		"ID": "636"
	},
	"Spreitenbach": {
		"y": "47.42016",
		"population": "11139",
		"x": "8.36301",
		"ID": "855"
	},
	"Oberweningen": {
		"y": "47.50226",
		"population": "1783",
		"x": "8.40702",
		"ID": "882"
	},
	"Zwieselberg": {
		"y": "46.71006",
		"population": "306",
		"x": "7.61669",
		"ID": "511"
	},
	"Cugy (FR)": {
		"y": "46.81479",
		"population": "1624",
		"x": "6.88888",
		"ID": "172"
	},
	"Inkwil": {
		"y": "47.20103",
		"population": "616",
		"x": "7.6712",
		"ID": "553"
	},
	"Domdidier": {
		"y": "46.86716",
		"population": "3041",
		"x": "7.01337",
		"ID": "233"
	},
	"Thierachern": {
		"y": "46.75319",
		"population": "2399",
		"x": "7.57442",
		"ID": "479"
	},
	"Kirchenthurnen": {
		"y": "46.82375",
		"population": "274",
		"x": "7.50054",
		"ID": "449"
	},
	"Vucherens": {
		"y": "46.62319",
		"population": "543",
		"x": "6.77987",
		"ID": "124"
	},
	"Niederburen": {
		"y": "47.46547",
		"population": "1502",
		"x": "9.20568",
		"ID": "1281"
	},
	"Kiesen": {
		"y": "46.81956",
		"population": "915",
		"x": "7.58402",
		"ID": "480"
	},
	"Rapperswil-Jona": {
		"y": "47.22557",
		"population": "26444",
		"x": "8.82228",
		"ID": "1071"
	},
	"Mammern": {
		"y": "47.64625",
		"population": "625",
		"x": "8.91519",
		"ID": "1113"
	},
	"Berg (TG)": {
		"y": "47.57879",
		"population": "3252",
		"x": "9.16635",
		"ID": "1253"
	},
	"Pleigne": {
		"y": "47.40758",
		"population": "358",
		"x": "7.29056",
		"ID": "369"
	},
	"Trelex": {
		"y": "46.41538",
		"population": "1421",
		"x": "6.20813",
		"ID": "25"
	},
	"Leuk": {
		"y": "46.31736",
		"population": "3843",
		"x": "7.63412",
		"ID": "503"
	},
	"Eggenwil": {
		"y": "47.3704",
		"population": "946",
		"x": "8.33948",
		"ID": "854"
	},
	"Schnottwil": {
		"y": "47.11173",
		"population": "1050",
		"x": "7.39368",
		"ID": "424"
	},
	"Wildhaus-Alt St. Johann": {
		"y": "47.20583",
		"population": "2651",
		"x": "9.35402",
		"ID": "1330"
	},
	"Steinach": {
		"y": "47.50178",
		"population": "3490",
		"x": "9.43846",
		"ID": "1383"
	},
	"Bachenbulach": {
		"y": "47.50317",
		"population": "3994",
		"x": "8.54556",
		"ID": "942"
	},
	"Ittigen": {
		"y": "46.97434",
		"population": "11111",
		"x": "7.48281",
		"ID": "452"
	},
	"Bussy-sur-Moudon": {
		"y": "46.69047",
		"population": "198",
		"x": "6.80959",
		"ID": "147"
	},
	"Appenzell": {
		"y": "47.33103",
		"population": "5636",
		"x": "9.40996",
		"ID": "1355"
	},
	"Saint-Legier-La Chiesaz": {
		"y": "46.48993",
		"population": "4936",
		"x": "6.89817",
		"ID": "166"
	},
	"Arboldswil": {
		"y": "47.41438",
		"population": "567",
		"x": "7.71755",
		"ID": "591"
	},
	"Elsau": {
		"y": "47.5026",
		"population": "3458",
		"x": "8.80792",
		"ID": "1076"
	},
	"Vergeletto": {
		"y": "46.22706",
		"population": "59",
		"x": "8.60208",
		"ID": "951"
	},
	"Ruti bei Buren": {
		"y": "47.15167",
		"population": "829",
		"x": "7.40307",
		"ID": "425"
	},
	"Triengen": {
		"y": "47.23375",
		"population": "4445",
		"x": "8.07729",
		"ID": "745"
	},
	"Saint-Barthelemy (VD)": {
		"y": "46.63484",
		"population": "730",
		"x": "6.60212",
		"ID": "81"
	},
	"Stabio": {
		"y": "45.84846",
		"population": "4569",
		"x": "8.93642",
		"ID": "1151"
	},
	"Bottens": {
		"y": "46.61596",
		"population": "1223",
		"x": "6.66149",
		"ID": "92"
	},
	"Winznau": {
		"y": "47.36356",
		"population": "1802",
		"x": "7.93011",
		"ID": "688"
	},
	"Heiligenschwendi": {
		"y": "46.75109",
		"population": "697",
		"x": "7.68391",
		"ID": "545"
	},
	"Kallern": {
		"y": "47.30948",
		"population": "328",
		"x": "8.29011",
		"ID": "828"
	},
	"Saicourt": {
		"y": "47.24281",
		"population": "598",
		"x": "7.20745",
		"ID": "337"
	},
	"Matzendorf": {
		"y": "47.30374",
		"population": "1279",
		"x": "7.6282",
		"ID": "522"
	},
	"Hermance": {
		"y": "46.3",
		"population": "977",
		"x": "6.23333",
		"ID": "32"
	},
	"Unterbach": {
		"y": "46.2843",
		"population": "410",
		"x": "7.79918",
		"ID": "602"
	},
	"Arogno": {
		"y": "45.95909",
		"population": "985",
		"x": "8.98441",
		"ID": "1153"
	},
	"Oberems": {
		"y": "46.28188",
		"population": "124",
		"x": "7.69352",
		"ID": "536"
	},
	"Lutzenberg": {
		"y": "47.46135",
		"population": "1243",
		"x": "9.57613",
		"ID": "1407"
	},
	"Montagny-pres-Yverdon": {
		"y": "46.79289",
		"population": "711",
		"x": "6.61222",
		"ID": "96"
	},
	"Therwil": {
		"y": "47.50117",
		"population": "9908",
		"x": "7.55286",
		"ID": "493"
	},
	"Lutzelfluh": {
		"y": "47.00757",
		"population": "4017",
		"x": "7.69165",
		"ID": "550"
	},
	"Treyvaux": {
		"y": "46.72745",
		"population": "1424",
		"x": "7.13772",
		"ID": "295"
	},
	"Giubiasco": {
		"y": "46.17246",
		"population": "8486",
		"x": "9.00793",
		"ID": "1157"
	},
	"Ormont-Dessous": {
		"y": "46.3766",
		"population": "1114",
		"x": "7.07022",
		"ID": "256"
	},
	"Wallisellen": {
		"y": "47.41499",
		"population": "15446",
		"x": "8.59672",
		"ID": "974"
	},
	"Innertkirchen": {
		"y": "46.70467",
		"population": "1032",
		"x": "8.22876",
		"ID": "791"
	},
	"Galgenen": {
		"y": "47.18226",
		"population": "5083",
		"x": "8.87046",
		"ID": "1104"
	},
	"Hellsau": {
		"y": "47.14583",
		"population": "201",
		"x": "7.65175",
		"ID": "519"
	},
	"Pully": {
		"y": "46.51027",
		"population": "17452",
		"x": "6.66183",
		"ID": "90"
	},
	"Greifensee": {
		"y": "47.3484",
		"population": "5316",
		"x": "8.68124",
		"ID": "1006"
	},
	"Kirchdorf (BE)": {
		"y": "46.82085",
		"population": "950",
		"x": "7.54847",
		"ID": "480"
	},
	"Churwalden": {
		"y": "46.78143",
		"population": "1990",
		"x": "9.54377",
		"ID": "1394"
	},
	"Tinizong-Rona": {
		"y": "46.57214",
		"population": "301",
		"x": "9.66078",
		"ID": "1435"
	},
	"Syens": {
		"y": "46.64406",
		"population": "139",
		"x": "6.77689",
		"ID": "125"
	},
	"Frutigen": {
		"y": "46.56761",
		"population": "6746",
		"x": "7.67566",
		"ID": "541"
	},
	"Eschlikon": {
		"y": "47.46361",
		"population": "4211",
		"x": "8.96381",
		"ID": "1146"
	},
	"Tenero-Contra": {
		"y": "46.18446",
		"population": "2844",
		"x": "8.84487",
		"ID": "1085"
	},
	"Gettnau": {
		"y": "47.14064",
		"population": "1123",
		"x": "7.97007",
		"ID": "683"
	},
	"Tecknau": {
		"y": "47.45132",
		"population": "852",
		"x": "7.88399",
		"ID": "658"
	},
	"Staldenried": {
		"y": "46.22937",
		"population": "546",
		"x": "7.88269",
		"ID": "634"
	},
	"Cortebert": {
		"y": "47.18825",
		"population": "703",
		"x": "7.10891",
		"ID": "272"
	},
	"La Punt-Chamues-ch": {
		"y": "46.57887",
		"population": "734",
		"x": "9.92015",
		"ID": "1495"
	},
	"Zofingen": {
		"y": "47.28779",
		"population": "11107",
		"x": "7.94586",
		"ID": "686"
	},
	"Arconciel": {
		"y": "46.74733",
		"population": "863",
		"x": "7.12152",
		"ID": "263"
	},
	"La Brevine": {
		"y": "46.98055",
		"population": "635",
		"x": "6.60639",
		"ID": "99"
	},
	"Trachselwald": {
		"y": "47.05344",
		"population": "958",
		"x": "7.75123",
		"ID": "584"
	},
	"Aire-la-Ville": {
		"y": "46.19057",
		"population": "1131",
		"x": "6.04287",
		"ID": "6"
	},
	"Rietheim": {
		"y": "47.6",
		"population": "734",
		"x": "8.28333",
		"ID": "834"
	},
	"Concise": {
		"y": "46.85027",
		"population": "949",
		"x": "6.71968",
		"ID": "109"
	},
	"Wangen (SZ)": {
		"y": "47.19082",
		"population": "4784",
		"x": "8.89498",
		"ID": "1141"
	},
	"Niederhunigen": {
		"y": "46.87905",
		"population": "601",
		"x": "7.63857",
		"ID": "514"
	},
	"Dagerlen": {
		"y": "47.56073",
		"population": "1004",
		"x": "8.72147",
		"ID": "1010"
	},
	"Urmein": {
		"y": "46.69175",
		"population": "139",
		"x": "9.40082",
		"ID": "1343"
	},
	"Erlenbach im Simmental": {
		"y": "46.66021",
		"population": "1681",
		"x": "7.55445",
		"ID": "477"
	},
	"Payerne": {
		"y": "46.82201",
		"population": "9352",
		"x": "6.93608",
		"ID": "200"
	},
	"Vuisternens-en-Ogoz": {
		"y": "46.70424",
		"population": "986",
		"x": "7.0561",
		"ID": "230"
	},
	"Rohrbachgraben": {
		"y": "47.11934",
		"population": "392",
		"x": "7.80044",
		"ID": "618"
	},
	"Chermignon": {
		"y": "46.28844",
		"population": "3101",
		"x": "7.47487",
		"ID": "438"
	},
	"Morges": {
		"y": "46.51127",
		"population": "15371",
		"x": "6.49854",
		"ID": "68"
	},
	"Langendorf": {
		"y": "47.21974",
		"population": "3686",
		"x": "7.51469",
		"ID": "488"
	},
	"Schaffhausen": {
		"y": "47.69732",
		"population": "35151",
		"x": "8.63493",
		"ID": "979"
	},
	"Ennetmoos": {
		"y": "46.95781",
		"population": "2086",
		"x": "8.33779",
		"ID": "846"
	},
	"Corserey": {
		"y": "46.7731",
		"population": "416",
		"x": "6.98873",
		"ID": "199"
	},
	"Unterlangenegg": {
		"y": "46.79926",
		"population": "922",
		"x": "7.70125",
		"ID": "546"
	},
	"Rorbas": {
		"y": "47.53092",
		"population": "2730",
		"x": "8.57555",
		"ID": "976"
	},
	"Hagneck": {
		"y": "47.05703",
		"population": "406",
		"x": "7.18532",
		"ID": "333"
	},
	"Novalles": {
		"y": "46.82837",
		"population": "102",
		"x": "6.59506",
		"ID": "85"
	},
	"Leutwil": {
		"y": "47.30826",
		"population": "754",
		"x": "8.17408",
		"ID": "776"
	},
	"Corsier-sur-Vevey": {
		"y": "46.49441",
		"population": "3417",
		"x": "6.87104",
		"ID": "166"
	},
	"Bergdietikon": {
		"y": "47.38921",
		"population": "2678",
		"x": "8.38624",
		"ID": "880"
	},
	"Meilen": {
		"y": "47.27232",
		"population": "13242",
		"x": "8.64617",
		"ID": "971"
	},
	"Murist": {
		"y": "46.79025",
		"population": "615",
		"x": "6.80708",
		"ID": "149"
	},
	"Gurmels": {
		"y": "46.89407",
		"population": "4092",
		"x": "7.17192",
		"ID": "299"
	},
	"Domleschg": {
		"y": "46.73536",
		"population": "1932",
		"x": "9.46077",
		"ID": "1368"
	},
	"Gempen": {
		"y": "47.47585",
		"population": "887",
		"x": "7.66028",
		"ID": "559"
	},
	"Bournens": {
		"y": "46.60894",
		"population": "372",
		"x": "6.56406",
		"ID": "81"
	},
	"Studen (BE)": {
		"y": "47.11305",
		"population": "3075",
		"x": "7.30323",
		"ID": "364"
	},
	"Jaun": {
		"y": "46.61122",
		"population": "655",
		"x": "7.27637",
		"ID": "354"
	},
	"Mauborget": {
		"y": "46.8559",
		"population": "119",
		"x": "6.61632",
		"ID": "97"
	},
	"Vogorno": {
		"y": "46.21191",
		"population": "275",
		"x": "8.85661",
		"ID": "1086"
	},
	"St. Niklaus": {
		"y": "46.17717",
		"population": "2267",
		"x": "7.80349",
		"ID": "600"
	},
	"Sonvilier": {
		"y": "47.13883",
		"population": "1233",
		"x": "6.96404",
		"ID": "206"
	},
	"Chene-Paquier": {
		"y": "46.77149",
		"population": "124",
		"x": "6.76937",
		"ID": "127"
	},
	"Ermensee": {
		"y": "47.22781",
		"population": "888",
		"x": "8.23627",
		"ID": "801"
	},
	"Remaufens": {
		"y": "46.52872",
		"population": "1037",
		"x": "6.88262",
		"ID": "167"
	},
	"Twann-Tuscherz": {
		"y": "47.11412",
		"population": "1146",
		"x": "7.19418",
		"ID": "334"
	},
	"Burgistein": {
		"y": "46.78464",
		"population": "1039",
		"x": "7.49988",
		"ID": "448"
	},
	"Zollikon": {
		"y": "47.34019",
		"population": "12529",
		"x": "8.57407",
		"ID": "972"
	},
	"Wettingen": {
		"y": "47.47049",
		"population": "19961",
		"x": "8.31636",
		"ID": "856"
	},
	"Vaz/Obervaz": {
		"y": "46.72215",
		"population": "2697",
		"x": "9.55905",
		"ID": "1417"
	},
	"Crans-pres-Celigny": {
		"y": "46.36432",
		"population": "2161",
		"x": "6.20532",
		"ID": "24"
	},
	"Lohningen": {
		"y": "47.70121",
		"population": "1374",
		"x": "8.55236",
		"ID": "946"
	},
	"Le Cerneux-Pequignot": {
		"y": "47.01585",
		"population": "320",
		"x": "6.67069",
		"ID": "112"
	},
	"Mumpf": {
		"y": "47.54563",
		"population": "1300",
		"x": "7.92123",
		"ID": "691"
	},
	"Wurenlos": {
		"y": "47.44208",
		"population": "6133",
		"x": "8.36439",
		"ID": "855"
	},
	"Kemmental": {
		"y": "47.60801",
		"population": "2369",
		"x": "9.14126",
		"ID": "1254"
	},
	"Cremines": {
		"y": "47.28329",
		"population": "521",
		"x": "7.44032",
		"ID": "427"
	},
	"Grancia": {
		"y": "45.96809",
		"population": "518",
		"x": "8.92691",
		"ID": "1153"
	},
	"Unterengstringen": {
		"y": "47.41396",
		"population": "3601",
		"x": "8.44761",
		"ID": "880"
	},
	"Poschiavo": {
		"y": "46.32441",
		"population": "3416",
		"x": "10.05823",
		"ID": "1532"
	},
	"Waltensburg/Vuorz": {
		"y": "46.77367",
		"population": "335",
		"x": "9.1085",
		"ID": "1237"
	},
	"Ziefen": {
		"y": "47.42924",
		"population": "1529",
		"x": "7.7053",
		"ID": "558"
	},
	"Donneloye": {
		"y": "46.74551",
		"population": "766",
		"x": "6.7164",
		"ID": "107"
	},
	"Stocken-Hofen": {
		"y": "46.71137",
		"population": "976",
		"x": "7.56461",
		"ID": "478"
	},
	"Coinsins": {
		"y": "46.42335",
		"population": "435",
		"x": "6.23733",
		"ID": "35"
	},
	"Hunenberg": {
		"y": "47.17536",
		"population": "8816",
		"x": "8.42497",
		"ID": "876"
	},
	"Niederhelfenschwil": {
		"y": "47.47487",
		"population": "2980",
		"x": "9.18543",
		"ID": "1281"
	},
	"Vuarrens": {
		"y": "46.68578",
		"population": "913",
		"x": "6.64793",
		"ID": "94"
	},
	"Schonholzerswilen": {
		"y": "47.51702",
		"population": "807",
		"x": "9.14089",
		"ID": "1252"
	},
	"Kyburg": {
		"y": "47.45569",
		"population": "405",
		"x": "8.74476",
		"ID": "1041"
	},
	"Wildberg": {
		"y": "47.42585",
		"population": "999",
		"x": "8.81669",
		"ID": "1074"
	},
	"Moiry": {
		"y": "46.65026",
		"population": "289",
		"x": "6.4537",
		"ID": "60"
	},
	"Locarno": {
		"y": "46.17086",
		"population": "15637",
		"x": "8.79953",
		"ID": "1050"
	},
	"Humlikon": {
		"y": "47.57641",
		"population": "497",
		"x": "8.67007",
		"ID": "1010"
	},
	"Steinerberg": {
		"y": "47.05206",
		"population": "902",
		"x": "8.58399",
		"ID": "967"
	},
	"Ormalingen": {
		"y": "47.46936",
		"population": "2083",
		"x": "7.87248",
		"ID": "658"
	},
	"Wil (ZH)": {
		"y": "47.60447",
		"population": "1366",
		"x": "8.50815",
		"ID": "912"
	},
	"Jussy": {
		"y": "46.2359",
		"population": "1250",
		"x": "6.26701",
		"ID": "31"
	},
	"Bettingen": {
		"y": "47.57039",
		"population": "1076",
		"x": "7.66425",
		"ID": "561"
	},
	"Hausen am Albis": {
		"y": "47.24496",
		"population": "3450",
		"x": "8.53299",
		"ID": "937"
	},
	"Erlenbach (ZH)": {
		"y": "47.30298",
		"population": "5375",
		"x": "8.59743",
		"ID": "972"
	},
	"Burtigny": {
		"y": "46.46754",
		"population": "328",
		"x": "6.25706",
		"ID": "35"
	},
	"Saas-Grund": {
		"y": "46.12281",
		"population": "1031",
		"x": "7.93651",
		"ID": "664"
	},
	"Corcelles-pres-Payerne": {
		"y": "46.83322",
		"population": "2210",
		"x": "6.96231",
		"ID": "200"
	},
	"Eich": {
		"y": "47.15116",
		"population": "1672",
		"x": "8.16695",
		"ID": "773"
	},
	"Trimbach": {
		"y": "47.36561",
		"population": "6354",
		"x": "7.8868",
		"ID": "656"
	},
	"Bockten": {
		"y": "47.46539",
		"population": "778",
		"x": "7.83263",
		"ID": "625"
	},
	"Thunstetten": {
		"y": "47.20275",
		"population": "3219",
		"x": "7.75746",
		"ID": "587"
	},
	"Vaux-sur-Morges": {
		"y": "46.53853",
		"population": "203",
		"x": "6.46393",
		"ID": "58"
	},
	"Aclens": {
		"y": "46.56825",
		"population": "516",
		"x": "6.51091",
		"ID": "69"
	},
	"Maggia": {
		"y": "46.24689",
		"population": "2550",
		"x": "8.7062",
		"ID": "1018"
	},
	"Gisikon": {
		"y": "47.12701",
		"population": "1188",
		"x": "8.40356",
		"ID": "875"
	},
	"Wasterkingen": {
		"y": "47.58956",
		"population": "570",
		"x": "8.47121",
		"ID": "912"
	},
	"Soubey": {
		"y": "47.30933",
		"population": "132",
		"x": "7.04886",
		"ID": "274"
	},
	"Allaman": {
		"y": "46.47008",
		"population": "391",
		"x": "6.3964",
		"ID": "49"
	},
	"Wadenswil": {
		"y": "47.22683",
		"population": "21324",
		"x": "8.6687",
		"ID": "1004"
	},
	"Varen": {
		"y": "46.3186",
		"population": "603",
		"x": "7.60743",
		"ID": "503"
	},
	"Grindelwald": {
		"y": "46.62396",
		"population": "3711",
		"x": "8.03601",
		"ID": "704"
	},
	"Bussy-Chardonney": {
		"y": "46.53086",
		"population": "377",
		"x": "6.44097",
		"ID": "58"
	},
	"Drei Hofe": {
		"y": "47.16198",
		"population": "736",
		"x": "7.63792",
		"ID": "519"
	},
	"Surpierre": {
		"y": "46.74207",
		"population": "325",
		"x": "6.84985",
		"ID": "148"
	},
	"Villarsel-sur-Marly": {
		"y": "46.76178",
		"population": "84",
		"x": "7.17195",
		"ID": "296"
	},
	"Engelberg": {
		"y": "46.82107",
		"population": "4021",
		"x": "8.40133",
		"ID": "869"
	},
	"Ayent": {
		"y": "46.28249",
		"population": "3865",
		"x": "7.41028",
		"ID": "408"
	},
	"Le Flon": {
		"y": "46.60447",
		"population": "1160",
		"x": "6.87329",
		"ID": "168"
	},
	"Lohn (GR)": {
		"y": "46.65139",
		"population": "43",
		"x": "9.42731",
		"ID": "1367"
	},
	"Oltingen": {
		"y": "47.43297",
		"population": "473",
		"x": "7.93919",
		"ID": "689"
	},
	"Morschwil": {
		"y": "47.47097",
		"population": "3519",
		"x": "9.42278",
		"ID": "1358"
	},
	"Steinhausen": {
		"y": "47.19857",
		"population": "9453",
		"x": "8.48718",
		"ID": "904"
	},
	"Buchholterberg": {
		"y": "46.81351",
		"population": "1523",
		"x": "7.67463",
		"ID": "546"
	},
	"Aesch (LU)": {
		"y": "47.25637",
		"population": "1068",
		"x": "8.2409",
		"ID": "827"
	},
	"Laconnex": {
		"y": "46.157",
		"population": "654",
		"x": "6.03128",
		"ID": "5"
	},
	"Lantsch/Lenz": {
		"y": "46.68413",
		"population": "517",
		"x": "9.5627",
		"ID": "1416"
	},
	"Kippel": {
		"y": "46.39885",
		"population": "349",
		"x": "7.77194",
		"ID": "604"
	},
	"Rossiniere": {
		"y": "46.46695",
		"population": "542",
		"x": "7.08205",
		"ID": "258"
	},
	"Rebevelier": {
		"y": "47.29136",
		"population": "43",
		"x": "7.1923",
		"ID": "338"
	},
	"Bettwiesen": {
		"y": "47.49718",
		"population": "1134",
		"x": "9.0285",
		"ID": "1182"
	},
	"Montcherand": {
		"y": "46.73363",
		"population": "474",
		"x": "6.5082",
		"ID": "73"
	},
	"Blonay": {
		"y": "46.46778",
		"population": "5997",
		"x": "6.89615",
		"ID": "165"
	},
	"Romoos": {
		"y": "47.01093",
		"population": "665",
		"x": "8.02543",
		"ID": "711"
	},
	"Sempach": {
		"y": "47.14738",
		"population": "4112",
		"x": "8.14978",
		"ID": "773"
	},
	"Ringgenberg (BE)": {
		"y": "46.70114",
		"population": "2603",
		"x": "7.89445",
		"ID": "643"
	},
	"Schonengrund": {
		"y": "47.32586",
		"population": "517",
		"x": "9.2269",
		"ID": "1279"
	},
	"Zeihen": {
		"y": "47.47536",
		"population": "1094",
		"x": "8.08313",
		"ID": "750"
	},
	"Hagglingen": {
		"y": "47.38849",
		"population": "2391",
		"x": "8.25323",
		"ID": "830"
	},
	"Epalinges": {
		"y": "46.55177",
		"population": "9144",
		"x": "6.66829",
		"ID": "91"
	},
	"Prevondavaux": {
		"y": "46.72963",
		"population": "64",
		"x": "6.79561",
		"ID": "148"
	},
	"Dallikon": {
		"y": "47.43938",
		"population": "3930",
		"x": "8.43243",
		"ID": "881"
	},
	"Riom-Parsonz": {
		"y": "46.58258",
		"population": "301",
		"x": "9.54746",
		"ID": "1414"
	},
	"Munsingen": {
		"y": "46.87298",
		"population": "11632",
		"x": "7.561",
		"ID": "481"
	},
	"Courtelary": {
		"y": "47.17153",
		"population": "1346",
		"x": "7.08278",
		"ID": "271"
	},
	"Onex": {
		"y": "46.18396",
		"population": "17978",
		"x": "6.10237",
		"ID": "11"
	},
	"Schleinikon": {
		"y": "47.49747",
		"population": "712",
		"x": "8.39748",
		"ID": "882"
	},
	"Magden": {
		"y": "47.52868",
		"population": "3916",
		"x": "7.81128",
		"ID": "626"
	},
	"Calanca": {
		"y": "46.26623",
		"population": "185",
		"x": "9.14886",
		"ID": "1258"
	},
	"Mundaun": {
		"y": "46.74264",
		"population": "317",
		"x": "9.16047",
		"ID": "1267"
	},
	"Reutigen": {
		"y": "46.69363",
		"population": "985",
		"x": "7.62102",
		"ID": "510"
	},
	"Ruegsau": {
		"y": "47.0381",
		"population": "3150",
		"x": "7.69096",
		"ID": "550"
	},
	"Ormont-Dessus": {
		"y": "46.34693",
		"population": "1457",
		"x": "7.16285",
		"ID": "288"
	},
	"Tschappina": {
		"y": "46.6869",
		"population": "125",
		"x": "9.38344",
		"ID": "1343"
	},
	"St. Margrethen": {
		"y": "47.45253",
		"population": "5692",
		"x": "9.63741",
		"ID": "1427"
	},
	"Marstetten": {
		"y": "47.59252",
		"population": "2740",
		"x": "9.06851",
		"ID": "1221"
	},
	"Samnaun": {
		"y": "46.94373",
		"population": "771",
		"x": "10.36058",
		"ID": "1577"
	},
	"Eschenz": {
		"y": "47.64793",
		"population": "1704",
		"x": "8.87472",
		"ID": "1113"
	},
	"Mosnang": {
		"y": "47.36252",
		"population": "2750",
		"x": "9.04296",
		"ID": "1216"
	},
	"Egolzwil": {
		"y": "47.18411",
		"population": "1406",
		"x": "8.00318",
		"ID": "715"
	},
	"Hochfelden": {
		"y": "47.52843",
		"population": "1978",
		"x": "8.50895",
		"ID": "911"
	},
	"Corban": {
		"y": "47.34638",
		"population": "461",
		"x": "7.47697",
		"ID": "459"
	},
	"Estavayer-le-Lac": {
		"y": "46.84876",
		"population": "6089",
		"x": "6.8465",
		"ID": "150"
	},
	"Sufers": {
		"y": "46.57091",
		"population": "125",
		"x": "9.3668",
		"ID": "1341"
	},
	"Holstein": {
		"y": "47.42512",
		"population": "2391",
		"x": "7.77136",
		"ID": "591"
	},
	"Alterswil": {
		"y": "46.79587",
		"population": "2019",
		"x": "7.25877",
		"ID": "358"
	},
	"Dotzigen": {
		"y": "47.12167",
		"population": "1452",
		"x": "7.34558",
		"ID": "394"
	},
	"Horriwil": {
		"y": "47.1823",
		"population": "859",
		"x": "7.62185",
		"ID": "520"
	},
	"Dardagny": {
		"y": "46.19564",
		"population": "1506",
		"x": "5.99497",
		"ID": "3"
	},
	"Lommiswil": {
		"y": "47.22365",
		"population": "1471",
		"x": "7.47139",
		"ID": "456"
	},
	"Belfaux": {
		"y": "46.82171",
		"population": "3181",
		"x": "7.10674",
		"ID": "265"
	},
	"Aegerten": {
		"y": "47.12115",
		"population": "1851",
		"x": "7.29164",
		"ID": "364"
	},
	"Ursenbach": {
		"y": "47.13696",
		"population": "894",
		"x": "7.77193",
		"ID": "586"
	},
	"Mauraz": {
		"y": "46.60582",
		"population": "49",
		"x": "6.42108",
		"ID": "60"
	},
	"Le Locle": {
		"y": "47.05953",
		"population": "10234",
		"x": "6.75228",
		"ID": "133"
	},
	"Plasselb": {
		"y": "46.73488",
		"population": "1000",
		"x": "7.25119",
		"ID": "327"
	},
	"Mutten": {
		"y": "46.67812",
		"population": "69",
		"x": "9.49996",
		"ID": "1392"
	},
	"Treycovagnes": {
		"y": "46.77387",
		"population": "463",
		"x": "6.61244",
		"ID": "95"
	},
	"Senarclens": {
		"y": "46.59786",
		"population": "432",
		"x": "6.48537",
		"ID": "70"
	},
	"Rumikon": {
		"y": "47.56558",
		"population": "291",
		"x": "8.3754",
		"ID": "883"
	},
	"Rothenthurm": {
		"y": "47.1042",
		"population": "2289",
		"x": "8.67585",
		"ID": "1001"
	},
	"Evilard": {
		"y": "47.14969",
		"population": "2512",
		"x": "7.23755",
		"ID": "335"
	},
	"Dietlikon": {
		"y": "47.41827",
		"population": "7547",
		"x": "8.6188",
		"ID": "974"
	},
	"Montalchez": {
		"y": "46.89885",
		"population": "243",
		"x": "6.74331",
		"ID": "130"
	},
	"Trasadingen": {
		"y": "47.66862",
		"population": "591",
		"x": "8.42995",
		"ID": "884"
	},
	"Dittingen": {
		"y": "47.44196",
		"population": "718",
		"x": "7.49619",
		"ID": "461"
	},
	"Forel (Lavaux)": {
		"y": "46.55",
		"population": "2083",
		"x": "6.81667",
		"ID": "144"
	},
	"Solothurn": {
		"y": "47.20791",
		"population": "16274",
		"x": "7.53714",
		"ID": "488"
	},
	"Gland": {
		"y": "46.42082",
		"population": "12698",
		"x": "6.2701",
		"ID": "42"
	},
	"Frauenkappelen": {
		"y": "46.95425",
		"population": "1192",
		"x": "7.33835",
		"ID": "391"
	},
	"Clavaleyres": {
		"y": "46.8991",
		"population": "49",
		"x": "7.09282",
		"ID": "266"
	},
	"Urdorf": {
		"y": "47.38507",
		"population": "9541",
		"x": "8.42581",
		"ID": "880"
	},
	"Sargans": {
		"y": "47.04896",
		"population": "5933",
		"x": "9.44103",
		"ID": "1374"
	},
	"Sembrancher": {
		"y": "46.07752",
		"population": "972",
		"x": "7.15279",
		"ID": "283"
	},
	"Diemerswil": {
		"y": "47.02009",
		"population": "202",
		"x": "7.42051",
		"ID": "422"
	},
	"Oberdorf (BL)": {
		"y": "47.39308",
		"population": "2363",
		"x": "7.75122",
		"ID": "591"
	},
	"Bioggio": {
		"y": "46.01961",
		"population": "2578",
		"x": "8.91438",
		"ID": "1118"
	},
	"Genolier": {
		"y": "46.43537",
		"population": "1909",
		"x": "6.21809",
		"ID": "35"
	},
	"Ersigen": {
		"y": "47.09368",
		"population": "1667",
		"x": "7.59507",
		"ID": "518"
	},
	"Wetzikon (ZH)": {
		"y": "47.3264",
		"population": "23985",
		"x": "8.79779",
		"ID": "1073"
	},
	"Wassen": {
		"y": "46.70651",
		"population": "403",
		"x": "8.59881",
		"ID": "960"
	},
	"Munchenwiler": {
		"y": "46.91109",
		"population": "480",
		"x": "7.1255",
		"ID": "299"
	},
	"Toffen": {
		"y": "46.86031",
		"population": "2497",
		"x": "7.49216",
		"ID": "449"
	},
	"San Vittore": {
		"y": "46.23709",
		"population": "757",
		"x": "9.10684",
		"ID": "1227"
	},
	"Seltisberg": {
		"y": "47.45947",
		"population": "1308",
		"x": "7.71729",
		"ID": "592"
	},
	"Sachseln": {
		"y": "46.86718",
		"population": "5018",
		"x": "8.23344",
		"ID": "794"
	},
	"Oberschrot": {
		"y": "46.74126",
		"population": "1166",
		"x": "7.28149",
		"ID": "357"
	},
	"Menznau": {
		"y": "47.08364",
		"population": "2838",
		"x": "8.03971",
		"ID": "713"
	},
	"Muhlethurnen": {
		"y": "46.81345",
		"population": "1377",
		"x": "7.50881",
		"ID": "480"
	},
	"Delley-Portalban": {
		"y": "46.91854",
		"population": "1052",
		"x": "6.95577",
		"ID": "202"
	},
	"Coppet": {
		"y": "46.31682",
		"population": "3102",
		"x": "6.19114",
		"ID": "23"
	},
	"Ogens": {
		"y": "46.70844",
		"population": "283",
		"x": "6.72448",
		"ID": "126"
	},
	"Billens-Hennens": {
		"y": "46.68532",
		"population": "673",
		"x": "6.88669",
		"ID": "170"
	},
	"Hergiswil (NW)": {
		"y": "46.98429",
		"population": "5584",
		"x": "8.30944",
		"ID": "846"
	},
	"Grafschaft": {
		"y": "46.46421",
		"population": "194",
		"x": "8.20553",
		"ID": "786"
	},
	"Lumino": {
		"y": "46.2302",
		"population": "1413",
		"x": "9.0642",
		"ID": "1227"
	},
	"Bogis-Bossey": {
		"y": "46.35374",
		"population": "887",
		"x": "6.16603",
		"ID": "24"
	},
	"Affoltern am Albis": {
		"y": "47.27743",
		"population": "11494",
		"x": "8.45128",
		"ID": "906"
	},
	"Vallorbe": {
		"y": "46.71256",
		"population": "3636",
		"x": "6.37894",
		"ID": "54"
	},
	"Belmont-sur-Yverdon": {
		"y": "46.74184",
		"population": "369",
		"x": "6.62467",
		"ID": "95"
	},
	"Seelisberg": {
		"y": "46.97302",
		"population": "634",
		"x": "8.58689",
		"ID": "965"
	},
	"Fey": {
		"y": "46.67383",
		"population": "636",
		"x": "6.68027",
		"ID": "106"
	},
	"Lufingen": {
		"y": "47.49108",
		"population": "2057",
		"x": "8.59428",
		"ID": "975"
	},
	"Interlaken": {
		"y": "46.68387",
		"population": "5571",
		"x": "7.86638",
		"ID": "643"
	},
	"Lyss": {
		"y": "47.0741",
		"population": "14171",
		"x": "7.30655",
		"ID": "363"
	},
	"Safenwil": {
		"y": "47.3214",
		"population": "3660",
		"x": "7.98122",
		"ID": "717"
	},
	"Menzingen": {
		"y": "47.17764",
		"population": "4158",
		"x": "8.59215",
		"ID": "969"
	},
	"Rupperswil": {
		"y": "47.40131",
		"population": "5109",
		"x": "8.12877",
		"ID": "778"
	},
	"Romerswil": {
		"y": "47.16813",
		"population": "1689",
		"x": "8.24643",
		"ID": "800"
	},
	"Balm bei Gunsberg": {
		"y": "47.25311",
		"population": "194",
		"x": "7.55825",
		"ID": "488"
	},
	"Kandergrund": {
		"y": "46.56212",
		"population": "773",
		"x": "7.659",
		"ID": "541"
	},
	"Chateau-d'Oex": {
		"y": "46.47455",
		"population": "3318",
		"x": "7.13155",
		"ID": "258"
	},
	"Arzier-Le Muids": {
		"y": "46.45962",
		"population": "2538",
		"x": "6.20813",
		"ID": "26"
	},
	"Monteceneri": {
		"y": "46.11255",
		"population": "4611",
		"x": "8.92112",
		"ID": "1120"
	},
	"Fechy": {
		"y": "46.47636",
		"population": "853",
		"x": "6.37397",
		"ID": "50"
	},
	"Boswil": {
		"y": "47.30381",
		"population": "2754",
		"x": "8.30881",
		"ID": "828"
	},
	"Rue": {
		"y": "46.61916",
		"population": "1466",
		"x": "6.82225",
		"ID": "146"
	},
	"Santa Maria in Calanca": {
		"y": "46.26623",
		"population": "101",
		"x": "9.14886",
		"ID": "1258"
	},
	"Sarnen": {
		"y": "46.89611",
		"population": "10072",
		"x": "8.24531",
		"ID": "820"
	},
	"Port-Valais": {
		"y": "46.21959",
		"population": "3362",
		"x": "7.32676",
		"ID": "377"
	},
	"Wallenried": {
		"y": "46.87361",
		"population": "443",
		"x": "7.11577",
		"ID": "266"
	},
	"Schwarzhausern": {
		"y": "47.25173",
		"population": "494",
		"x": "7.76552",
		"ID": "588"
	},
	"Giornico": {
		"y": "46.40141",
		"population": "869",
		"x": "8.87369",
		"ID": "1089"
	},
	"Chene-Bougeries": {
		"y": "46.19843",
		"population": "10537",
		"x": "6.18642",
		"ID": "21"
	},
	"Jenins": {
		"y": "47.00149",
		"population": "903",
		"x": "9.55657",
		"ID": "1398"
	},
	"Bonstetten": {
		"y": "47.31665",
		"population": "5315",
		"x": "8.46625",
		"ID": "907"
	},
	"Langrickenbach": {
		"y": "47.59353",
		"population": "1265",
		"x": "9.24727",
		"ID": "1312"
	},
	"Les Breuleux": {
		"y": "47.21099",
		"population": "1506",
		"x": "7.00792",
		"ID": "240"
	},
	"Airolo": {
		"y": "46.52855",
		"population": "1562",
		"x": "8.61189",
		"ID": "957"
	},
	"Chessel": {
		"y": "46.3496",
		"population": "391",
		"x": "6.89696",
		"ID": "163"
	},
	"Falera": {
		"y": "46.8015",
		"population": "613",
		"x": "9.2302",
		"ID": "1297"
	},
	"Alto Malcantone": {
		"y": "46.05425",
		"population": "1407",
		"x": "8.87645",
		"ID": "1119"
	},
	"Prez-vers-Noreaz": {
		"y": "46.78584",
		"population": "988",
		"x": "7.01456",
		"ID": "231"
	},
	"Zaziwil": {
		"y": "46.90196",
		"population": "1617",
		"x": "7.66185",
		"ID": "548"
	},
	"Mattstetten": {
		"y": "47.02817",
		"population": "557",
		"x": "7.51888",
		"ID": "484"
	},
	"Fluhli": {
		"y": "46.88391",
		"population": "1636",
		"x": "8.01558",
		"ID": "709"
	},
	"Brunegg": {
		"y": "47.42125",
		"population": "727",
		"x": "8.2158",
		"ID": "805"
	},
	"Altishofen": {
		"y": "47.19916",
		"population": "1541",
		"x": "7.96964",
		"ID": "715"
	},
	"Malans": {
		"y": "46.98096",
		"population": "2306",
		"x": "9.57527",
		"ID": "1422"
	},
	"Endingen": {
		"y": "47.53889",
		"population": "2512",
		"x": "8.29028",
		"ID": "833"
	},
	"Gingins": {
		"y": "46.4091",
		"population": "1217",
		"x": "6.17809",
		"ID": "25"
	},
	"Starrkirch-Wil": {
		"y": "47.34778",
		"population": "1688",
		"x": "7.92741",
		"ID": "687"
	},
	"Othmarsingen": {
		"y": "47.40149",
		"population": "2668",
		"x": "8.21852",
		"ID": "804"
	},
	"Marmorera": {
		"y": "46.49724",
		"population": "30",
		"x": "9.64352",
		"ID": "1433"
	},
	"Crissier": {
		"y": "46.55165",
		"population": "7382",
		"x": "6.57125",
		"ID": "80"
	},
	"Termen": {
		"y": "46.32688",
		"population": "889",
		"x": "8.02097",
		"ID": "698"
	},
	"Batterkinden": {
		"y": "47.13363",
		"population": "3147",
		"x": "7.54103",
		"ID": "486"
	},
	"Eriz": {
		"y": "46.78773",
		"population": "484",
		"x": "7.77102",
		"ID": "579"
	},
	"Ebikon": {
		"y": "47.07937",
		"population": "12934",
		"x": "8.34041",
		"ID": "848"
	},
	"Lauterbrunnen": {
		"y": "46.59568",
		"population": "2408",
		"x": "7.90765",
		"ID": "673"
	},
	"Wohlen (AG)": {
		"y": "47.35236",
		"population": "15379",
		"x": "8.27877",
		"ID": "829"
	},
	"Birr": {
		"y": "47.43587",
		"population": "4359",
		"x": "8.20801",
		"ID": "805"
	},
	"Essertines-sur-Yverdon": {
		"y": "46.71767",
		"population": "944",
		"x": "6.6447",
		"ID": "94"
	},
	"Affoltern im Emmental": {
		"y": "47.06529",
		"population": "1132",
		"x": "7.7347",
		"ID": "584"
	},
	"Thurnen": {
		"y": "47.45478",
		"population": "1370",
		"x": "7.82785",
		"ID": "624"
	},
	"Wyssachen": {
		"y": "47.07851",
		"population": "1144",
		"x": "7.82922",
		"ID": "617"
	},
	"Ehrendingen": {
		"y": "47.5025",
		"population": "4707",
		"x": "8.34729",
		"ID": "856"
	},
	"Luzein": {
		"y": "46.91957",
		"population": "1202",
		"x": "9.7608",
		"ID": "1473"
	},
	"Stallikon": {
		"y": "47.32582",
		"population": "3442",
		"x": "8.48965",
		"ID": "907"
	},
	"Pieterlen": {
		"y": "47.17501",
		"population": "3969",
		"x": "7.33791",
		"ID": "395"
	},
	"Dorenaz": {
		"y": "46.14892",
		"population": "859",
		"x": "7.04292",
		"ID": "219"
	},
	"Greppen": {
		"y": "47.05514",
		"population": "1028",
		"x": "8.43034",
		"ID": "873"
	},
	"Laufen": {
		"y": "47.42193",
		"population": "5484",
		"x": "7.49946",
		"ID": "460"
	},
	"Sins": {
		"y": "47.19216",
		"population": "4208",
		"x": "8.39578",
		"ID": "876"
	},
	"Neuenkirch": {
		"y": "47.09989",
		"population": "6568",
		"x": "8.20416",
		"ID": "799"
	},
	"Le Noirmont": {
		"y": "47.22567",
		"population": "1823",
		"x": "6.9573",
		"ID": "207"
	},
	"Iseltwald": {
		"y": "46.71076",
		"population": "416",
		"x": "7.96415",
		"ID": "675"
	},
	"Kaiserstuhl": {
		"y": "47.56839",
		"population": "390",
		"x": "8.418",
		"ID": "883"
	},
	"Pratteln": {
		"y": "47.52071",
		"population": "15664",
		"x": "7.69356",
		"ID": "560"
	},
	"Rodersdorf": {
		"y": "47.48221",
		"population": "1331",
		"x": "7.4576",
		"ID": "461"
	},
	"Gelterfingen": {
		"y": "46.84449",
		"population": "267",
		"x": "7.51564",
		"ID": "449"
	},
	"Chamoson": {
		"y": "46.20275",
		"population": "3547",
		"x": "7.22319",
		"ID": "317"
	},
	"Tramelan": {
		"y": "47.22393",
		"population": "4333",
		"x": "7.0995",
		"ID": "272"
	},
	"Luthern": {
		"y": "47.05753",
		"population": "1246",
		"x": "7.91692",
		"ID": "682"
	},
	"Trogen": {
		"y": "47.40782",
		"population": "1659",
		"x": "9.46498",
		"ID": "1381"
	},
	"Wolfwil": {
		"y": "47.26819",
		"population": "2041",
		"x": "7.78967",
		"ID": "621"
	},
	"Arth": {
		"y": "47.06337",
		"population": "11439",
		"x": "8.52349",
		"ID": "933"
	},
	"Fideris": {
		"y": "46.91518",
		"population": "589",
		"x": "9.7427",
		"ID": "1459"
	},
	"Wolfenschiessen": {
		"y": "46.90322",
		"population": "2124",
		"x": "8.39423",
		"ID": "870"
	},
	"Birmensdorf (ZH)": {
		"y": "47.35515",
		"population": "6186",
		"x": "8.44256",
		"ID": "879"
	},
	"Weiach": {
		"y": "47.55908",
		"population": "1368",
		"x": "8.43344",
		"ID": "883"
	},
	"Schattdorf": {
		"y": "46.8655",
		"population": "4928",
		"x": "8.65465",
		"ID": "997"
	},
	"Erlinsbach (AG)": {
		"y": "47.40523",
		"population": "3919",
		"x": "8.01515",
		"ID": "719"
	},
	"Roggliswil": {
		"y": "47.21353",
		"population": "648",
		"x": "7.88374",
		"ID": "653"
	},
	"Biere": {
		"y": "46.53761",
		"population": "1553",
		"x": "6.33362",
		"ID": "44"
	},
	"Saules (BE)": {
		"y": "47.24575",
		"population": "158",
		"x": "7.22179",
		"ID": "337"
	},
	"Berlingen": {
		"y": "47.67388",
		"population": "855",
		"x": "9.01969",
		"ID": "1186"
	},
	"Lyssach": {
		"y": "47.06445",
		"population": "1399",
		"x": "7.58228",
		"ID": "485"
	},
	"Roche (VD)": {
		"y": "46.36091",
		"population": "1524",
		"x": "6.93272",
		"ID": "191"
	},
	"Lachen": {
		"y": "47.19927",
		"population": "8357",
		"x": "8.85432",
		"ID": "1105"
	},
	"Schangnau": {
		"y": "46.82784",
		"population": "889",
		"x": "7.85987",
		"ID": "646"
	},
	"Oberhallau": {
		"y": "47.7071",
		"population": "436",
		"x": "8.47853",
		"ID": "914"
	},
	"Saint-Martin (VS)": {
		"y": "46.1727",
		"population": "843",
		"x": "7.44427",
		"ID": "406"
	},
	"Lauwil": {
		"y": "47.38773",
		"population": "323",
		"x": "7.6754",
		"ID": "557"
	},
	"Le Mont-sur-Lausanne": {
		"y": "46.55815",
		"population": "7150",
		"x": "6.63145",
		"ID": "91"
	},
	"Reverolle": {
		"y": "46.54276",
		"population": "357",
		"x": "6.44054",
		"ID": "58"
	},
	"Cremin": {
		"y": "46.72414",
		"population": "58",
		"x": "6.8425",
		"ID": "148"
	},
	"Boussens": {
		"y": "46.6035",
		"population": "960",
		"x": "6.58596",
		"ID": "81"
	},
	"Madulain": {
		"y": "46.58772",
		"population": "228",
		"x": "9.93949",
		"ID": "1509"
	},
	"Nods": {
		"y": "47.11371",
		"population": "738",
		"x": "7.08105",
		"ID": "270"
	},
	"Signy-Avenex": {
		"y": "46.39263",
		"population": "501",
		"x": "6.20417",
		"ID": "25"
	},
	"Val Mustair": {
		"y": "46.62683",
		"population": "1498",
		"x": "10.44624",
		"ID": "1581"
	},
	"Monthey": {
		"y": "46.25451",
		"population": "17321",
		"x": "6.95406",
		"ID": "189"
	},
	"Coeuve": {
		"y": "47.45289",
		"population": "708",
		"x": "7.09794",
		"ID": "277"
	},
	"Le Chenit": {
		"y": "46.60688",
		"population": "4594",
		"x": "6.23062",
		"ID": "38"
	},
	"Fisibach": {
		"y": "47.56389",
		"population": "439",
		"x": "8.40972",
		"ID": "883"
	},
	"Seewis im Prattigau": {
		"y": "46.99023",
		"population": "1385",
		"x": "9.63775",
		"ID": "1443"
	},
	"Walzenhausen": {
		"y": "47.44867",
		"population": "2025",
		"x": "9.60495",
		"ID": "1427"
	},
	"Hagendorf": {
		"y": "47.33436",
		"population": "4791",
		"x": "7.84192",
		"ID": "622"
	},
	"Haute-Ajoie": {
		"y": "47.38657",
		"population": "931",
		"x": "6.99551",
		"ID": "243"
	},
	"Gnosca": {
		"y": "46.23353",
		"population": "732",
		"x": "9.02218",
		"ID": "1195"
	},
	"Randa": {
		"y": "46.09413",
		"population": "444",
		"x": "7.85862",
		"ID": "632"
	},
	"Meienried": {
		"y": "47.13868",
		"population": "52",
		"x": "7.34137",
		"ID": "395"
	},
	"Mettmenstetten": {
		"y": "47.24529",
		"population": "4610",
		"x": "8.46347",
		"ID": "905"
	},
	"Aarburg": {
		"y": "47.32067",
		"population": "7580",
		"x": "7.89986",
		"ID": "655"
	},
	"Nuglar-St. Pantaleon": {
		"y": "47.46101",
		"population": "1469",
		"x": "7.69182",
		"ID": "558"
	},
	"Bozberg": {
		"y": "47.49549",
		"population": "1557",
		"x": "8.15143",
		"ID": "780"
	},
	"Einsiedeln": {
		"y": "47.12849",
		"population": "14782",
		"x": "8.74735",
		"ID": "1035"
	},
	"Cottens (FR)": {
		"y": "46.75224",
		"population": "1476",
		"x": "7.03127",
		"ID": "231"
	},
	"Koniz": {
		"y": "46.92436",
		"population": "39599",
		"x": "7.41457",
		"ID": "420"
	},
	"Remetschwil": {
		"y": "47.40832",
		"population": "2037",
		"x": "8.33192",
		"ID": "855"
	},
	"Trient": {
		"y": "46.05798",
		"population": "173",
		"x": "6.99395",
		"ID": "185"
	},
	"Buchs (SG)": {
		"y": "47.16743",
		"population": "12175",
		"x": "9.47794",
		"ID": "1377"
	},
	"Scherz": {
		"y": "47.44687",
		"population": "648",
		"x": "8.18419",
		"ID": "805"
	},
	"Fehren": {
		"y": "47.39652",
		"population": "605",
		"x": "7.57698",
		"ID": "491"
	},
	"Rothenbach im Emmental": {
		"y": "46.85425",
		"population": "1185",
		"x": "7.74251",
		"ID": "580"
	},
	"Courrendlin": {
		"y": "47.33853",
		"population": "2721",
		"x": "7.37243",
		"ID": "399"
	},
	"Volketswil": {
		"y": "47.39016",
		"population": "18349",
		"x": "8.69085",
		"ID": "1007"
	},
	"Les Clees": {
		"y": "46.73308",
		"population": "179",
		"x": "6.47141",
		"ID": "62"
	},
	"Leimbach (AG)": {
		"y": "47.27487",
		"population": "470",
		"x": "8.17005",
		"ID": "802"
	},
	"Jonen": {
		"y": "47.2974",
		"population": "2005",
		"x": "8.39337",
		"ID": "878"
	},
	"Commugny": {
		"y": "46.32105",
		"population": "2850",
		"x": "6.17119",
		"ID": "23"
	},
	"Jens": {
		"y": "47.09632",
		"population": "672",
		"x": "7.26358",
		"ID": "363"
	},
	"Seeberg": {
		"y": "47.15585",
		"population": "1393",
		"x": "7.66567",
		"ID": "553"
	},
	"St. Ursen": {
		"y": "46.7909",
		"population": "1264",
		"x": "7.22011",
		"ID": "328"
	},
	"Neuenhof": {
		"y": "47.4526",
		"population": "8705",
		"x": "8.32577",
		"ID": "855"
	},
	"Schiers": {
		"y": "46.96973",
		"population": "2605",
		"x": "9.6872",
		"ID": "1460"
	},
	"Sevaz": {
		"y": "46.83985",
		"population": "270",
		"x": "6.87703",
		"ID": "173"
	},
	"Stettlen": {
		"y": "46.95835",
		"population": "3129",
		"x": "7.52508",
		"ID": "483"
	},
	"Orges": {
		"y": "46.80927",
		"population": "275",
		"x": "6.58348",
		"ID": "84"
	},
	"Tauffelen": {
		"y": "47.06524",
		"population": "2719",
		"x": "7.19704",
		"ID": "333"
	},
	"Kallnach": {
		"y": "47.02032",
		"population": "1877",
		"x": "7.23545",
		"ID": "332"
	},
	"Niedergosgen": {
		"y": "47.37217",
		"population": "3696",
		"x": "7.99122",
		"ID": "718"
	},
	"Tuggen": {
		"y": "47.20291",
		"population": "3186",
		"x": "8.94896",
		"ID": "1141"
	},
	"Flurlingen": {
		"y": "47.6839",
		"population": "1428",
		"x": "8.62995",
		"ID": "979"
	},
	"Eichberg": {
		"y": "47.34374",
		"population": "1516",
		"x": "9.5314",
		"ID": "1405"
	},
	"Cressier (NE)": {
		"y": "47.05154",
		"population": "1876",
		"x": "7.03731",
		"ID": "237"
	},
	"Bottighofen": {
		"y": "47.63643",
		"population": "2154",
		"x": "9.20882",
		"ID": "1285"
	},
	"Massagno": {
		"y": "46.01257",
		"population": "6084",
		"x": "8.94354",
		"ID": "1154"
	},
	"Biglen": {
		"y": "46.92629",
		"population": "1722",
		"x": "7.62508",
		"ID": "515"
	},
	"Zwischbergen": {
		"y": "46.16366",
		"population": "84",
		"x": "8.11575",
		"ID": "754"
	},
	"Bauen": {
		"y": "46.92891",
		"population": "158",
		"x": "8.57277",
		"ID": "964"
	},
	"Nesslau": {
		"y": "47.2228",
		"population": "3516",
		"x": "9.20124",
		"ID": "1277"
	},
	"Lostorf": {
		"y": "47.38445",
		"population": "3876",
		"x": "7.94849",
		"ID": "688"
	},
	"Tannay": {
		"y": "46.30876",
		"population": "1586",
		"x": "6.17732",
		"ID": "23"
	},
	"Root": {
		"y": "47.11458",
		"population": "4665",
		"x": "8.39021",
		"ID": "874"
	},
	"Ependes (FR)": {
		"y": "46.75368",
		"population": "1103",
		"x": "7.14609",
		"ID": "296"
	},
	"Walterswil (BE)": {
		"y": "47.1122",
		"population": "512",
		"x": "7.77798",
		"ID": "585"
	},
	"Zunzgen": {
		"y": "47.44925",
		"population": "2464",
		"x": "7.80789",
		"ID": "624"
	},
	"Bavois": {
		"y": "46.68403",
		"population": "941",
		"x": "6.5671",
		"ID": "82"
	},
	"Liestal": {
		"y": "47.48455",
		"population": "13795",
		"x": "7.73446",
		"ID": "592"
	},
	"Leukerbad": {
		"y": "46.37943",
		"population": "1459",
		"x": "7.62687",
		"ID": "504"
	},
	"Saint-Prex": {
		"y": "46.47963",
		"population": "5528",
		"x": "6.45992",
		"ID": "57"
	},
	"Stetten (AG)": {
		"y": "47.40166",
		"population": "2132",
		"x": "8.30189",
		"ID": "830"
	},
	"Ellikon an der Thur": {
		"y": "47.56298",
		"population": "879",
		"x": "8.82331",
		"ID": "1077"
	},
	"Bardonnex": {
		"y": "46.149",
		"population": "2197",
		"x": "6.11833",
		"ID": "10"
	},
	"Plateau de Diesse": {
		"y": "47.11314",
		"population": "1954",
		"x": "7.11677",
		"ID": "270"
	},
	"Felsberg": {
		"y": "46.84424",
		"population": "2455",
		"x": "9.47684",
		"ID": "1395"
	},
	"Riaz": {
		"y": "46.64224",
		"population": "2370",
		"x": "7.06183",
		"ID": "261"
	},
	"Bunzen": {
		"y": "47.32004",
		"population": "1028",
		"x": "8.32253",
		"ID": "853"
	},
	"Lichtensteig": {
		"y": "47.32381",
		"population": "1883",
		"x": "9.08758",
		"ID": "1216"
	},
	"Schupfen": {
		"y": "47.03661",
		"population": "3679",
		"x": "7.37723",
		"ID": "393"
	},
	"Corcelles-le-Jorat": {
		"y": "46.6338",
		"population": "421",
		"x": "6.72625",
		"ID": "105"
	},
	"Lugano": {
		"y": "46.01008",
		"population": "62535",
		"x": "8.96004",
		"ID": "1154"
	},
	"Gams": {
		"y": "47.20429",
		"population": "3267",
		"x": "9.44172",
		"ID": "1377"
	},
	"Kerns": {
		"y": "46.90134",
		"population": "5917",
		"x": "8.27528",
		"ID": "820"
	},
	"Reute (AR)": {
		"y": "47.4201",
		"population": "689",
		"x": "9.57313",
		"ID": "1406"
	},
	"Rossens (FR)": {
		"y": "46.72067",
		"population": "1328",
		"x": "7.10369",
		"ID": "263"
	},
	"Illnau-Effretikon": {
		"y": "47.42293",
		"population": "16141",
		"x": "8.71605",
		"ID": "1041"
	},
	"Raron": {
		"y": "46.3",
		"population": "1880",
		"x": "7.8",
		"ID": "602"
	},
	"Boulens": {
		"y": "46.68225",
		"population": "324",
		"x": "6.71909",
		"ID": "106"
	},
	"Epsach": {
		"y": "47.07047",
		"population": "321",
		"x": "7.22173",
		"ID": "333"
	},
	"Chavannes-sur-Moudon": {
		"y": "46.65874",
		"population": "222",
		"x": "6.80964",
		"ID": "147"
	},
	"Uttwil": {
		"y": "47.5844",
		"population": "1817",
		"x": "9.34101",
		"ID": "1338"
	},
	"Ollon": {
		"y": "46.29524",
		"population": "6786",
		"x": "6.99314",
		"ID": "222"
	},
	"Frauenfeld": {
		"y": "47.55776",
		"population": "24301",
		"x": "8.89893",
		"ID": "1112"
	},
	"Brusino Arsizio": {
		"y": "45.93026",
		"population": "480",
		"x": "8.93875",
		"ID": "1152"
	},
	"Les Planchettes": {
		"y": "47.10616",
		"population": "218",
		"x": "6.77025",
		"ID": "134"
	},
	"Zug": {
		"y": "47.17242",
		"population": "28571",
		"x": "8.51745",
		"ID": "936"
	},
	"Gais": {
		"y": "47.3615",
		"population": "3026",
		"x": "9.45356",
		"ID": "1380"
	},
	"Oberrohrdorf": {
		"y": "47.42513",
		"population": "4006",
		"x": "8.32051",
		"ID": "855"
	},
	"Biel-Benken": {
		"y": "47.50781",
		"population": "3397",
		"x": "7.52581",
		"ID": "493"
	},
	"Munchenbuchsee": {
		"y": "47.02175",
		"population": "9816",
		"x": "7.45036",
		"ID": "422"
	},
	"Chapelle (Glane)": {
		"y": "46.58873",
		"population": "259",
		"x": "6.83718",
		"ID": "145"
	},
	"Sobrio": {
		"y": "46.3988",
		"population": "77",
		"x": "8.90064",
		"ID": "1126"
	},
	"Rubigen": {
		"y": "46.89868",
		"population": "2909",
		"x": "7.5446",
		"ID": "482"
	},
	"Burgdorf": {
		"y": "47.05901",
		"population": "15918",
		"x": "7.62786",
		"ID": "517"
	},
	"Veysonnaz": {
		"y": "46.19521",
		"population": "590",
		"x": "7.33556",
		"ID": "377"
	},
	"Hofstetten (ZH)": {
		"y": "47.47242",
		"population": "475",
		"x": "8.85401",
		"ID": "1110"
	},
	"Birwinken": {
		"y": "47.57648",
		"population": "1347",
		"x": "9.21467",
		"ID": "1283"
	},
	"Arlesheim": {
		"y": "47.51668",
		"population": "9042",
		"x": "7.58733",
		"ID": "526"
	},
	"Affeltrangen": {
		"y": "47.52581",
		"population": "2476",
		"x": "9.03307",
		"ID": "1183"
	},
	"Schattenhalb": {
		"y": "46.71903",
		"population": "574",
		"x": "8.19074",
		"ID": "791"
	},
	"Adlikon": {
		"y": "47.5823",
		"population": "662",
		"x": "8.69148",
		"ID": "1010"
	},
	"Eggerberg": {
		"y": "46.3068",
		"population": "344",
		"x": "7.87625",
		"ID": "636"
	},
	"Moriken-Wildegg": {
		"y": "47.41556",
		"population": "4351",
		"x": "8.18446",
		"ID": "805"
	},
	"Unterkulm": {
		"y": "47.30998",
		"population": "2917",
		"x": "8.11371",
		"ID": "776"
	},
	"Trimmis": {
		"y": "46.89907",
		"population": "3174",
		"x": "9.56236",
		"ID": "1421"
	},
	"Geltwil": {
		"y": "47.24901",
		"population": "201",
		"x": "8.32598",
		"ID": "851"
	},
	"Siglistorf": {
		"y": "47.54533",
		"population": "613",
		"x": "8.38064",
		"ID": "857"
	},
	"Muhlau": {
		"y": "47.23471",
		"population": "1058",
		"x": "8.38887",
		"ID": "877"
	},
	"Rechthalten": {
		"y": "46.76766",
		"population": "1056",
		"x": "7.24028",
		"ID": "328"
	},
	"Muhen": {
		"y": "47.33671",
		"population": "3772",
		"x": "8.05408",
		"ID": "747"
	},
	"Buochs": {
		"y": "46.97398",
		"population": "5373",
		"x": "8.42279",
		"ID": "872"
	},
	"Oberdorf (SO)": {
		"y": "47.2305",
		"population": "1640",
		"x": "7.50637",
		"ID": "488"
	},
	"Ruti bei Lyssach": {
		"y": "47.05446",
		"population": "169",
		"x": "7.58246",
		"ID": "517"
	},
	"Haut-Intyamon": {
		"y": "46.49869",
		"population": "1493",
		"x": "7.03408",
		"ID": "226"
	},
	"Kirchlindach": {
		"y": "46.99965",
		"population": "2830",
		"x": "7.41735",
		"ID": "422"
	},
	"Silvaplana": {
		"y": "46.4581",
		"population": "1084",
		"x": "9.79514",
		"ID": "1479"
	},
	"Ferden": {
		"y": "46.39359",
		"population": "244",
		"x": "7.75921",
		"ID": "571"
	},
	"Romont (BE)": {
		"y": "47.18865",
		"population": "195",
		"x": "7.34063",
		"ID": "396"
	},
	"Scharans": {
		"y": "46.71814",
		"population": "811",
		"x": "9.45903",
		"ID": "1368"
	},
	"Ursy": {
		"y": "46.63353",
		"population": "2906",
		"x": "6.8371",
		"ID": "146"
	},
	"Silenen": {
		"y": "46.77693",
		"population": "2077",
		"x": "8.75168",
		"ID": "1062"
	},
	"Schlatt (ZH)": {
		"y": "47.47067",
		"population": "737",
		"x": "8.82705",
		"ID": "1075"
	},
	"Diepflingen": {
		"y": "47.44443",
		"population": "715",
		"x": "7.8364",
		"ID": "624"
	},
	"Stein (AG)": {
		"y": "47.54517",
		"population": "3046",
		"x": "7.95275",
		"ID": "691"
	},
	"Albinen": {
		"y": "46.34071",
		"population": "241",
		"x": "7.63318",
		"ID": "503"
	},
	"Zernez": {
		"y": "46.70087",
		"population": "1547",
		"x": "10.09461",
		"ID": "1538"
	},
	"Lostallo": {
		"y": "46.31301",
		"population": "761",
		"x": "9.19663",
		"ID": "1259"
	},
	"Roggenburg": {
		"y": "47.43215",
		"population": "274",
		"x": "7.34282",
		"ID": "400"
	},
	"Niederbuchsiten": {
		"y": "47.29646",
		"population": "1113",
		"x": "7.7718",
		"ID": "589"
	},
	"Villarepos": {
		"y": "46.88343",
		"population": "611",
		"x": "7.07322",
		"ID": "266"
	},
	"Hilterfingen": {
		"y": "46.73521",
		"population": "3963",
		"x": "7.66185",
		"ID": "544"
	},
	"Zwingen": {
		"y": "47.43825",
		"population": "2248",
		"x": "7.53027",
		"ID": "492"
	},
	"Biel/Bienne": {
		"y": "47.13713",
		"population": "53159",
		"x": "7.24608",
		"ID": "335"
	},
	"Aadorf": {
		"y": "47.49204",
		"population": "8706",
		"x": "8.90099",
		"ID": "1110"
	},
	"Herbligen": {
		"y": "46.8299",
		"population": "583",
		"x": "7.60632",
		"ID": "513"
	},
	"Gravesano": {
		"y": "46.04208",
		"population": "1255",
		"x": "8.91832",
		"ID": "1119"
	},
	"Buchillon": {
		"y": "46.47062",
		"population": "623",
		"x": "6.42271",
		"ID": "57"
	},
	"Hospental": {
		"y": "46.61956",
		"population": "194",
		"x": "8.56977",
		"ID": "958"
	},
	"Lupfig": {
		"y": "47.44069",
		"population": "2280",
		"x": "8.20378",
		"ID": "805"
	},
	"Anniviers": {
		"y": "46.10137",
		"population": "2698",
		"x": "7.71597",
		"ID": "566"
	},
	"Brienz (BE)": {
		"y": "46.7545",
		"population": "3018",
		"x": "8.03847",
		"ID": "736"
	},
	"Worb": {
		"y": "46.92984",
		"population": "11229",
		"x": "7.56306",
		"ID": "482"
	},
	"Eiken": {
		"y": "47.53394",
		"population": "2159",
		"x": "7.98883",
		"ID": "721"
	},
	"Bubendorf": {
		"y": "47.44586",
		"population": "4332",
		"x": "7.73759",
		"ID": "592"
	},
	"Elfingen": {
		"y": "47.50998",
		"population": "276",
		"x": "8.10219",
		"ID": "750"
	},
	"Tasch": {
		"y": "46.06838",
		"population": "1216",
		"x": "7.77766",
		"ID": "598"
	},
	"Riemenstalden": {
		"y": "46.94712",
		"population": "89",
		"x": "8.66525",
		"ID": "998"
	},
	"Aeugst am Albis": {
		"y": "47.27541",
		"population": "1970",
		"x": "8.4897",
		"ID": "906"
	},
	"Zollikofen": {
		"y": "46.99905",
		"population": "9961",
		"x": "7.45809",
		"ID": "452"
	},
	"St. Antonien": {
		"y": "46.96983",
		"population": "328",
		"x": "9.81234",
		"ID": "1489"
	},
	"Neuheim": {
		"y": "47.19946",
		"population": "2154",
		"x": "8.58268",
		"ID": "970"
	},
	"Greng": {
		"y": "46.91337",
		"population": "177",
		"x": "7.09397",
		"ID": "266"
	},
	"Deisswil bei Munchenbuchsee": {
		"y": "47.03717",
		"population": "81",
		"x": "7.45337",
		"ID": "453"
	},
	"Bosco/Gurin": {
		"y": "46.31696",
		"population": "51",
		"x": "8.49123",
		"ID": "919"
	},
	"Beggingen": {
		"y": "47.76737",
		"population": "476",
		"x": "8.53535",
		"ID": "947"
	},
	"Biberist": {
		"y": "47.18009",
		"population": "8050",
		"x": "7.56246",
		"ID": "487"
	},
	"Granges (Veveyse)": {
		"y": "46.52561",
		"population": "828",
		"x": "6.82659",
		"ID": "144"
	},
	"Chexbres": {
		"y": "46.48208",
		"population": "2137",
		"x": "6.77805",
		"ID": "122"
	},
	"Zermatt": {
		"y": "46.01998",
		"population": "5742",
		"x": "7.74863",
		"ID": "564"
	},
	"Bern": {
		"y": "46.94809",
		"population": "126385",
		"x": "7.44744",
		"ID": "451"
	},
	"Montet (Glane)": {
		"y": "46.64633",
		"population": "390",
		"x": "6.81175",
		"ID": "146"
	},
	"Val-de-Travers": {
		"y": "46.94018",
		"population": "10671",
		"x": "6.67595",
		"ID": "111"
	},
	"Le Paquier (FR)": {
		"y": "46.59477",
		"population": "1122",
		"x": "7.05328",
		"ID": "228"
	},
	"Herznach": {
		"y": "47.47148",
		"population": "1414",
		"x": "8.04751",
		"ID": "720"
	},
	"Rutschelen": {
		"y": "47.17322",
		"population": "557",
		"x": "7.77109",
		"ID": "586"
	},
	"Signau": {
		"y": "46.9315",
		"population": "2635",
		"x": "7.78725",
		"ID": "614"
	},
	"Carouge (GE)": {
		"y": "46.18096",
		"population": "19618",
		"x": "6.13921",
		"ID": "11"
	},
	"Lommis": {
		"y": "47.51729",
		"population": "1217",
		"x": "8.99669",
		"ID": "1183"
	},
	"Conthey": {
		"y": "46.2237",
		"population": "8373",
		"x": "7.30283",
		"ID": "347"
	},
	"Fetigny": {
		"y": "46.79819",
		"population": "957",
		"x": "6.9117",
		"ID": "172"
	},
	"Gerzensee": {
		"y": "46.84023",
		"population": "1148",
		"x": "7.54503",
		"ID": "481"
	},
	"Meggen": {
		"y": "47.05143",
		"population": "6749",
		"x": "8.37221",
		"ID": "873"
	},
	"Lauperswil": {
		"y": "46.96564",
		"population": "2630",
		"x": "7.74214",
		"ID": "582"
	},
	"Busserach": {
		"y": "47.39464",
		"population": "2188",
		"x": "7.54116",
		"ID": "491"
	},
	"Melide": {
		"y": "45.95455",
		"population": "1783",
		"x": "8.94725",
		"ID": "1153"
	},
	"Mollens (VD)": {
		"y": "46.5776",
		"population": "295",
		"x": "6.3632",
		"ID": "52"
	},
	"Ruswil": {
		"y": "47.08425",
		"population": "6720",
		"x": "8.12645",
		"ID": "772"
	},
	"Eysins": {
		"y": "46.3817",
		"population": "1501",
		"x": "6.20695",
		"ID": "24"
	},
	"Henniez": {
		"y": "46.74219",
		"population": "338",
		"x": "6.88696",
		"ID": "171"
	},
	"Saint-Aubin-Sauges": {
		"y": "46.89419",
		"population": "2471",
		"x": "6.77251",
		"ID": "130"
	},
	"Le Grand-Saconnex": {
		"y": "46.23188",
		"population": "11583",
		"x": "6.12091",
		"ID": "12"
	},
	"Monthal": {
		"y": "47.517",
		"population": "388",
		"x": "8.14035",
		"ID": "780"
	},
	"Wald (BE)": {
		"y": "46.8825",
		"population": "1168",
		"x": "7.45919",
		"ID": "450"
	},
	"Sursee": {
		"y": "47.14929",
		"population": "9399",
		"x": "8.12719",
		"ID": "773"
	},
	"Brione (Verzasca)": {
		"y": "46.29525",
		"population": "178",
		"x": "8.79173",
		"ID": "1053"
	},
	"Lechelles": {
		"y": "46.82896",
		"population": "796",
		"x": "7.01621",
		"ID": "232"
	},
	"Durnten": {
		"y": "47.27856",
		"population": "7299",
		"x": "8.84156",
		"ID": "1106"
	},
	"Dietwil": {
		"y": "47.14665",
		"population": "1275",
		"x": "8.39355",
		"ID": "875"
	},
	"Degersheim": {
		"y": "47.37429",
		"population": "3934",
		"x": "9.20019",
		"ID": "1280"
	},
	"Dachsen": {
		"y": "47.66515",
		"population": "1968",
		"x": "8.6179",
		"ID": "979"
	},
	"Kirchberg (BE)": {
		"y": "47.08538",
		"population": "5727",
		"x": "7.58288",
		"ID": "518"
	},
	"Cerentino": {
		"y": "46.30817",
		"population": "52",
		"x": "8.54526",
		"ID": "919"
	},
	"Bossonnens": {
		"y": "46.52471",
		"population": "1481",
		"x": "6.84952",
		"ID": "144"
	},
	"Honau": {
		"y": "47.13254",
		"population": "380",
		"x": "8.40811",
		"ID": "875"
	},
	"Niederosch": {
		"y": "47.11576",
		"population": "233",
		"x": "7.61587",
		"ID": "518"
	},
	"Bargen (BE)": {
		"y": "47.06015",
		"population": "988",
		"x": "7.2686",
		"ID": "363"
	},
	"Bas-Intyamon": {
		"y": "46.56102",
		"population": "1269",
		"x": "7.10616",
		"ID": "260"
	},
	"Lampenberg": {
		"y": "47.42559",
		"population": "486",
		"x": "7.75884",
		"ID": "591"
	},
	"Wahlen": {
		"y": "47.40226",
		"population": "1394",
		"x": "7.51511",
		"ID": "460"
	},
	"Andwil (SG)": {
		"y": "47.43855",
		"population": "1881",
		"x": "9.27436",
		"ID": "1309"
	},
	"Aeschi (SO)": {
		"y": "47.17977",
		"population": "1210",
		"x": "7.66138",
		"ID": "553"
	},
	"Rances": {
		"y": "46.76068",
		"population": "460",
		"x": "6.52966",
		"ID": "73"
	},
	"Riddes": {
		"y": "46.17276",
		"population": "2884",
		"x": "7.2236",
		"ID": "316"
	},
	"Les Genevez (JU)": {
		"y": "47.25552",
		"population": "507",
		"x": "7.12961",
		"ID": "273"
	},
	"Neyruz (FR)": {
		"y": "46.76868",
		"population": "2560",
		"x": "7.06827",
		"ID": "264"
	},
	"Thalheim an der Thur": {
		"y": "47.57822",
		"population": "900",
		"x": "8.7512",
		"ID": "1044"
	},
	"Givisiez": {
		"y": "46.81201",
		"population": "3020",
		"x": "7.12639",
		"ID": "297"
	},
	"Montreux": {
		"y": "46.43301",
		"population": "23558",
		"x": "6.91143",
		"ID": "165"
	},
	"Saanen": {
		"y": "46.48956",
		"population": "6802",
		"x": "7.25961",
		"ID": "352"
	},
	"Avusy": {
		"y": "46.14957",
		"population": "1418",
		"x": "6.00888",
		"ID": "2"
	},
	"Amlikon-Bissegg": {
		"y": "47.56257",
		"population": "1314",
		"x": "9.04784",
		"ID": "1220"
	},
	"Beurnevesin": {
		"y": "47.4925",
		"population": "126",
		"x": "7.13373",
		"ID": "310"
	},
	"Tobel-Tagerschen": {
		"y": "47.50914",
		"population": "1544",
		"x": "9.03209",
		"ID": "1183"
	},
	"Erlen": {
		"y": "47.54814",
		"population": "3561",
		"x": "9.23415",
		"ID": "1283"
	},
	"Chigny": {
		"y": "46.51971",
		"population": "331",
		"x": "6.47659",
		"ID": "58"
	},
	"Breitenbach": {
		"y": "47.40564",
		"population": "3689",
		"x": "7.54382",
		"ID": "491"
	},
	"Auswil": {
		"y": "47.13653",
		"population": "457",
		"x": "7.83525",
		"ID": "618"
	},
	"Eppenberg-Woschnau": {
		"y": "47.37998",
		"population": "310",
		"x": "8.0246",
		"ID": "718"
	},
	"Dottingen": {
		"y": "47.57091",
		"population": "3744",
		"x": "8.25846",
		"ID": "833"
	},
	"Tujetsch": {
		"y": "46.65046",
		"population": "1304",
		"x": "8.7323",
		"ID": "1026"
	},
	"Niederbipp": {
		"y": "47.26613",
		"population": "4487",
		"x": "7.69461",
		"ID": "555"
	},
	"Zumikon": {
		"y": "47.33158",
		"population": "5116",
		"x": "8.62271",
		"ID": "972"
	},
	"Tschiertschen-Praden": {
		"y": "46.81766",
		"population": "308",
		"x": "9.60638",
		"ID": "1419"
	},
	"Cottens (VD)": {
		"y": "46.57251",
		"population": "473",
		"x": "6.4564",
		"ID": "59"
	},
	"Gachlingen": {
		"y": "47.70329",
		"population": "810",
		"x": "8.49878",
		"ID": "914"
	},
	"Bellinzona": {
		"y": "46.19278",
		"population": "17988",
		"x": "9.01703",
		"ID": "1194"
	},
	"Lully (FR)": {
		"y": "46.83401",
		"population": "1120",
		"x": "6.84534",
		"ID": "150"
	},
	"Kuttigen": {
		"y": "47.41566",
		"population": "5960",
		"x": "8.04767",
		"ID": "719"
	},
	"Bonvillars": {
		"y": "46.83976",
		"population": "502",
		"x": "6.67128",
		"ID": "109"
	},
	"Morcote": {
		"y": "45.925",
		"population": "755",
		"x": "8.916",
		"ID": "1117"
	},
	"Nottwil": {
		"y": "47.13569",
		"population": "3564",
		"x": "8.13712",
		"ID": "773"
	},
	"Alberswil": {
		"y": "47.14998",
		"population": "654",
		"x": "8.00313",
		"ID": "714"
	},
	"Pianezzo": {
		"y": "46.17006",
		"population": "592",
		"x": "9.02522",
		"ID": "1193"
	},
	"Untervaz": {
		"y": "46.9275",
		"population": "2429",
		"x": "9.53422",
		"ID": "1397"
	},
	"Flims": {
		"y": "46.83705",
		"population": "2673",
		"x": "9.28458",
		"ID": "1323"
	},
	"Vaulion": {
		"y": "46.68913",
		"population": "488",
		"x": "6.38941",
		"ID": "54"
	},
	"Fulenbach": {
		"y": "47.27496",
		"population": "1712",
		"x": "7.83343",
		"ID": "621"
	},
	"Merenschwand": {
		"y": "47.2587",
		"population": "3339",
		"x": "8.37532",
		"ID": "877"
	},
	"Bozen": {
		"y": "47.49528",
		"population": "721",
		"x": "8.08333",
		"ID": "750"
	},
	"Lungern": {
		"y": "46.78578",
		"population": "2107",
		"x": "8.15984",
		"ID": "766"
	},
	"Burglen (TG)": {
		"y": "47.54921",
		"population": "3633",
		"x": "9.1495",
		"ID": "1252"
	},
	"Gottlieben": {
		"y": "47.66452",
		"population": "324",
		"x": "9.12736",
		"ID": "1255"
	},
	"Widnau": {
		"y": "47.40834",
		"population": "9235",
		"x": "9.63321",
		"ID": "1445"
	},
	"Grusch": {
		"y": "46.97965",
		"population": "1968",
		"x": "9.64639",
		"ID": "1443"
	},
	"Mettauertal": {
		"y": "47.5618",
		"population": "1915",
		"x": "8.14319",
		"ID": "781"
	},
	"Confignon": {
		"y": "46.17341",
		"population": "4438",
		"x": "6.08437",
		"ID": "5"
	},
	"Menziken": {
		"y": "47.24249",
		"population": "5799",
		"x": "8.19047",
		"ID": "801"
	},
	"Fresens": {
		"y": "46.8874",
		"population": "216",
		"x": "6.74843",
		"ID": "129"
	},
	"Basadingen-Schlattingen": {
		"y": "47.66868",
		"population": "1817",
		"x": "8.74821",
		"ID": "1046"
	},
	"Uznach": {
		"y": "47.22421",
		"population": "6171",
		"x": "8.98263",
		"ID": "1177"
	},
	"Bedretto": {
		"y": "46.50596",
		"population": "94",
		"x": "8.51137",
		"ID": "923"
	},
	"Full-Reuenthal": {
		"y": "47.61606",
		"population": "859",
		"x": "8.20473",
		"ID": "808"
	},
	"Oberthal": {
		"y": "46.91612",
		"population": "722",
		"x": "7.67569",
		"ID": "548"
	},
	"Seedorf (UR)": {
		"y": "46.88199",
		"population": "1786",
		"x": "8.61611",
		"ID": "963"
	},
	"Eggersriet": {
		"y": "47.44202",
		"population": "2238",
		"x": "9.46901",
		"ID": "1382"
	},
	"Meltingen": {
		"y": "47.38328",
		"population": "648",
		"x": "7.5875",
		"ID": "491"
	},
	"Jeuss": {
		"y": "46.90405",
		"population": "414",
		"x": "7.16272",
		"ID": "299"
	},
	"Turtmann-Unterems": {
		"y": "46.30028",
		"population": "1104",
		"x": "7.702",
		"ID": "536"
	},
	"Bassersdorf": {
		"y": "47.44342",
		"population": "11494",
		"x": "8.62851",
		"ID": "974"
	},
	"Dubendorf": {
		"y": "47.39724",
		"population": "26297",
		"x": "8.61872",
		"ID": "973"
	},
	"Rohr (SO)": {
		"y": "47.41029",
		"population": "94",
		"x": "7.95333",
		"ID": "689"
	},
	"Feusisberg": {
		"y": "47.18707",
		"population": "5066",
		"x": "8.74724",
		"ID": "1036"
	},
	"Rickenbach (ZH)": {
		"y": "47.55191",
		"population": "2576",
		"x": "8.79654",
		"ID": "1077"
	},
	"Speicher": {
		"y": "47.4109",
		"population": "4167",
		"x": "9.44335",
		"ID": "1381"
	},
	"Uetendorf": {
		"y": "46.77392",
		"population": "5924",
		"x": "7.57251",
		"ID": "479"
	},
	"Regensdorf": {
		"y": "47.4341",
		"population": "17843",
		"x": "8.46874",
		"ID": "909"
	},
	"Darligen": {
		"y": "46.66175",
		"population": "407",
		"x": "7.80808",
		"ID": "609"
	},
	"Bottmingen": {
		"y": "47.52343",
		"population": "6356",
		"x": "7.57211",
		"ID": "494"
	},
	"Montherod": {
		"y": "46.5017",
		"population": "492",
		"x": "6.3615",
		"ID": "50"
	},
	"Bussigny": {
		"y": "46.5511",
		"population": "8200",
		"x": "6.55597",
		"ID": "80"
	},
	"Kreuzlingen": {
		"y": "47.65051",
		"population": "21152",
		"x": "9.17504",
		"ID": "1254"
	},
	"Oberhofen am Thunersee": {
		"y": "46.73148",
		"population": "2381",
		"x": "7.66903",
		"ID": "544"
	},
	"Hindelbank": {
		"y": "47.0427",
		"population": "2392",
		"x": "7.54143",
		"ID": "484"
	},
	"Valeyres-sous-Ursins": {
		"y": "46.74715",
		"population": "245",
		"x": "6.65231",
		"ID": "95"
	},
	"Heimenhausen": {
		"y": "47.20904",
		"population": "1099",
		"x": "7.69957",
		"ID": "554"
	},
	"Thalheim (AG)": {
		"y": "47.43534",
		"population": "799",
		"x": "8.10027",
		"ID": "749"
	},
	"Zuzwil (BE)": {
		"y": "47.05112",
		"population": "565",
		"x": "7.46806",
		"ID": "453"
	},
	"Wichtrach": {
		"y": "46.8501",
		"population": "4075",
		"x": "7.57748",
		"ID": "481"
	},
	"Andeer": {
		"y": "46.6034",
		"population": "912",
		"x": "9.42614",
		"ID": "1366"
	},
	"Eglisau": {
		"y": "47.57738",
		"population": "4972",
		"x": "8.52122",
		"ID": "943"
	},
	"Lajoux (JU)": {
		"y": "47.27893",
		"population": "652",
		"x": "7.13726",
		"ID": "306"
	},
	"Bedano": {
		"y": "46.05122",
		"population": "1536",
		"x": "8.91935",
		"ID": "1119"
	},
	"Essert-Pittet": {
		"y": "46.72754",
		"population": "164",
		"x": "6.58334",
		"ID": "83"
	},
	"Valangin": {
		"y": "47.01606",
		"population": "493",
		"x": "6.90669",
		"ID": "176"
	},
	"Lohnstorf": {
		"y": "46.80771",
		"population": "231",
		"x": "7.50987",
		"ID": "480"
	},
	"Eschenbach (LU)": {
		"y": "47.13231",
		"population": "3614",
		"x": "8.31964",
		"ID": "849"
	},
	"Vaulruz": {
		"y": "46.62118",
		"population": "1026",
		"x": "6.98727",
		"ID": "196"
	},
	"Sagogn": {
		"y": "46.79371",
		"population": "682",
		"x": "9.25701",
		"ID": "1297"
	},
	"Niederwald": {
		"y": "46.43536",
		"population": "47",
		"x": "8.18994",
		"ID": "786"
	},
	"Herbetswil": {
		"y": "47.29601",
		"population": "529",
		"x": "7.59195",
		"ID": "522"
	},
	"Lutry": {
		"y": "46.50241",
		"population": "9470",
		"x": "6.68647",
		"ID": "103"
	},
	"Hautligen": {
		"y": "46.8576",
		"population": "243",
		"x": "7.60671",
		"ID": "513"
	},
	"Sumvitg": {
		"y": "46.72845",
		"population": "1194",
		"x": "8.93884",
		"ID": "1132"
	},
	"Gampelen": {
		"y": "47.01499",
		"population": "829",
		"x": "7.05994",
		"ID": "236"
	},
	"Wangen bei Olten": {
		"y": "47.34365",
		"population": "5007",
		"x": "7.86982",
		"ID": "656"
	},
	"Muri (AG)": {
		"y": "47.27428",
		"population": "7480",
		"x": "8.33854",
		"ID": "852"
	},
	"Wittnau": {
		"y": "47.47709",
		"population": "1198",
		"x": "7.96607",
		"ID": "690"
	},
	"Kammersrohr": {
		"y": "47.25296",
		"population": "33",
		"x": "7.5932",
		"ID": "521"
	},
	"Randogne": {
		"y": "46.30952",
		"population": "2956",
		"x": "7.50058",
		"ID": "439"
	},
	"Aubonne": {
		"y": "46.49514",
		"population": "3219",
		"x": "6.39155",
		"ID": "50"
	},
	"Benken (SG)": {
		"y": "47.19942",
		"population": "2868",
		"x": "9.00735",
		"ID": "1177"
	},
	"Isenthal": {
		"y": "46.91079",
		"population": "505",
		"x": "8.56121",
		"ID": "964"
	},
	"Kanerkinden": {
		"y": "47.41188",
		"population": "513",
		"x": "7.83716",
		"ID": "624"
	},
	"Bad Zurzach": {
		"y": "47.58764",
		"population": "4091",
		"x": "8.29365",
		"ID": "833"
	},
	"Movelier": {
		"y": "47.40954",
		"population": "384",
		"x": "7.31719",
		"ID": "400"
	},
	"Saint-Blaise": {
		"y": "47.01323",
		"population": "3258",
		"x": "6.98472",
		"ID": "236"
	},
	"Courgevaux": {
		"y": "46.90648",
		"population": "1425",
		"x": "7.11215",
		"ID": "266"
	},
	"Bioley-Magnoux": {
		"y": "46.72593",
		"population": "201",
		"x": "6.71082",
		"ID": "107"
	},
	"Les Brenets": {
		"y": "47.06708",
		"population": "1036",
		"x": "6.70727",
		"ID": "113"
	},
	"Perroy": {
		"y": "46.46821",
		"population": "1464",
		"x": "6.36622",
		"ID": "49"
	},
	"Orpund": {
		"y": "47.13891",
		"population": "2641",
		"x": "7.30775",
		"ID": "364"
	},
	"Quarten": {
		"y": "47.107",
		"population": "2750",
		"x": "9.24199",
		"ID": "1303"
	},
	"Hofstetten-Fluh": {
		"y": "47.47216",
		"population": "3152",
		"x": "7.50826",
		"ID": "461"
	},
	"Langenbruck": {
		"y": "47.34917",
		"population": "982",
		"x": "7.76802",
		"ID": "590"
	},
	"Sonogno": {
		"y": "46.3504",
		"population": "91",
		"x": "8.78514",
		"ID": "1054"
	},
	"Lenzburg": {
		"y": "47.37184",
		"population": "9039",
		"x": "8.1891",
		"ID": "804"
	},
	"Mels": {
		"y": "47.04556",
		"population": "8460",
		"x": "9.42318",
		"ID": "1350"
	},
	"Aarau": {
		"y": "47.39254",
		"population": "20253",
		"x": "8.04422",
		"ID": "748"
	},
	"Echandens": {
		"y": "46.53947",
		"population": "2648",
		"x": "6.53704",
		"ID": "69"
	},
	"Torricella-Taverne": {
		"y": "46.06831",
		"population": "3045",
		"x": "8.91244",
		"ID": "1119"
	},
	"Lenk": {
		"y": "46.45826",
		"population": "2356",
		"x": "7.44298",
		"ID": "411"
	},
	"Schanis": {
		"y": "47.15995",
		"population": "3730",
		"x": "9.04549",
		"ID": "1212"
	},
	"Jorat-Menthue": {
		"y": "46.63641",
		"population": "1520",
		"x": "6.72437",
		"ID": "105"
	},
	"Cadempino": {
		"y": "46.03672",
		"population": "1519",
		"x": "8.93403",
		"ID": "1154"
	},
	"Altstatten": {
		"y": "47.37766",
		"population": "11120",
		"x": "9.54746",
		"ID": "1405"
	},
	"Villars-sur-Glane": {
		"y": "46.79054",
		"population": "11882",
		"x": "7.11717",
		"ID": "264"
	},
	"Visperterminen": {
		"y": "46.25899",
		"population": "1377",
		"x": "7.90192",
		"ID": "635"
	},
	"Farnern": {
		"y": "47.26693",
		"population": "202",
		"x": "7.61778",
		"ID": "521"
	},
	"Knutwil": {
		"y": "47.19953",
		"population": "2117",
		"x": "8.07315",
		"ID": "744"
	},
	"Rennaz": {
		"y": "46.3748",
		"population": "834",
		"x": "6.91604",
		"ID": "164"
	},
	"Zeiningen": {
		"y": "47.54143",
		"population": "2262",
		"x": "7.87179",
		"ID": "660"
	},
	"Mont-sur-Rolle": {
		"y": "46.4702",
		"population": "2554",
		"x": "6.33516",
		"ID": "43"
	},
	"Bonaduz": {
		"y": "46.81103",
		"population": "3161",
		"x": "9.39821",
		"ID": "1345"
	},
	"Chesopelloz": {
		"y": "46.8081",
		"population": "120",
		"x": "7.078",
		"ID": "264"
	},
	"Mohlin": {
		"y": "47.55915",
		"population": "10745",
		"x": "7.84329",
		"ID": "660"
	},
	"Troistorrents": {
		"y": "46.2289",
		"population": "4468",
		"x": "6.91589",
		"ID": "161"
	},
	"Romanel-sur-Lausanne": {
		"y": "46.56667",
		"population": "3309",
		"x": "6.60453",
		"ID": "91"
	},
	"Mergoscia": {
		"y": "46.21061",
		"population": "215",
		"x": "8.84777",
		"ID": "1086"
	},
	"Hallwil": {
		"y": "47.28413",
		"population": "786",
		"x": "8.21577",
		"ID": "802"
	},
	"Corcelles (BE)": {
		"y": "47.28488",
		"population": "210",
		"x": "7.45242",
		"ID": "427"
	},
	"Cademario": {
		"y": "46.02264",
		"population": "741",
		"x": "8.8924",
		"ID": "1118"
	},
	"Les Agettes": {
		"y": "46.21198",
		"population": "337",
		"x": "7.37147",
		"ID": "377"
	},
	"Mumliswil-Ramiswil": {
		"y": "47.34411",
		"population": "2390",
		"x": "7.7035",
		"ID": "556"
	},
	"Tamins": {
		"y": "46.82964",
		"population": "1167",
		"x": "9.40648",
		"ID": "1346"
	},
	"Habsburg": {
		"y": "47.46228",
		"population": "407",
		"x": "8.18503",
		"ID": "779"
	},
	"Lauerz": {
		"y": "47.03528",
		"population": "1096",
		"x": "8.58118",
		"ID": "966"
	},
	"Waldstatt": {
		"y": "47.35627",
		"population": "1750",
		"x": "9.28345",
		"ID": "1308"
	},
	"Aeschi bei Spiez": {
		"y": "46.65848",
		"population": "2183",
		"x": "7.6965",
		"ID": "543"
	},
	"Niederlenz": {
		"y": "47.40079",
		"population": "4504",
		"x": "8.1764",
		"ID": "778"
	},
	"Unterageri": {
		"y": "47.13645",
		"population": "8482",
		"x": "8.5853",
		"ID": "968"
	},
	"Faoug": {
		"y": "46.90829",
		"population": "858",
		"x": "7.07803",
		"ID": "266"
	},
	"Luterswil-Gachliwil": {
		"y": "47.12224",
		"population": "313",
		"x": "7.43908",
		"ID": "424"
	},
	"Giebenach": {
		"y": "47.52299",
		"population": "1035",
		"x": "7.73971",
		"ID": "593"
	},
	"Saviese": {
		"y": "46.25115",
		"population": "7317",
		"x": "7.34558",
		"ID": "378"
	},
	"Ennetbaden": {
		"y": "47.48055",
		"population": "3290",
		"x": "8.32399",
		"ID": "856"
	},
	"Teufenthal (AG)": {
		"y": "47.32863",
		"population": "1556",
		"x": "8.12074",
		"ID": "776"
	},
	"Roggwil (TG)": {
		"y": "47.49981",
		"population": "2928",
		"x": "9.3958",
		"ID": "1359"
	},
	"Allschwil": {
		"y": "47.55074",
		"population": "20183",
		"x": "7.53599",
		"ID": "494"
	},
	"Gretzenbach": {
		"y": "47.35823",
		"population": "2630",
		"x": "8.00243",
		"ID": "718"
	},
	"Heremence": {
		"y": "46.18032",
		"population": "1299",
		"x": "7.40477",
		"ID": "406"
	},
	"Juriens": {
		"y": "46.68846",
		"population": "301",
		"x": "6.44569",
		"ID": "61"
	},
	"Koppigen": {
		"y": "47.13385",
		"population": "2085",
		"x": "7.59875",
		"ID": "519"
	},
	"Marsens": {
		"y": "46.65649",
		"population": "1785",
		"x": "7.06167",
		"ID": "229"
	},
	"Pierrafortscha": {
		"y": "46.7812",
		"population": "138",
		"x": "7.1807",
		"ID": "296"
	},
	"Baar": {
		"y": "47.19625",
		"population": "23282",
		"x": "8.52954",
		"ID": "936"
	},
	"Etziken": {
		"y": "47.18755",
		"population": "771",
		"x": "7.64777",
		"ID": "553"
	},
	"Gipf-Oberfrick": {
		"y": "47.49875",
		"population": "3521",
		"x": "8.00497",
		"ID": "721"
	},
	"La Rippe": {
		"y": "46.38096",
		"population": "1141",
		"x": "6.15046",
		"ID": "15"
	},
	"Oftringen": {
		"y": "47.31382",
		"population": "13113",
		"x": "7.92533",
		"ID": "687"
	},
	"Himmelried": {
		"y": "47.42111",
		"population": "927",
		"x": "7.59659",
		"ID": "524"
	},
	"Buseno": {
		"y": "46.27381",
		"population": "92",
		"x": "9.10735",
		"ID": "1228"
	},
	"Diegten": {
		"y": "47.4138",
		"population": "1609",
		"x": "7.81085",
		"ID": "624"
	},
	"Erlinsbach (SO)": {
		"y": "47.39753",
		"population": "3358",
		"x": "8.00797",
		"ID": "719"
	},
	"Eschenbach (SG)": {
		"y": "47.23981",
		"population": "8980",
		"x": "8.92156",
		"ID": "1142"
	},
	"Trin": {
		"y": "46.82834",
		"population": "1317",
		"x": "9.36164",
		"ID": "1346"
	},
	"Lucens": {
		"y": "46.70854",
		"population": "3293",
		"x": "6.83931",
		"ID": "148"
	},
	"Vufflens-le-Chateau": {
		"y": "46.52627",
		"population": "820",
		"x": "6.47206",
		"ID": "58"
	},
	"Niederweningen": {
		"y": "47.50614",
		"population": "2824",
		"x": "8.37711",
		"ID": "882"
	},
	"Grengiols": {
		"y": "46.37395",
		"population": "430",
		"x": "8.093",
		"ID": "758"
	},
	"Sisseln": {
		"y": "47.55313",
		"population": "1537",
		"x": "7.9917",
		"ID": "722"
	},
	"Oberbuchsiten": {
		"y": "47.31334",
		"population": "2163",
		"x": "7.76836",
		"ID": "589"
	},
	"Altburon": {
		"y": "47.18204",
		"population": "975",
		"x": "7.88123",
		"ID": "653"
	},
	"Gorduno": {
		"y": "46.21631",
		"population": "780",
		"x": "9.03076",
		"ID": "1194"
	},
	"Charrat": {
		"y": "46.1249",
		"population": "1645",
		"x": "7.13138",
		"ID": "284"
	},
	"Berikon": {
		"y": "47.35137",
		"population": "4553",
		"x": "8.37209",
		"ID": "879"
	},
	"Plan-les-Ouates": {
		"y": "46.16789",
		"population": "10147",
		"x": "6.11664",
		"ID": "11"
	},
	"Orselina": {
		"y": "46.18013",
		"population": "734",
		"x": "8.79979",
		"ID": "1050"
	},
	"Mandach": {
		"y": "47.54783",
		"population": "314",
		"x": "8.18903",
		"ID": "807"
	},
	"Turgi": {
		"y": "47.49201",
		"population": "2949",
		"x": "8.25412",
		"ID": "832"
	},
	"Winterthur": {
		"y": "47.50564",
		"population": "106349",
		"x": "8.72413",
		"ID": "1042"
	},
	"Escholzmatt-Marbach": {
		"y": "46.85441",
		"population": "4227",
		"x": "7.89966",
		"ID": "646"
	},
	"Arni (BE)": {
		"y": "46.93519",
		"population": "911",
		"x": "7.66473",
		"ID": "548"
	},
	"Kilchberg (BL)": {
		"y": "47.42486",
		"population": "154",
		"x": "7.89396",
		"ID": "657"
	},
	"Zetzwil": {
		"y": "47.28824",
		"population": "1304",
		"x": "8.15095",
		"ID": "776"
	},
	"Muttenz": {
		"y": "47.52271",
		"population": "17342",
		"x": "7.64511",
		"ID": "526"
	},
	"Davos": {
		"y": "46.80429",
		"population": "11020",
		"x": "9.83723",
		"ID": "1486"
	},
	"Vouvry": {
		"y": "46.33746",
		"population": "3930",
		"x": "6.8895",
		"ID": "163"
	},
	"Schwaderloch": {
		"y": "47.58541",
		"population": "672",
		"x": "8.14455",
		"ID": "781"
	},
	"Schwarzenburg": {
		"y": "46.79861",
		"population": "6763",
		"x": "7.3375",
		"ID": "388"
	},
	"Frick": {
		"y": "47.51169",
		"population": "5233",
		"x": "8.02471",
		"ID": "721"
	},
	"Olten": {
		"y": "47.34999",
		"population": "17364",
		"x": "7.90329",
		"ID": "656"
	},
	"Acquarossa": {
		"y": "46.45473",
		"population": "1830",
		"x": "8.94261",
		"ID": "1127"
	},
	"Kaiseraugst": {
		"y": "47.53966",
		"population": "5463",
		"x": "7.72605",
		"ID": "593"
	},
	"Buchrain": {
		"y": "47.10175",
		"population": "6070",
		"x": "8.34792",
		"ID": "849"
	},
	"Rueggisberg": {
		"y": "46.82216",
		"population": "1782",
		"x": "7.4389",
		"ID": "418"
	},
	"Bagnes": {
		"y": "46.08333",
		"population": "7978",
		"x": "7.21667",
		"ID": "314"
	},
	"Oberkulm": {
		"y": "47.29839",
		"population": "2639",
		"x": "8.12591",
		"ID": "776"
	},
	"Beromunster": {
		"y": "47.20612",
		"population": "6353",
		"x": "8.19265",
		"ID": "801"
	},
	"Lauenen": {
		"y": "46.42437",
		"population": "825",
		"x": "7.3217",
		"ID": "381"
	},
	"Niederried bei Interlaken": {
		"y": "46.72547",
		"population": "346",
		"x": "7.92549",
		"ID": "675"
	},
	"Kienberg": {
		"y": "47.43832",
		"population": "510",
		"x": "7.96381",
		"ID": "689"
	},
	"Rafz": {
		"y": "47.60438",
		"population": "4319",
		"x": "8.54305",
		"ID": "944"
	},
	"Buhler": {
		"y": "47.37348",
		"population": "1675",
		"x": "9.42507",
		"ID": "1356"
	},
	"Apples": {
		"y": "46.55237",
		"population": "1330",
		"x": "6.42889",
		"ID": "59"
	},
	"Muzzano": {
		"y": "45.99622",
		"population": "812",
		"x": "8.92709",
		"ID": "1118"
	},
	"Obergosgen": {
		"y": "47.36406",
		"population": "2197",
		"x": "7.95275",
		"ID": "688"
	},
	"Embrach": {
		"y": "47.50561",
		"population": "9050",
		"x": "8.59406",
		"ID": "975"
	},
	"Aranno": {
		"y": "46.01798",
		"population": "347",
		"x": "8.87069",
		"ID": "1082"
	},
	"Sattel": {
		"y": "47.08246",
		"population": "1909",
		"x": "8.63565",
		"ID": "1001"
	},
	"Zullwil": {
		"y": "47.39263",
		"population": "631",
		"x": "7.6005",
		"ID": "524"
	},
	"Chavannes-pres-Renens": {
		"y": "46.53005",
		"population": "7286",
		"x": "6.57068",
		"ID": "79"
	},
	"Oberstammheim": {
		"y": "47.63244",
		"population": "1166",
		"x": "8.79963",
		"ID": "1078"
	},
	"Obermumpf": {
		"y": "47.52937",
		"population": "1049",
		"x": "7.93762",
		"ID": "691"
	},
	"Wiler (Lotschen)": {
		"y": "46.40315",
		"population": "570",
		"x": "7.78161",
		"ID": "604"
	},
	"Freienwil": {
		"y": "47.50297",
		"population": "975",
		"x": "8.32768",
		"ID": "856"
	},
	"Adligenswil": {
		"y": "47.06521",
		"population": "5323",
		"x": "8.36124",
		"ID": "848"
	},
	"Feldbrunnen-St. Niklaus": {
		"y": "47.22018",
		"population": "960",
		"x": "7.55486",
		"ID": "488"
	},
	"Gelterkinden": {
		"y": "47.46497",
		"population": "5885",
		"x": "7.85174",
		"ID": "658"
	},
	"Egerkingen": {
		"y": "47.31957",
		"population": "3396",
		"x": "7.78424",
		"ID": "622"
	},
	"Luscherz": {
		"y": "47.04461",
		"population": "526",
		"x": "7.15266",
		"ID": "301"
	},
	"Alpnach": {
		"y": "46.94227",
		"population": "5830",
		"x": "8.2718",
		"ID": "821"
	},
	"Wangen-Bruttisellen": {
		"y": "47.42173",
		"population": "7677",
		"x": "8.63263",
		"ID": "974"
	},
	"Bedigliora": {
		"y": "46.00242",
		"population": "624",
		"x": "8.83927",
		"ID": "1082"
	},
	"Pomy": {
		"y": "46.75856",
		"population": "731",
		"x": "6.66908",
		"ID": "95"
	},
	"Buren (SO)": {
		"y": "47.44702",
		"population": "982",
		"x": "7.67058",
		"ID": "558"
	},
	"Rute": {
		"y": "47.3035",
		"population": "3511",
		"x": "9.45589",
		"ID": "1379"
	},
	"Dompierre (VD)": {
		"y": "46.70829",
		"population": "247",
		"x": "6.88313",
		"ID": "170"
	},
	"Fischenthal": {
		"y": "47.33122",
		"population": "2386",
		"x": "8.92052",
		"ID": "1144"
	},
	"Saint-Gingolph": {
		"y": "46.39217",
		"population": "878",
		"x": "6.80594",
		"ID": "120"
	},
	"Muralto": {
		"y": "46.17323",
		"population": "2636",
		"x": "8.80219",
		"ID": "1050"
	},
	"Echallens": {
		"y": "46.6413",
		"population": "5586",
		"x": "6.63317",
		"ID": "93"
	},
	"Vico Morcote": {
		"y": "45.92817",
		"population": "374",
		"x": "8.91935",
		"ID": "1117"
	},
	"Corcelles-pres-Concise": {
		"y": "46.85326",
		"population": "328",
		"x": "6.69988",
		"ID": "109"
	},
	"Liesberg": {
		"y": "47.40398",
		"population": "1162",
		"x": "7.42787",
		"ID": "429"
	},
	"Nenzlingen": {
		"y": "47.44739",
		"population": "418",
		"x": "7.55701",
		"ID": "492"
	},
	"Titterten": {
		"y": "47.40213",
		"population": "402",
		"x": "7.71617",
		"ID": "591"
	},
	"Preonzo": {
		"y": "46.26187",
		"population": "611",
		"x": "9.00505",
		"ID": "1195"
	},
	"Novaggio": {
		"y": "46.0102",
		"population": "817",
		"x": "8.8561",
		"ID": "1082"
	},
	"Rottenschwil": {
		"y": "47.31375",
		"population": "802",
		"x": "8.36137",
		"ID": "853"
	},
	"Hersberg": {
		"y": "47.49209",
		"population": "325",
		"x": "7.78313",
		"ID": "625"
	},
	"Auenstein": {
		"y": "47.41558",
		"population": "1545",
		"x": "8.13455",
		"ID": "778"
	},
	"Chenens": {
		"y": "46.74157",
		"population": "845",
		"x": "7.00403",
		"ID": "231"
	},
	"Henggart": {
		"y": "47.56272",
		"population": "2240",
		"x": "8.68215",
		"ID": "1010"
	},
	"Delemont": {
		"y": "47.36493",
		"population": "12301",
		"x": "7.34453",
		"ID": "399"
	},
	"Oberried am Brienzersee": {
		"y": "46.73633",
		"population": "446",
		"x": "7.95925",
		"ID": "676"
	},
	"Oberuzwil": {
		"y": "47.43076",
		"population": "6252",
		"x": "9.12724",
		"ID": "1250"
	},
	"Sissach": {
		"y": "47.44237",
		"population": "6534",
		"x": "7.84871",
		"ID": "624"
	},
	"Valeyres-sous-Montagny": {
		"y": "46.80046",
		"population": "660",
		"x": "6.60369",
		"ID": "96"
	},
	"Milvignes": {
		"y": "46.9722",
		"population": "8993",
		"x": "6.85719",
		"ID": "175"
	},
	"Walterswil (SO)": {
		"y": "47.32449",
		"population": "688",
		"x": "7.95586",
		"ID": "687"
	},
	"Rickenbach (BL)": {
		"y": "47.48596",
		"population": "579",
		"x": "7.84736",
		"ID": "625"
	},
	"Hauterive (FR)": {
		"y": "46.75952",
		"population": "2358",
		"x": "7.0927",
		"ID": "263"
	},
	"Guttet-Feschel": {
		"y": "46.32533",
		"population": "415",
		"x": "7.667",
		"ID": "537"
	},
	"Brusio": {
		"y": "46.25953",
		"population": "1098",
		"x": "10.12385",
		"ID": "1543"
	},
	"Leibstadt": {
		"y": "47.5879",
		"population": "1259",
		"x": "8.17611",
		"ID": "808"
	},
	"Mervelier": {
		"y": "47.34349",
		"population": "506",
		"x": "7.49969",
		"ID": "459"
	},
	"Rudlingen": {
		"y": "47.57826",
		"population": "734",
		"x": "8.57191",
		"ID": "943"
	},
	"Bremgarten bei Bern": {
		"y": "46.97811",
		"population": "4315",
		"x": "7.43545",
		"ID": "421"
	},
	"Safiental": {
		"y": "46.69624",
		"population": "895",
		"x": "9.30396",
		"ID": "1321"
	},
	"Uezwil": {
		"y": "47.3169",
		"population": "462",
		"x": "8.27163",
		"ID": "828"
	},
	"Evolene": {
		"y": "46.11422",
		"population": "1684",
		"x": "7.49407",
		"ID": "435"
	},
	"Ettingen": {
		"y": "47.48268",
		"population": "4925",
		"x": "7.54982",
		"ID": "493"
	},
	"Rivaz": {
		"y": "46.47629",
		"population": "362",
		"x": "6.77878",
		"ID": "122"
	},
	"Lupsingen": {
		"y": "47.44433",
		"population": "1409",
		"x": "7.69574",
		"ID": "558"
	},
	"Biezwil": {
		"y": "47.11653",
		"population": "315",
		"x": "7.41546",
		"ID": "424"
	},
	"Grone": {
		"y": "46.25288",
		"population": "2304",
		"x": "7.45947",
		"ID": "438"
	},
	"Jegenstorf": {
		"y": "47.04802",
		"population": "5526",
		"x": "7.50787",
		"ID": "453"
	},
	"Blitzingen": {
		"y": "46.4436",
		"population": "74",
		"x": "8.2019",
		"ID": "786"
	},
	"Hinterrhein": {
		"y": "46.55827",
		"population": "66",
		"x": "9.41183",
		"ID": "1365"
	},
	"Aesch (BL)": {
		"y": "47.47104",
		"population": "9998",
		"x": "7.5973",
		"ID": "525"
	},
	"Hedingen": {
		"y": "47.29794",
		"population": "3642",
		"x": "8.44833",
		"ID": "906"
	},
	"Corsier (GE)": {
		"y": "46.26297",
		"population": "1957",
		"x": "6.22461",
		"ID": "22"
	},
	"Comano": {
		"y": "46.03635",
		"population": "2058",
		"x": "8.95526",
		"ID": "1154"
	},
	"Muhleberg": {
		"y": "46.95466",
		"population": "2833",
		"x": "7.26102",
		"ID": "361"
	},
	"Balgach": {
		"y": "47.40556",
		"population": "4424",
		"x": "9.60702",
		"ID": "1426"
	},
	"Unterlunkhofen": {
		"y": "47.3212",
		"population": "1294",
		"x": "8.38102",
		"ID": "878"
	},
	"La Cote-aux-Fees": {
		"y": "46.86744",
		"population": "454",
		"x": "6.49043",
		"ID": "75"
	},
	"Wartau": {
		"y": "47.08333",
		"population": "5181",
		"x": "9.48333",
		"ID": "1375"
	},
	"Brittnau": {
		"y": "47.25954",
		"population": "3812",
		"x": "7.94689",
		"ID": "686"
	},
	"Wangen an der Aare": {
		"y": "47.23199",
		"population": "2237",
		"x": "7.65448",
		"ID": "554"
	},
	"Ipsach": {
		"y": "47.11389",
		"population": "3917",
		"x": "7.23029",
		"ID": "334"
	},
	"Oeschenbach": {
		"y": "47.10287",
		"population": "238",
		"x": "7.74756",
		"ID": "585"
	},
	"Biberstein": {
		"y": "47.41883",
		"population": "1458",
		"x": "8.08302",
		"ID": "749"
	},
	"Vandoeuvres": {
		"y": "46.22179",
		"population": "2454",
		"x": "6.20285",
		"ID": "21"
	},
	"Dully": {
		"y": "46.43143",
		"population": "640",
		"x": "6.29461",
		"ID": "42"
	},
	"Renens (VD)": {
		"y": "46.53989",
		"population": "20265",
		"x": "6.5881",
		"ID": "79"
	},
	"Stansstad": {
		"y": "46.9768",
		"population": "4348",
		"x": "8.33553",
		"ID": "846"
	},
	"Brienzwiler": {
		"y": "46.75084",
		"population": "470",
		"x": "8.10139",
		"ID": "736"
	},
	"Nidau": {
		"y": "47.12545",
		"population": "6788",
		"x": "7.24033",
		"ID": "335"
	},
	"Weisslingen": {
		"y": "47.43063",
		"population": "3216",
		"x": "8.76787",
		"ID": "1041"
	},
	"Marchissy": {
		"y": "46.48811",
		"population": "449",
		"x": "6.24659",
		"ID": "36"
	},
	"Wald (AR)": {
		"y": "47.4156",
		"population": "834",
		"x": "9.49099",
		"ID": "1381"
	},
	"Nunningen": {
		"y": "47.3945",
		"population": "1864",
		"x": "7.62122",
		"ID": "524"
	},
	"Capriasca": {
		"y": "46.06507",
		"population": "6430",
		"x": "8.95609",
		"ID": "1155"
	},
	"Unterschachen": {
		"y": "46.86281",
		"population": "696",
		"x": "8.76923",
		"ID": "1064"
	},
	"Zurich": {
		"y": "47.36667",
		"population": "382623",
		"x": "8.55",
		"ID": "939"
	},
	"Bottstein": {
		"y": "47.55544",
		"population": "3876",
		"x": "8.22258",
		"ID": "807"
	},
	"Bad Ragaz": {
		"y": "47.00601",
		"population": "5655",
		"x": "9.50266",
		"ID": "1398"
	},
	"Meierskappel": {
		"y": "47.12424",
		"population": "1340",
		"x": "8.44436",
		"ID": "903"
	},
	"Untersiggenthal": {
		"y": "47.50213",
		"population": "7060",
		"x": "8.25554",
		"ID": "832"
	},
	"Ebnat-Kappel": {
		"y": "47.26195",
		"population": "4913",
		"x": "9.12473",
		"ID": "1247"
	},
	"Mosogno": {
		"y": "46.19877",
		"population": "52",
		"x": "8.64159",
		"ID": "984"
	},
	"Rovray": {
		"y": "46.78489",
		"population": "175",
		"x": "6.76445",
		"ID": "127"
	},
	"Raperswilen": {
		"y": "47.63241",
		"population": "391",
		"x": "9.04261",
		"ID": "1185"
	},
	"Cadenazzo": {
		"y": "46.15172",
		"population": "2723",
		"x": "8.94719",
		"ID": "1156"
	},
	"Collex-Bossy": {
		"y": "46.27953",
		"population": "1632",
		"x": "6.12207",
		"ID": "13"
	},
	"Cheiry": {
		"y": "46.75038",
		"population": "375",
		"x": "6.83553",
		"ID": "148"
	},
	"Chene-Bourg": {
		"y": "46.19534",
		"population": "8304",
		"x": "6.19406",
		"ID": "21"
	},
	"Wohlen bei Bern": {
		"y": "46.97113",
		"population": "8920",
		"x": "7.35593",
		"ID": "392"
	},
	"Vich": {
		"y": "46.42925",
		"population": "893",
		"x": "6.25013",
		"ID": "35"
	},
	"Weesen": {
		"y": "47.13447",
		"population": "1554",
		"x": "9.09644",
		"ID": "1212"
	},
	"Maladers": {
		"y": "46.83579",
		"population": "502",
		"x": "9.55997",
		"ID": "1419"
	},
	"Suscevaz": {
		"y": "46.76335",
		"population": "195",
		"x": "6.58289",
		"ID": "84"
	},
	"Embd": {
		"y": "46.21503",
		"population": "285",
		"x": "7.8267",
		"ID": "600"
	},
	"Grub (AR)": {
		"y": "47.44765",
		"population": "985",
		"x": "9.50974",
		"ID": "1382"
	},
	"Altwis": {
		"y": "47.23847",
		"population": "411",
		"x": "8.24781",
		"ID": "827"
	},
	"Vorderthal": {
		"y": "47.12172",
		"population": "996",
		"x": "8.90225",
		"ID": "1103"
	},
	"Oberwil bei Buren": {
		"y": "47.13072",
		"population": "822",
		"x": "7.41141",
		"ID": "424"
	},
	"Bremblens": {
		"y": "46.54665",
		"population": "507",
		"x": "6.52062",
		"ID": "69"
	},
	"Damphreux": {
		"y": "47.47602",
		"population": "181",
		"x": "7.10694",
		"ID": "277"
	},
	"Salouf": {
		"y": "46.62445",
		"population": "206",
		"x": "9.57613",
		"ID": "1415"
	},
	"Lengnau (BE)": {
		"y": "47.18155",
		"population": "4896",
		"x": "7.36814",
		"ID": "396"
	},
	"Cevio": {
		"y": "46.31479",
		"population": "1141",
		"x": "8.60332",
		"ID": "953"
	},
	"Messen": {
		"y": "47.09128",
		"population": "1450",
		"x": "7.44957",
		"ID": "454"
	},
	"Kradolf-Schonenberg": {
		"y": "47.52139",
		"population": "3489",
		"x": "9.1986",
		"ID": "1282"
	},
	"Sevelen": {
		"y": "47.12213",
		"population": "4768",
		"x": "9.48601",
		"ID": "1376"
	},
	"Corippo": {
		"y": "46.23593",
		"population": "13",
		"x": "8.84073",
		"ID": "1086"
	},
	"Bettwil": {
		"y": "47.29064",
		"population": "566",
		"x": "8.2679",
		"ID": "828"
	},
	"Molondin": {
		"y": "46.7591",
		"population": "222",
		"x": "6.74457",
		"ID": "127"
	},
	"Andiast": {
		"y": "46.78454",
		"population": "201",
		"x": "9.11373",
		"ID": "1238"
	},
	"Pontresina": {
		"y": "46.4955",
		"population": "2152",
		"x": "9.90126",
		"ID": "1493"
	},
	"Avry": {
		"y": "46.78815",
		"population": "1868",
		"x": "7.07006",
		"ID": "264"
	},
	"Romanel-sur-Morges": {
		"y": "46.55657",
		"population": "458",
		"x": "6.51059",
		"ID": "69"
	},
	"Pfafers": {
		"y": "46.98986",
		"population": "1560",
		"x": "9.50077",
		"ID": "1398"
	},
	"Dornach": {
		"y": "47.48038",
		"population": "6434",
		"x": "7.61644",
		"ID": "525"
	},
	"Spiez": {
		"y": "46.68473",
		"population": "12306",
		"x": "7.69111",
		"ID": "544"
	},
	"Kleinandelfingen": {
		"y": "47.60058",
		"population": "2055",
		"x": "8.68362",
		"ID": "1011"
	},
	"Lausen": {
		"y": "47.47139",
		"population": "4978",
		"x": "7.7603",
		"ID": "592"
	},
	"Teufen (AR)": {
		"y": "47.3908",
		"population": "6050",
		"x": "9.38644",
		"ID": "1356"
	},
	"Derendingen": {
		"y": "47.1985",
		"population": "6249",
		"x": "7.58844",
		"ID": "520"
	},
	"Tubach": {
		"y": "47.48678",
		"population": "1332",
		"x": "9.45462",
		"ID": "1383"
	},
	"Cortaillod": {
		"y": "46.94306",
		"population": "4747",
		"x": "6.8444",
		"ID": "152"
	},
	"Brugg": {
		"y": "47.1237",
		"population": "11007",
		"x": "7.27887",
		"ID": "364"
	},
	"Saint-Leonard": {
		"y": "46.25152",
		"population": "2250",
		"x": "7.41714",
		"ID": "407"
	},
	"Bas-Vully": {
		"y": "46.96194",
		"population": "2105",
		"x": "7.11251",
		"ID": "267"
	},
	"Paudex": {
		"y": "46.50548",
		"population": "1489",
		"x": "6.66819",
		"ID": "90"
	},
	"Thorigen": {
		"y": "47.17306",
		"population": "1082",
		"x": "7.72888",
		"ID": "586"
	},
	"Lutisburg": {
		"y": "47.39451",
		"population": "1421",
		"x": "9.08312",
		"ID": "1217"
	},
	"Wil (SG)": {
		"y": "47.46152",
		"population": "23125",
		"x": "9.04552",
		"ID": "1218"
	},
	"Thonex": {
		"y": "46.18815",
		"population": "13611",
		"x": "6.19904",
		"ID": "21"
	},
	"Boppelsen": {
		"y": "47.46945",
		"population": "1320",
		"x": "8.40614",
		"ID": "881"
	},
	"Lignerolle": {
		"y": "46.74291",
		"population": "389",
		"x": "6.45842",
		"ID": "62"
	},
	"Flaach": {
		"y": "47.57608",
		"population": "1349",
		"x": "8.60633",
		"ID": "977"
	},
	"Begnins": {
		"y": "46.44152",
		"population": "1793",
		"x": "6.24762",
		"ID": "35"
	},
	"Matzingen": {
		"y": "47.51957",
		"population": "2595",
		"x": "8.93365",
		"ID": "1147"
	},
	"Aarberg": {
		"y": "47.04439",
		"population": "4478",
		"x": "7.27578",
		"ID": "362"
	},
	"Prangins": {
		"y": "46.39518",
		"population": "4010",
		"x": "6.2496",
		"ID": "34"
	},
	"Waltalingen": {
		"y": "47.62203",
		"population": "668",
		"x": "8.77821",
		"ID": "1045"
	},
	"Ergisch": {
		"y": "46.29098",
		"population": "185",
		"x": "7.71307",
		"ID": "536"
	},
	"Champoz": {
		"y": "47.2558",
		"population": "161",
		"x": "7.29531",
		"ID": "367"
	},
	"Montilliez": {
		"y": "46.64601",
		"population": "1654",
		"x": "6.67991",
		"ID": "105"
	},
	"Fiez": {
		"y": "46.82716",
		"population": "417",
		"x": "6.62333",
		"ID": "96"
	},
	"Russy": {
		"y": "46.84126",
		"population": "214",
		"x": "7.00348",
		"ID": "233"
	},
	"Fischingen": {
		"y": "47.41422",
		"population": "2598",
		"x": "8.96862",
		"ID": "1145"
	},
	"Waltenschwil": {
		"y": "47.33493",
		"population": "2747",
		"x": "8.30344",
		"ID": "853"
	},
	"Gebenstorf": {
		"y": "47.48136",
		"population": "4941",
		"x": "8.23949",
		"ID": "806"
	},
	"Brig-Glis": {
		"y": "46.31667",
		"population": "12592",
		"x": "7.98333",
		"ID": "698"
	},
	"Saxon": {
		"y": "46.14937",
		"population": "5497",
		"x": "7.17514",
		"ID": "284"
	},
	"Bourg-en-Lavaux": {
		"y": "46.49575",
		"population": "5204",
		"x": "6.70901",
		"ID": "102"
	},
	"Bivio": {
		"y": "46.46852",
		"population": "178",
		"x": "9.65088",
		"ID": "1433"
	},
	"Knonau": {
		"y": "47.2235",
		"population": "2089",
		"x": "8.46197",
		"ID": "905"
	},
	"Mollens (VS)": {
		"y": "46.31652",
		"population": "970",
		"x": "7.52121",
		"ID": "439"
	},
	"Muntschemier": {
		"y": "46.99493",
		"population": "1319",
		"x": "7.14636",
		"ID": "300"
	},
	"Halten": {
		"y": "47.16883",
		"population": "868",
		"x": "7.60348",
		"ID": "519"
	},
	"Bolken": {
		"y": "47.19123",
		"population": "564",
		"x": "7.66305",
		"ID": "553"
	},
	"Staffelbach": {
		"y": "47.28306",
		"population": "1075",
		"x": "8.0387",
		"ID": "746"
	},
	"Vetroz": {
		"y": "46.22171",
		"population": "5845",
		"x": "7.27858",
		"ID": "347"
	},
	"Crassier": {
		"y": "46.37465",
		"population": "1172",
		"x": "6.16367",
		"ID": "24"
	},
	"Selzach": {
		"y": "47.20531",
		"population": "3242",
		"x": "7.45521",
		"ID": "456"
	},
	"Freienstein-Teufen": {
		"y": "47.53575",
		"population": "2267",
		"x": "8.59045",
		"ID": "976"
	},
	"Verdabbio": {
		"y": "46.26846",
		"population": "162",
		"x": "9.15723",
		"ID": "1258"
	},
	"Medel (Lucmagn)": {
		"y": "46.62419",
		"population": "376",
		"x": "8.85515",
		"ID": "1094"
	},
	"Bettenhausen": {
		"y": "47.17148",
		"population": "654",
		"x": "7.71575",
		"ID": "553"
	},
	"Beinwil (SO)": {
		"y": "47.36262",
		"population": "265",
		"x": "7.58707",
		"ID": "523"
	},
	"Casti-Wergenstein": {
		"y": "46.61593",
		"population": "52",
		"x": "9.35401",
		"ID": "1341"
	},
	"Murten": {
		"y": "46.92827",
		"population": "6554",
		"x": "7.11715",
		"ID": "267"
	},
	"Domat/Ems": {
		"y": "46.83483",
		"population": "7832",
		"x": "9.45075",
		"ID": "1370"
	},
	"Neerach": {
		"y": "47.51096",
		"population": "3030",
		"x": "8.47099",
		"ID": "911"
	},
	"Kaltbrunn": {
		"y": "47.21367",
		"population": "4664",
		"x": "9.0259",
		"ID": "1177"
	},
	"Avully": {
		"y": "46.17005",
		"population": "1750",
		"x": "6.00459",
		"ID": "3"
	},
	"Munsterlingen": {
		"y": "47.63197",
		"population": "3161",
		"x": "9.23271",
		"ID": "1285"
	},
	"Mathon": {
		"y": "46.63603",
		"population": "52",
		"x": "9.4138",
		"ID": "1342"
	},
	"Vevey": {
		"y": "46.46299",
		"population": "18890",
		"x": "6.84345",
		"ID": "143"
	},
	"Fribourg": {
		"y": "46.80237",
		"population": "36954",
		"x": "7.15128",
		"ID": "297"
	},
	"Founex": {
		"y": "46.33277",
		"population": "3598",
		"x": "6.19243",
		"ID": "23"
	},
	"Vellerat": {
		"y": "47.32031",
		"population": "69",
		"x": "7.36996",
		"ID": "398"
	},
	"Roschenz": {
		"y": "47.42366",
		"population": "1837",
		"x": "7.48024",
		"ID": "460"
	},
	"Schluein": {
		"y": "46.78819",
		"population": "547",
		"x": "9.22603",
		"ID": "1297"
	},
	"Kriens": {
		"y": "47.03537",
		"population": "26537",
		"x": "8.27631",
		"ID": "823"
	},
	"Neuchatel": {
		"y": "46.99179",
		"population": "32613",
		"x": "6.931",
		"ID": "203"
	},
	"Gorgier": {
		"y": "46.90143",
		"population": "1991",
		"x": "6.77985",
		"ID": "130"
	},
	"Schmitten (GR)": {
		"y": "46.68686",
		"population": "238",
		"x": "9.67317",
		"ID": "1437"
	},
	"Heiden": {
		"y": "47.44255",
		"population": "4086",
		"x": "9.53293",
		"ID": "1406"
	},
	"Montanaire": {
		"y": "46.69719",
		"population": "2408",
		"x": "6.75493",
		"ID": "126"
	},
	"Felben-Wellhausen": {
		"y": "47.57914",
		"population": "2668",
		"x": "8.94221",
		"ID": "1148"
	},
	"Lamone": {
		"y": "46.0453",
		"population": "1765",
		"x": "8.93158",
		"ID": "1119"
	},
	"La Folliaz": {
		"y": "46.74266",
		"population": "950",
		"x": "6.96717",
		"ID": "198"
	},
	"Hemmiken": {
		"y": "47.48882",
		"population": "269",
		"x": "7.89376",
		"ID": "659"
	},
	"Furna": {
		"y": "46.93694",
		"population": "208",
		"x": "9.67874",
		"ID": "1442"
	},
	"Villigen": {
		"y": "47.52682",
		"population": "2008",
		"x": "8.21486",
		"ID": "807"
	},
	"Saint-Saphorin (Lavaux)": {
		"y": "46.47902",
		"population": "381",
		"x": "6.79318",
		"ID": "143"
	},
	"Vullierens": {
		"y": "46.57397",
		"population": "451",
		"x": "6.48193",
		"ID": "69"
	},
	"Zumholz": {
		"y": "46.75462",
		"population": "392",
		"x": "7.29146",
		"ID": "357"
	},
	"Rothenbrunnen": {
		"y": "46.76948",
		"population": "299",
		"x": "9.42608",
		"ID": "1369"
	},
	"Bergun/Bravuogn": {
		"y": "46.62934",
		"population": "501",
		"x": "9.74762",
		"ID": "1468"
	},
	"Metzerlen-Mariastein": {
		"y": "47.46589",
		"population": "877",
		"x": "7.47105",
		"ID": "461"
	},
	"Sils im Domleschg": {
		"y": "46.70041",
		"population": "919",
		"x": "9.45404",
		"ID": "1368"
	},
	"Amden": {
		"y": "47.14888",
		"population": "1733",
		"x": "9.14233",
		"ID": "1245"
	},
	"Rorschach": {
		"y": "47.478",
		"population": "9027",
		"x": "9.4903",
		"ID": "1383"
	},
	"La Chaux-du-Milieu": {
		"y": "47.01257",
		"population": "499",
		"x": "6.70724",
		"ID": "112"
	},
	"Grindel": {
		"y": "47.38069",
		"population": "476",
		"x": "7.50591",
		"ID": "459"
	},
	"Bowil": {
		"y": "46.89304",
		"population": "1346",
		"x": "7.69757",
		"ID": "548"
	},
	"Menieres": {
		"y": "46.78268",
		"population": "413",
		"x": "6.88014",
		"ID": "171"
	},
	"Gampel-Bratsch": {
		"y": "46.31599",
		"population": "1899",
		"x": "7.7421",
		"ID": "570"
	},
	"Stetten (SH)": {
		"y": "47.74025",
		"population": "1320",
		"x": "8.66298",
		"ID": "1013"
	},
	"Ruti (ZH)": {
		"y": "47.25603",
		"population": "11793",
		"x": "8.85552",
		"ID": "1106"
	},
	"Porrentruy": {
		"y": "47.41475",
		"population": "6638",
		"x": "7.07638",
		"ID": "276"
	},
	"Maienfeld": {
		"y": "47.00472",
		"population": "2739",
		"x": "9.53115",
		"ID": "1398"
	},
	"Motschwil": {
		"y": "47.04581",
		"population": "133",
		"x": "7.5694",
		"ID": "484"
	},
	"Fraschels": {
		"y": "46.99788",
		"population": "458",
		"x": "7.20806",
		"ID": "332"
	},
	"Valeyres-sous-Rances": {
		"y": "46.74824",
		"population": "600",
		"x": "6.5354",
		"ID": "73"
	},
	"Ingenbohl": {
		"y": "46.9988",
		"population": "8256",
		"x": "8.61529",
		"ID": "966"
	},
	"Chavannes-le-Veyron": {
		"y": "46.607",
		"population": "120",
		"x": "6.45086",
		"ID": "60"
	},
	"Goschenen": {
		"y": "46.66816",
		"population": "423",
		"x": "8.58709",
		"ID": "959"
	},
	"Bister": {
		"y": "46.36033",
		"population": "31",
		"x": "8.06445",
		"ID": "728"
	},
	"Saubraz": {
		"y": "46.51635",
		"population": "386",
		"x": "6.3307",
		"ID": "44"
	},
	"Hauterive (NE)": {
		"y": "47.01233",
		"population": "2598",
		"x": "6.97615",
		"ID": "203"
	},
	"Binningen": {
		"y": "47.54021",
		"population": "14889",
		"x": "7.56932",
		"ID": "494"
	},
	"Richterswil": {
		"y": "47.20622",
		"population": "13053",
		"x": "8.69686",
		"ID": "1003"
	},
	"Val-de-Ruz": {
		"y": "47.04008",
		"population": "16454",
		"x": "6.90829",
		"ID": "176"
	},
	"Collombey-Muraz": {
		"y": "46.27385",
		"population": "8577",
		"x": "6.94789",
		"ID": "189"
	},
	"Bellmund": {
		"y": "47.10852",
		"population": "1617",
		"x": "7.24608",
		"ID": "334"
	},
	"Barschwil": {
		"y": "47.3822",
		"population": "799",
		"x": "7.47229",
		"ID": "459"
	},
	"Buchs (AG)": {
		"y": "47.39358",
		"population": "7605",
		"x": "8.08233",
		"ID": "748"
	},
	"Schleitheim": {
		"y": "47.75",
		"population": "1662",
		"x": "8.51111",
		"ID": "915"
	},
	"Niederdorf": {
		"y": "47.40945",
		"population": "1763",
		"x": "7.74957",
		"ID": "591"
	},
	"Remigen": {
		"y": "47.5186",
		"population": "1049",
		"x": "8.185",
		"ID": "780"
	},
	"Les Montets": {
		"y": "46.80781",
		"population": "1338",
		"x": "6.8581",
		"ID": "172"
	},
	"Gunsberg": {
		"y": "47.25311",
		"population": "1137",
		"x": "7.55825",
		"ID": "488"
	},
	"Faido": {
		"y": "46.477",
		"population": "2816",
		"x": "8.80125",
		"ID": "1056"
	},
	"Marthalen": {
		"y": "47.62913",
		"population": "1935",
		"x": "8.65326",
		"ID": "1011"
	},
	"Ettiswil": {
		"y": "47.15031",
		"population": "2599",
		"x": "8.01759",
		"ID": "714"
	},
	"Villars-le-Comte": {
		"y": "46.7131",
		"population": "150",
		"x": "6.80136",
		"ID": "126"
	},
	"Obfelden": {
		"y": "47.26413",
		"population": "4977",
		"x": "8.4215",
		"ID": "877"
	},
	"Bruttelen": {
		"y": "47.02269",
		"population": "561",
		"x": "7.14793",
		"ID": "301"
	},
	"Rossemaison": {
		"y": "47.34434",
		"population": "600",
		"x": "7.3409",
		"ID": "399"
	},
	"Weggis": {
		"y": "47.03208",
		"population": "4132",
		"x": "8.43219",
		"ID": "873"
	},
	"Seengen": {
		"y": "47.32852",
		"population": "3750",
		"x": "8.20509",
		"ID": "803"
	},
	"Belmont-sur-Lausanne": {
		"y": "46.51891",
		"population": "3576",
		"x": "6.67636",
		"ID": "103"
	},
	"Lavertezzo": {
		"y": "46.25893",
		"population": "1318",
		"x": "8.83756",
		"ID": "1086"
	},
	"Mezieres (VD)": {
		"y": "46.59148",
		"population": "1203",
		"x": "6.76575",
		"ID": "124"
	},
	"Seftigen": {
		"y": "46.78765",
		"population": "2185",
		"x": "7.53937",
		"ID": "479"
	},
	"Nufenen": {
		"y": "46.5394",
		"population": "153",
		"x": "9.24353",
		"ID": "1292"
	},
	"Heitenried": {
		"y": "46.82762",
		"population": "1362",
		"x": "7.29944",
		"ID": "358"
	},
	"Schubelbach": {
		"y": "47.17326",
		"population": "8916",
		"x": "8.92811",
		"ID": "1141"
	},
	"Bursinel": {
		"y": "46.43957",
		"population": "471",
		"x": "6.30581",
		"ID": "42"
	},
	"Eschert": {
		"y": "47.27503",
		"population": "371",
		"x": "7.40334",
		"ID": "427"
	},
	"Mellingen": {
		"y": "47.41903",
		"population": "5291",
		"x": "8.27331",
		"ID": "830"
	},
	"Attelwil": {
		"y": "47.26223",
		"population": "281",
		"x": "8.04469",
		"ID": "716"
	},
	"Klosters-Serneus": {
		"y": "46.88918",
		"population": "3762",
		"x": "9.83826",
		"ID": "1487"
	},
	"Pfungen": {
		"y": "47.51394",
		"population": "3736",
		"x": "8.6423",
		"ID": "1009"
	},
	"Oberburg": {
		"y": "47.03774",
		"population": "2866",
		"x": "7.62652",
		"ID": "517"
	},
	"Schonenberg (ZH)": {
		"y": "47.19182",
		"population": "1836",
		"x": "8.64494",
		"ID": "1003"
	},
	"Valsot": {
		"y": "46.88372",
		"population": "902",
		"x": "10.39754",
		"ID": "1585"
	},
	"Willisau": {
		"y": "47.17125",
		"population": "7551",
		"x": "7.96775",
		"ID": "684"
	},
	"Nuvilly": {
		"y": "46.78336",
		"population": "401",
		"x": "6.82778",
		"ID": "149"
	},
	"Botterens": {
		"y": "46.62502",
		"population": "543",
		"x": "7.11548",
		"ID": "261"
	},
	"Onsernone": {
		"y": "46.2035",
		"population": "236",
		"x": "8.58662",
		"ID": "950"
	},
	"Beinwil (Freiamt)": {
		"y": "47.22956",
		"population": "1071",
		"x": "8.3392",
		"ID": "851"
	},
	"Pollegio": {
		"y": "46.36486",
		"population": "728",
		"x": "8.94839",
		"ID": "1125"
	},
	"Rebstein": {
		"y": "47.39812",
		"population": "4414",
		"x": "9.58503",
		"ID": "1426"
	},
	"Vionnaz": {
		"y": "46.31101",
		"population": "2514",
		"x": "6.90062",
		"ID": "162"
	},
	"Runenberg": {
		"y": "47.43477",
		"population": "773",
		"x": "7.8829",
		"ID": "657"
	},
	"Reckingen-Gluringen": {
		"y": "46.46989",
		"population": "436",
		"x": "8.24164",
		"ID": "812"
	},
	"Schlatt (TG)": {
		"y": "47.66134",
		"population": "1629",
		"x": "8.70332",
		"ID": "1012"
	},
	"Vuissens": {
		"y": "46.73342",
		"population": "244",
		"x": "6.76625",
		"ID": "126"
	},
	"Bonfol": {
		"y": "47.47735",
		"population": "659",
		"x": "7.15144",
		"ID": "310"
	},
	"Niederonz": {
		"y": "47.18289",
		"population": "1628",
		"x": "7.68047",
		"ID": "553"
	},
	"Brione sopra Minusio": {
		"y": "46.18417",
		"population": "486",
		"x": "8.81421",
		"ID": "1085"
	},
	"Hasliberg": {
		"y": "46.74645",
		"population": "1111",
		"x": "8.22839",
		"ID": "792"
	},
	"Adliswil": {
		"y": "47.30997",
		"population": "18382",
		"x": "8.52462",
		"ID": "938"
	},
	"Croy": {
		"y": "46.695",
		"population": "315",
		"x": "6.47676",
		"ID": "72"
	},
	"Hochstetten": {
		"y": "47.14505",
		"population": "266",
		"x": "7.63134",
		"ID": "519"
	},
	"Oberruti": {
		"y": "47.16673",
		"population": "1498",
		"x": "8.39441",
		"ID": "875"
	},
	"Carrouge (VD)": {
		"y": "46.60457",
		"population": "1206",
		"x": "6.77067",
		"ID": "124"
	},
	"Vulliens": {
		"y": "46.62405",
		"population": "460",
		"x": "6.79596",
		"ID": "146"
	},
	"Gachnang": {
		"y": "47.53935",
		"population": "3958",
		"x": "8.85311",
		"ID": "1111"
	},
	"Wolhusen": {
		"y": "47.05983",
		"population": "4217",
		"x": "8.07389",
		"ID": "742"
	},
	"Wangenried": {
		"y": "47.21713",
		"population": "420",
		"x": "7.65565",
		"ID": "554"
	},
	"Gondiswil": {
		"y": "47.14677",
		"population": "731",
		"x": "7.87136",
		"ID": "652"
	},
	"Meyrin": {
		"y": "46.23424",
		"population": "21314",
		"x": "6.08025",
		"ID": "12"
	},
	"Grossaffoltern": {
		"y": "47.06595",
		"population": "2950",
		"x": "7.36232",
		"ID": "393"
	},
	"Uttigen": {
		"y": "46.79435",
		"population": "1919",
		"x": "7.57789",
		"ID": "512"
	},
	"Curtilles": {
		"y": "46.70108",
		"population": "311",
		"x": "6.84505",
		"ID": "147"
	},
	"Darstetten": {
		"y": "46.65948",
		"population": "825",
		"x": "7.49111",
		"ID": "446"
	},
	"Langenthal": {
		"y": "47.21526",
		"population": "15144",
		"x": "7.79607",
		"ID": "620"
	},
	"Homburg": {
		"y": "47.63469",
		"population": "1506",
		"x": "9.00756",
		"ID": "1185"
	},
	"Landiswil": {
		"y": "46.95815",
		"population": "612",
		"x": "7.68027",
		"ID": "549"
	},
	"Seewen": {
		"y": "47.43738",
		"population": "1015",
		"x": "7.6615",
		"ID": "558"
	},
	"Bremgarten (AG)": {
		"y": "47.35109",
		"population": "7703",
		"x": "8.34214",
		"ID": "853"
	},
	"Vacallo": {
		"y": "45.84466",
		"population": "3362",
		"x": "9.03335",
		"ID": "1187"
	},
	"Glattfelden": {
		"y": "47.55871",
		"population": "4881",
		"x": "8.50167",
		"ID": "911"
	},
	"Grachen": {
		"y": "46.19529",
		"population": "1341",
		"x": "7.83745",
		"ID": "600"
	},
	"Trubschachen": {
		"y": "46.92228",
		"population": "1369",
		"x": "7.8452",
		"ID": "614"
	},
	"Oppens": {
		"y": "46.71396",
		"population": "182",
		"x": "6.69168",
		"ID": "107"
	},
	"Forel-sur-Lucens": {
		"y": "46.72635",
		"population": "152",
		"x": "6.82421",
		"ID": "148"
	},
	"Ochlenberg": {
		"y": "47.14953",
		"population": "564",
		"x": "7.73603",
		"ID": "586"
	},
	"Leytron": {
		"y": "46.1866",
		"population": "3047",
		"x": "7.2078",
		"ID": "316"
	},
	"Hergiswil bei Willisau": {
		"y": "47.08498",
		"population": "1847",
		"x": "7.95799",
		"ID": "682"
	},
	"Birsfelden": {
		"y": "47.5529",
		"population": "10045",
		"x": "7.62322",
		"ID": "527"
	},
	"Fehraltorf": {
		"y": "47.38775",
		"population": "6254",
		"x": "8.75149",
		"ID": "1040"
	},
	"Magenwil": {
		"y": "47.41252",
		"population": "2061",
		"x": "8.23297",
		"ID": "805"
	},
	"Fully": {
		"y": "46.17894",
		"population": "8418",
		"x": "7.09365",
		"ID": "252"
	},
	"Lohn (SH)": {
		"y": "47.75508",
		"population": "751",
		"x": "8.66847",
		"ID": "1014"
	},
	"Laupen": {
		"y": "46.90214",
		"population": "3027",
		"x": "7.23973",
		"ID": "330"
	},
	"Willadingen": {
		"y": "47.14667",
		"population": "202",
		"x": "7.61112",
		"ID": "519"
	},
	"Rheinfelden": {
		"y": "47.56013",
		"population": "12979",
		"x": "7.78715",
		"ID": "594"
	},
	"Meinisberg": {
		"y": "47.15965",
		"population": "1312",
		"x": "7.34801",
		"ID": "395"
	},
	"Autigny": {
		"y": "46.73661",
		"population": "794",
		"x": "7.01998",
		"ID": "231"
	},
	"Stusslingen": {
		"y": "47.39427",
		"population": "1067",
		"x": "7.97426",
		"ID": "688"
	},
	"Buren an der Aare": {
		"y": "47.13976",
		"population": "3469",
		"x": "7.3722",
		"ID": "395"
	},
	"Siselen": {
		"y": "47.03251",
		"population": "574",
		"x": "7.19119",
		"ID": "333"
	},
	"Trub": {
		"y": "46.94168",
		"population": "1306",
		"x": "7.87996",
		"ID": "648"
	},
	"Altikon": {
		"y": "47.57404",
		"population": "646",
		"x": "8.78282",
		"ID": "1077"
	},
	"Hutten": {
		"y": "47.17573",
		"population": "886",
		"x": "8.66655",
		"ID": "1003"
	},
	"Hunzenschwil": {
		"y": "47.38417",
		"population": "3846",
		"x": "8.12293",
		"ID": "778"
	},
	"Rickenbach (SO)": {
		"y": "47.34239",
		"population": "818",
		"x": "7.85469",
		"ID": "656"
	},
	"Opfikon": {
		"y": "47.43169",
		"population": "18389",
		"x": "8.57588",
		"ID": "974"
	},
	"Wigoltingen": {
		"y": "47.5977",
		"population": "2349",
		"x": "9.03141",
		"ID": "1184"
	},
	"Dulliken": {
		"y": "47.34476",
		"population": "4819",
		"x": "7.94623",
		"ID": "687"
	},
	"Sumiswald": {
		"y": "47.02747",
		"population": "4910",
		"x": "7.74526",
		"ID": "584"
	},
	"Guttingen": {
		"y": "47.60349",
		"population": "1560",
		"x": "9.28742",
		"ID": "1312"
	},
	"Ramlinsburg": {
		"y": "47.44913",
		"population": "692",
		"x": "7.76956",
		"ID": "592"
	},
	"Birrwil": {
		"y": "47.2886",
		"population": "1123",
		"x": "8.20004",
		"ID": "802"
	},
	"Rekingen (AG)": {
		"y": "47.57009",
		"population": "939",
		"x": "8.3188",
		"ID": "833"
	},
	"Wolflinswil": {
		"y": "47.4607",
		"population": "996",
		"x": "7.99835",
		"ID": "720"
	},
	"Schwerzenbach": {
		"y": "47.38213",
		"population": "4947",
		"x": "8.65727",
		"ID": "1007"
	},
	"Schwyz": {
		"y": "47.02076",
		"population": "14570",
		"x": "8.65414",
		"ID": "1000"
	},
	"Matten bei Interlaken": {
		"y": "46.67833",
		"population": "3861",
		"x": "7.86889",
		"ID": "643"
	},
	"Cudrefin": {
		"y": "46.95577",
		"population": "1501",
		"x": "7.01855",
		"ID": "235"
	},
	"Buch (SH)": {
		"y": "47.71744",
		"population": "315",
		"x": "8.78151",
		"ID": "1080"
	},
	"Haut-Vully": {
		"y": "46.9573",
		"population": "1363",
		"x": "7.07226",
		"ID": "267"
	},
	"Eptingen": {
		"y": "47.38474",
		"population": "528",
		"x": "7.81898",
		"ID": "623"
	},
	"Jouxtens-Mezery": {
		"y": "46.55185",
		"population": "1414",
		"x": "6.59605",
		"ID": "91"
	},
	"Rossenges": {
		"y": "46.6535",
		"population": "65",
		"x": "6.77597",
		"ID": "125"
	},
	"Neftenbach": {
		"y": "47.52764",
		"population": "5484",
		"x": "8.6649",
		"ID": "1009"
	},
	"Grens": {
		"y": "46.39401",
		"population": "386",
		"x": "6.19114",
		"ID": "25"
	},
	"Sergey": {
		"y": "46.7493",
		"population": "144",
		"x": "6.50127",
		"ID": "73"
	},
	"Schlosswil": {
		"y": "46.90869",
		"population": "626",
		"x": "7.61171",
		"ID": "514"
	},
	"Puplinge": {
		"y": "46.21043",
		"population": "2097",
		"x": "6.23114",
		"ID": "31"
	},
	"Munchwilen (TG)": {
		"y": "47.47719",
		"population": "5181",
		"x": "8.99677",
		"ID": "1182"
	},
	"Bettmeralp": {
		"y": "46.39022",
		"population": "444",
		"x": "8.06254",
		"ID": "729"
	},
	"Corgemont": {
		"y": "47.19457",
		"population": "1651",
		"x": "7.14517",
		"ID": "304"
	},
	"Courchapoix": {
		"y": "47.34734",
		"population": "425",
		"x": "7.45142",
		"ID": "459"
	},
	"Mesocco": {
		"y": "46.3939",
		"population": "1329",
		"x": "9.23333",
		"ID": "1289"
	},
	"Sullens": {
		"y": "46.59557",
		"population": "924",
		"x": "6.56687",
		"ID": "80"
	},
	"Alle": {
		"y": "47.42618",
		"population": "1748",
		"x": "7.12911",
		"ID": "309"
	},
	"Noflen": {
		"y": "46.8056",
		"population": "299",
		"x": "7.5433",
		"ID": "480"
	},
	"Niedermuhlern": {
		"y": "46.8606",
		"population": "458",
		"x": "7.46581",
		"ID": "449"
	},
	"Buckten": {
		"y": "47.4099",
		"population": "689",
		"x": "7.84481",
		"ID": "657"
	},
	"Gruyeres": {
		"y": "46.58365",
		"population": "2118",
		"x": "7.08253",
		"ID": "260"
	},
	"Schinznach": {
		"y": "47.4465",
		"population": "2211",
		"x": "8.14089",
		"ID": "779"
	},
	"Burg im Leimental": {
		"y": "47.45957",
		"population": "260",
		"x": "7.43808",
		"ID": "430"
	},
	"Bolligen": {
		"y": "46.9751",
		"population": "6074",
		"x": "7.49697",
		"ID": "452"
	},
	"Prilly": {
		"y": "46.53698",
		"population": "11901",
		"x": "6.60456",
		"ID": "91"
	},
	"Villaz-Saint-Pierre": {
		"y": "46.72074",
		"population": "1177",
		"x": "6.95638",
		"ID": "198"
	},
	"Geneve": {
		"y": "46.20222",
		"population": "184304",
		"x": "6.14569",
		"ID": "11"
	},
	"Zizers": {
		"y": "46.93575",
		"population": "3315",
		"x": "9.56491",
		"ID": "1421"
	},
	"Ponte Capriasca": {
		"y": "46.06055",
		"population": "1865",
		"x": "8.94819",
		"ID": "1155"
	},
	"Morens (FR)": {
		"y": "46.84364",
		"population": "154",
		"x": "6.90697",
		"ID": "173"
	},
	"Maracon": {
		"y": "46.55",
		"population": "444",
		"x": "6.87097",
		"ID": "167"
	},
	"Wolfhalden": {
		"y": "47.4527",
		"population": "1769",
		"x": "9.54815",
		"ID": "1407"
	},
	"Lussy-sur-Morges": {
		"y": "46.50409",
		"population": "627",
		"x": "6.45",
		"ID": "58"
	},
	"Russin": {
		"y": "46.18696",
		"population": "517",
		"x": "6.01381",
		"ID": "3"
	},
	"Courtedoux": {
		"y": "47.40819",
		"population": "762",
		"x": "7.04281",
		"ID": "243"
	},
	"Villorsonnens": {
		"y": "46.70739",
		"population": "1267",
		"x": "7.00017",
		"ID": "230"
	},
	"Chatel-sur-Montsalvens": {
		"y": "46.61652",
		"population": "270",
		"x": "7.13266",
		"ID": "293"
	},
	"Kirchleerau": {
		"y": "47.27724",
		"population": "835",
		"x": "8.07405",
		"ID": "746"
	},
	"Reiden": {
		"y": "47.24719",
		"population": "6874",
		"x": "7.97135",
		"ID": "685"
	},
	"Obersteckholz": {
		"y": "47.19931",
		"population": "402",
		"x": "7.81706",
		"ID": "619"
	},
	"Kloten": {
		"y": "47.45152",
		"population": "18209",
		"x": "8.58491",
		"ID": "974"
	},
	"Wiggiswil": {
		"y": "47.03131",
		"population": "98",
		"x": "7.47086",
		"ID": "453"
	},
	"Hermiswil": {
		"y": "47.15593",
		"population": "96",
		"x": "7.70056",
		"ID": "553"
	},
	"Wikon": {
		"y": "47.26339",
		"population": "1448",
		"x": "7.96801",
		"ID": "686"
	},
	"Morigen": {
		"y": "47.0851",
		"population": "832",
		"x": "7.21413",
		"ID": "334"
	},
	"Horrenbach-Buchen": {
		"y": "46.78773",
		"population": "236",
		"x": "7.77102",
		"ID": "579"
	},
	"Jonschwil": {
		"y": "47.42402",
		"population": "3736",
		"x": "9.08689",
		"ID": "1217"
	},
	"Martigny": {
		"y": "46.10276",
		"population": "17254",
		"x": "7.07245",
		"ID": "251"
	},
	"Manno": {
		"y": "46.02885",
		"population": "1290",
		"x": "8.91824",
		"ID": "1119"
	},
	"Andermatt": {
		"y": "46.63565",
		"population": "1365",
		"x": "8.59388",
		"ID": "959"
	},
	"Mont-Noble": {
		"y": "46.20747",
		"population": "1016",
		"x": "7.49047",
		"ID": "437"
	},
	"Morlon": {
		"y": "46.62563",
		"population": "585",
		"x": "7.08382",
		"ID": "261"
	},
	"Haldenstein": {
		"y": "46.87867",
		"population": "1018",
		"x": "9.52618",
		"ID": "1396"
	},
	"Russikon": {
		"y": "47.39669",
		"population": "4255",
		"x": "8.77515",
		"ID": "1074"
	},
	"Flums": {
		"y": "47.09058",
		"population": "4802",
		"x": "9.34301",
		"ID": "1328"
	},
	"Gaiserwald": {
		"y": "47.45",
		"population": "8262",
		"x": "9.33333",
		"ID": "1335"
	},
	"Steg-Hohtenn": {
		"y": "46.31893",
		"population": "1543",
		"x": "7.75573",
		"ID": "570"
	},
	"Yens": {
		"y": "46.51901",
		"population": "1379",
		"x": "6.4185",
		"ID": "58"
	},
	"Hornussen": {
		"y": "47.50025",
		"population": "928",
		"x": "8.06125",
		"ID": "750"
	},
	"Oulens-sous-Echallens": {
		"y": "46.64378",
		"population": "525",
		"x": "6.57703",
		"ID": "81"
	},
	"Torny": {
		"y": "46.77093",
		"population": "875",
		"x": "6.95801",
		"ID": "199"
	},
	"Poliez-Pittet": {
		"y": "46.62735",
		"population": "806",
		"x": "6.68813",
		"ID": "105"
	},
	"Leuzigen": {
		"y": "47.17458",
		"population": "1238",
		"x": "7.45775",
		"ID": "425"
	},
	"La Chaux-des-Breuleux": {
		"y": "47.2221",
		"population": "85",
		"x": "7.02829",
		"ID": "240"
	},
	"Waldi": {
		"y": "47.63421",
		"population": "1026",
		"x": "9.09504",
		"ID": "1222"
	},
	"Werthenstein": {
		"y": "47.05578",
		"population": "1972",
		"x": "8.10182",
		"ID": "742"
	},
	"Plaffeien": {
		"y": "46.74198",
		"population": "1947",
		"x": "7.28666",
		"ID": "357"
	},
	"Cornaux": {
		"y": "47.0396",
		"population": "1580",
		"x": "7.01872",
		"ID": "236"
	},
	"Luzern": {
		"y": "47.05048",
		"population": "79250",
		"x": "8.30635",
		"ID": "823"
	},
	"Guttannen": {
		"y": "46.65511",
		"population": "291",
		"x": "8.28951",
		"ID": "840"
	},
	"Loveresse": {
		"y": "47.24387",
		"population": "317",
		"x": "7.23881",
		"ID": "337"
	},
	"Bever": {
		"y": "46.55",
		"population": "625",
		"x": "9.88333",
		"ID": "1494"
	},
	"Kerzers": {
		"y": "46.97586",
		"population": "4813",
		"x": "7.1957",
		"ID": "332"
	},
	"Bourrignon": {
		"y": "47.39551",
		"population": "264",
		"x": "7.24542",
		"ID": "340"
	},
	"Fischbach-Goslikon": {
		"y": "47.36912",
		"population": "1620",
		"x": "8.31108",
		"ID": "854"
	},
	"Walliswil bei Niederbipp": {
		"y": "47.23614",
		"population": "222",
		"x": "7.69525",
		"ID": "554"
	},
	"Leissigen": {
		"y": "46.6546",
		"population": "1000",
		"x": "7.77548",
		"ID": "609"
	},
	"Huttikon": {
		"y": "47.4426",
		"population": "877",
		"x": "8.38807",
		"ID": "881"
	},
	"Buchegg": {
		"y": "47.1425",
		"population": "2485",
		"x": "7.50976",
		"ID": "455"
	},
	"Durrenasch": {
		"y": "47.31812",
		"population": "1208",
		"x": "8.1585",
		"ID": "776"
	},
	"Merzligen": {
		"y": "47.08729",
		"population": "400",
		"x": "7.25376",
		"ID": "363"
	},
	"Oberlunkhofen": {
		"y": "47.3115",
		"population": "1904",
		"x": "8.39142",
		"ID": "878"
	},
	"Besenburen": {
		"y": "47.31439",
		"population": "603",
		"x": "8.34586",
		"ID": "853"
	},
	"Muri bei Bern": {
		"y": "46.93122",
		"population": "12580",
		"x": "7.48658",
		"ID": "451"
	},
	"Martigny-Combe": {
		"y": "46.07817",
		"population": "2313",
		"x": "7.05099",
		"ID": "218"
	},
	"Wilderswil": {
		"y": "46.66369",
		"population": "2603",
		"x": "7.86175",
		"ID": "643"
	},
	"Schonenbuch": {
		"y": "47.53853",
		"population": "1367",
		"x": "7.50572",
		"ID": "462"
	},
	"Unteriberg": {
		"y": "47.06258",
		"population": "2306",
		"x": "8.8052",
		"ID": "1067"
	},
	"Basel": {
		"y": "47.55839",
		"population": "165124",
		"x": "7.57327",
		"ID": "494"
	},
	"Ufhusen": {
		"y": "47.11647",
		"population": "876",
		"x": "7.89623",
		"ID": "651"
	},
	"Schwellbrunn": {
		"y": "47.35255",
		"population": "1486",
		"x": "9.24894",
		"ID": "1308"
	},
	"Rehetobel": {
		"y": "47.42611",
		"population": "1660",
		"x": "9.483",
		"ID": "1382"
	},
	"Le Bemont (JU)": {
		"y": "47.26298",
		"population": "316",
		"x": "7.0152",
		"ID": "241"
	},
	"Staufen": {
		"y": "47.38372",
		"population": "2912",
		"x": "8.16606",
		"ID": "778"
	},
	"Uebeschi": {
		"y": "46.73948",
		"population": "669",
		"x": "7.54728",
		"ID": "479"
	},
	"Huttwilen": {
		"y": "47.60674",
		"population": "1655",
		"x": "8.87343",
		"ID": "1112"
	},
	"Burglen (UR)": {
		"y": "46.87565",
		"population": "3911",
		"x": "8.66539",
		"ID": "997"
	},
	"Chiasso": {
		"y": "45.83203",
		"population": "7894",
		"x": "9.03119",
		"ID": "1187"
	},
	"Giffers": {
		"y": "46.7623",
		"population": "1514",
		"x": "7.20845",
		"ID": "328"
	},
	"Thalwil": {
		"y": "47.29175",
		"population": "17578",
		"x": "8.56351",
		"ID": "938"
	},
	"Boudry": {
		"y": "46.94991",
		"population": "5607",
		"x": "6.83757",
		"ID": "152"
	},
	"Severy": {
		"y": "46.57347",
		"population": "227",
		"x": "6.44171",
		"ID": "59"
	},
	"Radelfingen": {
		"y": "47.02146",
		"population": "1246",
		"x": "7.27178",
		"ID": "362"
	},
	"Roggwil (BE)": {
		"y": "47.24119",
		"population": "3869",
		"x": "7.82141",
		"ID": "620"
	},
	"Unterentfelden": {
		"y": "47.36836",
		"population": "4035",
		"x": "8.0427",
		"ID": "718"
	},
	"Puidoux": {
		"y": "46.50093",
		"population": "2849",
		"x": "6.78249",
		"ID": "122"
	},
	"Zielebach": {
		"y": "47.15803",
		"population": "321",
		"x": "7.57291",
		"ID": "487"
	},
	"Cormoret": {
		"y": "47.17078",
		"population": "481",
		"x": "7.05421",
		"ID": "239"
	},
	"Vitznau": {
		"y": "47.01014",
		"population": "1306",
		"x": "8.4842",
		"ID": "901"
	},
	"Hagenbuch": {
		"y": "47.52035",
		"population": "1102",
		"x": "8.8892",
		"ID": "1111"
	},
	"Aesch (ZH)": {
		"y": "47.33674",
		"population": "1192",
		"x": "8.44099",
		"ID": "907"
	},
	"Collina d'Oro": {
		"y": "45.97719",
		"population": "4643",
		"x": "8.91976",
		"ID": "1118"
	},
	"Wallbach": {
		"y": "47.56806",
		"population": "1887",
		"x": "7.89785",
		"ID": "660"
	},
	"Brutten": {
		"y": "47.47318",
		"population": "2002",
		"x": "8.67569",
		"ID": "1008"
	},
	"Verossaz": {
		"y": "46.21221",
		"population": "705",
		"x": "6.9863",
		"ID": "188"
	},
	"Walkringen": {
		"y": "46.94856",
		"population": "1711",
		"x": "7.6204",
		"ID": "515"
	},
	"St. Silvester": {
		"y": "46.74246",
		"population": "957",
		"x": "7.22401",
		"ID": "327"
	},
	"Courtepin": {
		"y": "46.86547",
		"population": "3658",
		"x": "7.12309",
		"ID": "298"
	},
	"Muhledorf (BE)": {
		"y": "46.82798",
		"population": "240",
		"x": "7.52994",
		"ID": "480"
	},
	"Bariswil": {
		"y": "47.01947",
		"population": "1010",
		"x": "7.52709",
		"ID": "484"
	},
	"Wittinsburg": {
		"y": "47.42521",
		"population": "426",
		"x": "7.84128",
		"ID": "624"
	},
	"Saas-Fee": {
		"y": "46.10805",
		"population": "1606",
		"x": "7.92741",
		"ID": "663"
	},
	"Salgesch": {
		"y": "46.31155",
		"population": "1439",
		"x": "7.5712",
		"ID": "470"
	},
	"Icogne": {
		"y": "46.29193",
		"population": "557",
		"x": "7.44054",
		"ID": "408"
	},
	"Bichelsee-Balterswil": {
		"y": "47.44902",
		"population": "2777",
		"x": "8.92434",
		"ID": "1146"
	},
	"Villars-sous-Yens": {
		"y": "46.50694",
		"population": "564",
		"x": "6.43015",
		"ID": "58"
	},
	"Chavannes-le-Chene": {
		"y": "46.77696",
		"population": "277",
		"x": "6.77793",
		"ID": "127"
	},
	"Gryon": {
		"y": "46.27377",
		"population": "1257",
		"x": "7.05975",
		"ID": "254"
	},
	"Oensingen": {
		"y": "47.28639",
		"population": "6120",
		"x": "7.72305",
		"ID": "589"
	},
	"Denens": {
		"y": "46.51771",
		"population": "708",
		"x": "6.45289",
		"ID": "58"
	},
	"Amsoldingen": {
		"y": "46.72754",
		"population": "799",
		"x": "7.58247",
		"ID": "511"
	},
	"Buch am Irchel": {
		"y": "47.548",
		"population": "951",
		"x": "8.62744",
		"ID": "976"
	},
	"Schwanden bei Brienz": {
		"y": "46.77107",
		"population": "579",
		"x": "8.05582",
		"ID": "736"
	},
	"Moudon": {
		"y": "46.66947",
		"population": "5754",
		"x": "6.80127",
		"ID": "147"
	},
	"Chippis": {
		"y": "46.2802",
		"population": "1618",
		"x": "7.53962",
		"ID": "470"
	},
	"Vuiteboeuf": {
		"y": "46.80922",
		"population": "545",
		"x": "6.55043",
		"ID": "84"
	},
	"Mirchel": {
		"y": "46.89456",
		"population": "618",
		"x": "7.64993",
		"ID": "514"
	},
	"Siviriez": {
		"y": "46.65852",
		"population": "2205",
		"x": "6.87774",
		"ID": "169"
	},
	"Seegraben": {
		"y": "47.34124",
		"population": "1422",
		"x": "8.77131",
		"ID": "1073"
	},
	"Champtauroz": {
		"y": "46.75888",
		"population": "133",
		"x": "6.78558",
		"ID": "127"
	},
	"Flerden": {
		"y": "46.70332",
		"population": "226",
		"x": "9.40825",
		"ID": "1343"
	},
	"Enges": {
		"y": "47.06673",
		"population": "278",
		"x": "7.01657",
		"ID": "237"
	},
	"Egliswil": {
		"y": "47.34954",
		"population": "1332",
		"x": "8.18802",
		"ID": "803"
	},
	"Grabs": {
		"y": "47.18248",
		"population": "6859",
		"x": "9.44395",
		"ID": "1377"
	},
	"Lovatens": {
		"y": "46.69203",
		"population": "150",
		"x": "6.86072",
		"ID": "147"
	},
	"Mont-Tramelan": {
		"y": "47.20999",
		"population": "115",
		"x": "7.06477",
		"ID": "272"
	},
	"Langnau am Albis": {
		"y": "47.28885",
		"population": "7364",
		"x": "8.5411",
		"ID": "938"
	},
	"Otelfingen": {
		"y": "47.46053",
		"population": "2741",
		"x": "8.39141",
		"ID": "881"
	},
	"Lengnau (AG)": {
		"y": "47.52222",
		"population": "2647",
		"x": "8.33056",
		"ID": "857"
	},
	"Rovio": {
		"y": "45.93309",
		"population": "805",
		"x": "8.98699",
		"ID": "1152"
	},
	"Villars-Sainte-Croix": {
		"y": "46.56734",
		"population": "709",
		"x": "6.56325",
		"ID": "80"
	},
	"Belprahon": {
		"y": "47.28635",
		"population": "306",
		"x": "7.40588",
		"ID": "427"
	},
	"Jongny": {
		"y": "46.47883",
		"population": "1477",
		"x": "6.84114",
		"ID": "143"
	},
	"Schlieren": {
		"y": "47.39668",
		"population": "18063",
		"x": "8.44763",
		"ID": "908"
	},
	"Walenstadt": {
		"y": "47.12287",
		"population": "5478",
		"x": "9.19496",
		"ID": "1275"
	},
	"Oppligen": {
		"y": "46.81839",
		"population": "652",
		"x": "7.60074",
		"ID": "513"
	},
	"Etagnieres": {
		"y": "46.60152",
		"population": "1140",
		"x": "6.60646",
		"ID": "92"
	},
	"Innerthal": {
		"y": "47.10567",
		"population": "191",
		"x": "8.92011",
		"ID": "1139"
	},
	"Neggio": {
		"y": "45.98709",
		"population": "326",
		"x": "8.8797",
		"ID": "1118"
	},
	"Le Landeron": {
		"y": "47.0562",
		"population": "4444",
		"x": "7.07184",
		"ID": "269"
	},
	"Misery-Courtion": {
		"y": "46.8582",
		"population": "1821",
		"x": "7.08494",
		"ID": "265"
	},
	"Yvorne": {
		"y": "46.33122",
		"population": "1006",
		"x": "6.95872",
		"ID": "190"
	},
	"S-chanf": {
		"y": "46.61179",
		"population": "697",
		"x": "9.98354",
		"ID": "1509"
	},
	"Choulex": {
		"y": "46.22454",
		"population": "1123",
		"x": "6.22799",
		"ID": "31"
	},
	"Wiler bei Utzenstorf": {
		"y": "47.15059",
		"population": "869",
		"x": "7.55657",
		"ID": "486"
	},
	"Grandson": {
		"y": "46.80946",
		"population": "3209",
		"x": "6.646",
		"ID": "96"
	},
	"Buchs (ZH)": {
		"y": "47.45876",
		"population": "6233",
		"x": "8.43661",
		"ID": "881"
	},
	"Laax": {
		"y": "46.80452",
		"population": "1573",
		"x": "9.25787",
		"ID": "1297"
	},
	"Schafisheim": {
		"y": "47.37529",
		"population": "2893",
		"x": "8.14076",
		"ID": "777"
	},
	"Oberageri": {
		"y": "47.13614",
		"population": "5834",
		"x": "8.6144",
		"ID": "968"
	},
	"Rebeuvelier": {
		"y": "47.32477",
		"population": "396",
		"x": "7.40936",
		"ID": "428"
	},
	"Oetwil an der Limmat": {
		"y": "47.42832",
		"population": "2333",
		"x": "8.39491",
		"ID": "880"
	},
	"Conters im Prattigau": {
		"y": "46.9",
		"population": "215",
		"x": "9.78333",
		"ID": "1473"
	},
	"Mellikon": {
		"y": "47.56944",
		"population": "260",
		"x": "8.35417",
		"ID": "858"
	},
	"Rueyres": {
		"y": "46.69337",
		"population": "265",
		"x": "6.69213",
		"ID": "106"
	},
	"Chatonnaye": {
		"y": "46.75452",
		"population": "783",
		"x": "6.93799",
		"ID": "198"
	},
	"Iffwil": {
		"y": "47.06396",
		"population": "417",
		"x": "7.48286",
		"ID": "453"
	},
	"Sonceboz-Sombeval": {
		"y": "47.19654",
		"population": "1893",
		"x": "7.17751",
		"ID": "304"
	},
	"Rickenbach (LU)": {
		"y": "47.24836",
		"population": "3142",
		"x": "8.17752",
		"ID": "775"
	},
	"Wauwil": {
		"y": "47.18457",
		"population": "1952",
		"x": "8.021",
		"ID": "715"
	},
	"Sennwald": {
		"y": "47.26063",
		"population": "5199",
		"x": "9.50268",
		"ID": "1403"
	},
	"Lavigny": {
		"y": "46.50118",
		"population": "920",
		"x": "6.41091",
		"ID": "50"
	},
	"Ferpicloz": {
		"y": "46.74818",
		"population": "279",
		"x": "7.16223",
		"ID": "296"
	},
	"Ballwil": {
		"y": "47.15487",
		"population": "2719",
		"x": "8.32138",
		"ID": "850"
	},
	"Kappelen": {
		"y": "47.06015",
		"population": "1316",
		"x": "7.2686",
		"ID": "363"
	},
	"Meyriez": {
		"y": "46.92366",
		"population": "587",
		"x": "7.1066",
		"ID": "267"
	},
	"Barbereche": {
		"y": "46.85735",
		"population": "509",
		"x": "7.15982",
		"ID": "298"
	},
	"Bellikon": {
		"y": "47.3916",
		"population": "1540",
		"x": "8.34934",
		"ID": "854"
	},
	"Pampigny": {
		"y": "46.58093",
		"population": "1122",
		"x": "6.42941",
		"ID": "59"
	},
	"Hafelfingen": {
		"y": "47.41493",
		"population": "271",
		"x": "7.866",
		"ID": "657"
	},
	"Evionnaz": {
		"y": "46.18096",
		"population": "1186",
		"x": "7.02232",
		"ID": "220"
	},
	"Diessbach bei Buren": {
		"y": "47.1078",
		"population": "981",
		"x": "7.36122",
		"ID": "394"
	},
	"Meisterschwanden": {
		"y": "47.29489",
		"population": "2782",
		"x": "8.22867",
		"ID": "802"
	},
	"Seedorf (BE)": {
		"y": "47.03445",
		"population": "2954",
		"x": "7.31249",
		"ID": "362"
	},
	"Rumligen": {
		"y": "46.82786",
		"population": "434",
		"x": "7.48861",
		"ID": "449"
	},
	"Alchenstorf": {
		"y": "47.12537",
		"population": "595",
		"x": "7.63785",
		"ID": "552"
	},
	"Bosingen": {
		"y": "46.89229",
		"population": "3347",
		"x": "7.2277",
		"ID": "330"
	},
	"Thusis": {
		"y": "46.69724",
		"population": "2968",
		"x": "9.43938",
		"ID": "1368"
	},
	"Mathod": {
		"y": "46.76638",
		"population": "579",
		"x": "6.56472",
		"ID": "84"
	},
	"Lugnez": {
		"y": "47.48515",
		"population": "184",
		"x": "7.09753",
		"ID": "277"
	},
	"Erstfeld": {
		"y": "46.81885",
		"population": "3688",
		"x": "8.65052",
		"ID": "996"
	},
	"Ottenbach": {
		"y": "47.28147",
		"population": "2546",
		"x": "8.40942",
		"ID": "878"
	},
	"Riniken": {
		"y": "47.49395",
		"population": "1458",
		"x": "8.18673",
		"ID": "806"
	},
	"Ascona": {
		"y": "46.15451",
		"population": "5356",
		"x": "8.77327",
		"ID": "1050"
	},
	"Oberrieden": {
		"y": "47.27444",
		"population": "4973",
		"x": "8.57838",
		"ID": "971"
	},
	"Schwendibach": {
		"y": "46.76993",
		"population": "230",
		"x": "7.66192",
		"ID": "545"
	},
	"Oberentfelden": {
		"y": "47.35639",
		"population": "7600",
		"x": "8.04594",
		"ID": "718"
	},
	"Chables": {
		"y": "46.82451",
		"population": "763",
		"x": "6.81078",
		"ID": "150"
	},
	"Nurensdorf": {
		"y": "47.44814",
		"population": "5428",
		"x": "8.64908",
		"ID": "1008"
	},
	"Broc": {
		"y": "46.60513",
		"population": "2464",
		"x": "7.09891",
		"ID": "260"
	},
	"Bougy-Villars": {
		"y": "46.48188",
		"population": "482",
		"x": "6.35359",
		"ID": "50"
	},
	"Losone": {
		"y": "46.16866",
		"population": "6473",
		"x": "8.75928",
		"ID": "1050"
	},
	"Hasle (LU)": {
		"y": "46.97787",
		"population": "1710",
		"x": "8.05326",
		"ID": "740"
	},
	"Vex": {
		"y": "46.21239",
		"population": "1779",
		"x": "7.39826",
		"ID": "406"
	},
	"Miglieglia": {
		"y": "46.02379",
		"population": "309",
		"x": "8.85738",
		"ID": "1082"
	},
	"Ried-Brig": {
		"y": "46.31376",
		"population": "2029",
		"x": "8.01752",
		"ID": "698"
	},
	"Zuzgen": {
		"y": "47.52508",
		"population": "852",
		"x": "7.89986",
		"ID": "659"
	},
	"Oberengstringen": {
		"y": "47.40841",
		"population": "6461",
		"x": "8.46515",
		"ID": "909"
	},
	"Gerlafingen": {
		"y": "47.16978",
		"population": "4887",
		"x": "7.57505",
		"ID": "487"
	},
	"Gundlischwand": {
		"y": "46.6322",
		"population": "341",
		"x": "7.91269",
		"ID": "642"
	},
	"Gersau": {
		"y": "47.008",
		"population": "2201",
		"x": "8.51678",
		"ID": "932"
	},
	"Munchenstein": {
		"y": "47.51848",
		"population": "11685",
		"x": "7.60966",
		"ID": "526"
	},
	"Hemberg": {
		"y": "47.30062",
		"population": "902",
		"x": "9.17517",
		"ID": "1278"
	},
	"Butschwil-Ganterschwil": {
		"y": "47.36022",
		"population": "4660",
		"x": "9.07213",
		"ID": "1216"
	},
	"Jenaz": {
		"y": "46.92892",
		"population": "1148",
		"x": "9.71275",
		"ID": "1459"
	},
	"Grosswangen": {
		"y": "47.13282",
		"population": "3084",
		"x": "8.04781",
		"ID": "743"
	},
	"Blauen": {
		"y": "47.45023",
		"population": "692",
		"x": "7.51848",
		"ID": "492"
	},
	"Ponte Tresa": {
		"y": "45.97167",
		"population": "786",
		"x": "8.85927",
		"ID": "1081"
	},
	"Utzenstorf": {
		"y": "47.12981",
		"population": "4151",
		"x": "7.55838",
		"ID": "486"
	},
	"Forst-Langenbuhl": {
		"y": "46.76468",
		"population": "763",
		"x": "7.52325",
		"ID": "479"
	},
	"Herdern": {
		"y": "47.60304",
		"population": "1012",
		"x": "8.91077",
		"ID": "1149"
	},
	"Uerkheim": {
		"y": "47.30289",
		"population": "1343",
		"x": "8.02371",
		"ID": "717"
	},
	"Ferlens (VD)": {
		"y": "46.58808",
		"population": "335",
		"x": "6.7808",
		"ID": "124"
	},
	"Saint-Sulpice (VD)": {
		"y": "46.51047",
		"population": "3818",
		"x": "6.55897",
		"ID": "79"
	},
	"Herrliberg": {
		"y": "47.29064",
		"population": "6196",
		"x": "8.61464",
		"ID": "971"
	},
	"Renan (BE)": {
		"y": "47.12686",
		"population": "882",
		"x": "6.92825",
		"ID": "178"
	},
	"Benken (ZH)": {
		"y": "47.65276",
		"population": "850",
		"x": "8.65391",
		"ID": "1012"
	},
	"Givrins": {
		"y": "46.42969",
		"population": "971",
		"x": "6.20213",
		"ID": "25"
	},
	"Maisprach": {
		"y": "47.52457",
		"population": "930",
		"x": "7.84705",
		"ID": "659"
	},
	"Beinwil am See": {
		"y": "47.26059",
		"population": "3005",
		"x": "8.20506",
		"ID": "802"
	},
	"Develier": {
		"y": "47.35773",
		"population": "1372",
		"x": "7.29839",
		"ID": "368"
	},
	"Rossa": {
		"y": "46.37139",
		"population": "147",
		"x": "9.12363",
		"ID": "1230"
	},
	"Mies": {
		"y": "46.30355",
		"population": "1933",
		"x": "6.16332",
		"ID": "23"
	},
	"Schinznach-Bad": {
		"y": "47.44992",
		"population": "1251",
		"x": "8.16833",
		"ID": "779"
	},
	"Stafa": {
		"y": "47.24254",
		"population": "13930",
		"x": "8.72342",
		"ID": "1037"
	},
	"Munchwilen (AG)": {
		"y": "47.53573",
		"population": "891",
		"x": "7.96409",
		"ID": "691"
	},
	"Inwil": {
		"y": "47.1253",
		"population": "2384",
		"x": "8.34885",
		"ID": "849"
	},
	"Krauchthal": {
		"y": "47.00964",
		"population": "2304",
		"x": "7.5664",
		"ID": "484"
	},
	"Ballens": {
		"y": "46.55485",
		"population": "505",
		"x": "6.3731",
		"ID": "51"
	},
	"Wittenbach": {
		"y": "47.46108",
		"population": "9516",
		"x": "9.38601",
		"ID": "1358"
	},
	"Miege": {
		"y": "46.31119",
		"population": "1337",
		"x": "7.54701",
		"ID": "470"
	},
	"Sorengo": {
		"y": "45.99766",
		"population": "1584",
		"x": "8.93783",
		"ID": "1118"
	},
	"Schneisingen": {
		"y": "47.51944",
		"population": "1326",
		"x": "8.36667",
		"ID": "857"
	},
	"Buttenhardt": {
		"y": "47.75706",
		"population": "346",
		"x": "8.6533",
		"ID": "1014"
	},
	"Horw": {
		"y": "47.01692",
		"population": "13392",
		"x": "8.30956",
		"ID": "847"
	},
	"Le Mouret": {
		"y": "46.73183",
		"population": "3055",
		"x": "7.18749",
		"ID": "327"
	},
	"Montricher": {
		"y": "46.60005",
		"population": "957",
		"x": "6.37695",
		"ID": "52"
	},
	"Morrens (VD)": {
		"y": "46.59089",
		"population": "1053",
		"x": "6.62229",
		"ID": "92"
	},
	"Balsthal": {
		"y": "47.31613",
		"population": "5946",
		"x": "7.69318",
		"ID": "556"
	},
	"Horgen": {
		"y": "47.25983",
		"population": "19794",
		"x": "8.59778",
		"ID": "971"
	},
	"Effingen": {
		"y": "47.48868",
		"population": "609",
		"x": "8.10286",
		"ID": "750"
	},
	"Sorvilier": {
		"y": "47.23749",
		"population": "270",
		"x": "7.30841",
		"ID": "366"
	},
	"Berg (SG)": {
		"y": "47.48667",
		"population": "834",
		"x": "9.40986",
		"ID": "1358"
	},
	"Grossdietwil": {
		"y": "47.16836",
		"population": "819",
		"x": "7.89141",
		"ID": "652"
	},
	"Boecourt": {
		"y": "47.35138",
		"population": "892",
		"x": "7.21493",
		"ID": "339"
	},
	"Brot-Plamboz": {
		"y": "46.98541",
		"population": "270",
		"x": "6.74784",
		"ID": "131"
	},
	"Glarus": {
		"y": "47.04057",
		"population": "12294",
		"x": "9.06804",
		"ID": "1210"
	},
	"Wynigen": {
		"y": "47.10586",
		"population": "1974",
		"x": "7.66681",
		"ID": "552"
	},
	"Bangerten": {
		"y": "47.05564",
		"population": "160",
		"x": "7.44914",
		"ID": "453"
	},
	"Fontaines-sur-Grandson": {
		"y": "46.85618",
		"population": "191",
		"x": "6.59985",
		"ID": "97"
	},
	"Gossau (SG)": {
		"y": "47.41551",
		"population": "17649",
		"x": "9.25482",
		"ID": "1309"
	},
	"Moosleerau": {
		"y": "47.26904",
		"population": "905",
		"x": "8.06405",
		"ID": "746"
	},
	"Bischofszell": {
		"y": "47.49575",
		"population": "5794",
		"x": "9.23882",
		"ID": "1282"
	},
	"Muntelier": {
		"y": "46.93522",
		"population": "950",
		"x": "7.12356",
		"ID": "267"
	},
	"Villars-le-Terroir": {
		"y": "46.65817",
		"population": "1030",
		"x": "6.64389",
		"ID": "93"
	},
	"Hauptwil-Gottshaus": {
		"y": "47.48015",
		"population": "1884",
		"x": "9.25066",
		"ID": "1310"
	},
	"Hausen (AG)": {
		"y": "47.46396",
		"population": "3379",
		"x": "8.20988",
		"ID": "806"
	},
	"Bretigny-sur-Morrens": {
		"y": "46.59981",
		"population": "768",
		"x": "6.64314",
		"ID": "92"
	},
	"Sirnach": {
		"y": "47.46222",
		"population": "7605",
		"x": "8.99763",
		"ID": "1182"
	},
	"Vuadens": {
		"y": "46.61731",
		"population": "2264",
		"x": "7.02052",
		"ID": "228"
	},
	"Rothenfluh": {
		"y": "47.46201",
		"population": "766",
		"x": "7.92022",
		"ID": "658"
	},
	"Les Enfers": {
		"y": "47.28934",
		"population": "148",
		"x": "7.04302",
		"ID": "241"
	},
	"Courgenay": {
		"y": "47.40365",
		"population": "2202",
		"x": "7.12416",
		"ID": "308"
	},
	"Worben": {
		"y": "47.10279",
		"population": "2253",
		"x": "7.29518",
		"ID": "364"
	},
	"Warth-Weiningen": {
		"y": "47.58811",
		"population": "1232",
		"x": "8.88191",
		"ID": "1112"
	},
	"Finsterhennen": {
		"y": "47.02483",
		"population": "526",
		"x": "7.17536",
		"ID": "301"
	},
	"Lavey-Morcles": {
		"y": "46.20871",
		"population": "890",
		"x": "7.03631",
		"ID": "220"
	},
	"Gsteigwiler": {
		"y": "46.65545",
		"population": "392",
		"x": "7.87188",
		"ID": "642"
	},
	"La Chaux (Cossonay)": {
		"y": "46.61844",
		"population": "421",
		"x": "6.47223",
		"ID": "60"
	},
	"Villnachern": {
		"y": "47.47098",
		"population": "1554",
		"x": "8.15975",
		"ID": "779"
	},
	"Steinen": {
		"y": "47.04975",
		"population": "3272",
		"x": "8.61214",
		"ID": "967"
	},
	"Reconvilier": {
		"y": "47.23431",
		"population": "2286",
		"x": "7.22239",
		"ID": "337"
	},
	"Riggisberg": {
		"y": "46.81028",
		"population": "2370",
		"x": "7.48014",
		"ID": "448"
	},
	"Cheserex": {
		"y": "46.39928",
		"population": "1189",
		"x": "6.17397",
		"ID": "25"
	},
	"Teuffenthal (BE)": {
		"y": "46.76766",
		"population": "159",
		"x": "7.71142",
		"ID": "545"
	},
	"Pfaffikon": {
		"y": "47.36453",
		"population": "11296",
		"x": "8.79202",
		"ID": "1073"
	},
	"Oeschgen": {
		"y": "47.52307",
		"population": "934",
		"x": "8.01899",
		"ID": "721"
	},
	"Avegno Gordevio": {
		"y": "46.22604",
		"population": "1435",
		"x": "8.74309",
		"ID": "1018"
	},
	"Schmitten (FR)": {
		"y": "46.8575",
		"population": "3993",
		"x": "7.25031",
		"ID": "359"
	},
	"Hirschthal": {
		"y": "47.32178",
		"population": "1558",
		"x": "8.05281",
		"ID": "747"
	},
	"Rumendingen": {
		"y": "47.10588",
		"population": "83",
		"x": "7.6394",
		"ID": "518"
	},
	"Cheyres": {
		"y": "46.81439",
		"population": "1407",
		"x": "6.78685",
		"ID": "128"
	},
	"Collonges": {
		"y": "46.17204",
		"population": "713",
		"x": "7.03425",
		"ID": "220"
	},
	"Blumenstein": {
		"y": "46.7421",
		"population": "1198",
		"x": "7.52136",
		"ID": "479"
	},
	"Thun": {
		"y": "46.75118",
		"population": "42555",
		"x": "7.62166",
		"ID": "511"
	},
	"Bovernier": {
		"y": "46.07901",
		"population": "844",
		"x": "7.08584",
		"ID": "250"
	},
	"Schelten": {
		"y": "47.33428",
		"population": "36",
		"x": "7.55171",
		"ID": "490"
	},
	"Lusslingen-Nennigkofen": {
		"y": "47.18633",
		"population": "1037",
		"x": "7.49516",
		"ID": "456"
	},
	"Tagerwilen": {
		"y": "47.65698",
		"population": "4325",
		"x": "9.13999",
		"ID": "1254"
	},
	"Grandval": {
		"y": "47.28278",
		"population": "382",
		"x": "7.42504",
		"ID": "427"
	},
	"Fieschertal": {
		"y": "46.422",
		"population": "317",
		"x": "8.14542",
		"ID": "759"
	},
	"Islisberg": {
		"y": "47.32203",
		"population": "629",
		"x": "8.44142",
		"ID": "907"
	},
	"Pfeffingen": {
		"y": "47.45984",
		"population": "2332",
		"x": "7.58975",
		"ID": "525"
	},
	"Oberwil (BL)": {
		"y": "47.51407",
		"population": "10981",
		"x": "7.55786",
		"ID": "493"
	},
	"Huntwangen": {
		"y": "47.59576",
		"population": "1013",
		"x": "8.49116",
		"ID": "912"
	},
	"Savognin": {
		"y": "46.59636",
		"population": "983",
		"x": "9.59825",
		"ID": "1415"
	},
	"Court": {
		"y": "47.23956",
		"population": "1404",
		"x": "7.33655",
		"ID": "397"
	},
	"Laufen-Uhwiesen": {
		"y": "47.67025",
		"population": "1616",
		"x": "8.64354",
		"ID": "1012"
	},
	"Yverdon-les-Bains": {
		"y": "46.77852",
		"population": "29206",
		"x": "6.64115",
		"ID": "95"
	},
	"Eriswil": {
		"y": "47.07816",
		"population": "1332",
		"x": "7.85149",
		"ID": "651"
	},
	"Sierre": {
		"y": "46.29192",
		"population": "16484",
		"x": "7.53559",
		"ID": "470"
	},
	"Gambarogno": {
		"y": "46.11221",
		"population": "5091",
		"x": "8.83055",
		"ID": "1084"
	},
	"Dozwil": {
		"y": "47.57665",
		"population": "673",
		"x": "9.32336",
		"ID": "1337"
	},
	"Rifferswil": {
		"y": "47.24372",
		"population": "1056",
		"x": "8.49692",
		"ID": "905"
	},
	"Kehrsatz": {
		"y": "46.91035",
		"population": "4181",
		"x": "7.47096",
		"ID": "450"
	},
	"Waldenburg": {
		"y": "47.38333",
		"population": "1134",
		"x": "7.75",
		"ID": "590"
	},
	"Dattlikon": {
		"y": "47.52493",
		"population": "742",
		"x": "8.6245",
		"ID": "976"
	},
	"Mex (VD)": {
		"y": "46.57592",
		"population": "669",
		"x": "6.55452",
		"ID": "80"
	},
	"Leggia": {
		"y": "46.26315",
		"population": "138",
		"x": "9.16354",
		"ID": "1258"
	},
	"Holziken": {
		"y": "47.31951",
		"population": "1298",
		"x": "8.0343",
		"ID": "717"
	},
	"Windisch": {
		"y": "47.47899",
		"population": "7261",
		"x": "8.21842",
		"ID": "806"
	},
	"Gruningen": {
		"y": "47.28333",
		"population": "3338",
		"x": "8.75",
		"ID": "1038"
	},
	"Pregny-Chambesy": {
		"y": "46.23789",
		"population": "3388",
		"x": "6.14239",
		"ID": "12"
	},
	"Blenio": {
		"y": "46.47613",
		"population": "1766",
		"x": "8.94609",
		"ID": "1127"
	},
	"Brislach": {
		"y": "47.41763",
		"population": "1600",
		"x": "7.5434",
		"ID": "492"
	},
	"Hinwil": {
		"y": "47.29646",
		"population": "10807",
		"x": "8.83431",
		"ID": "1072"
	},
	"Lotzwil": {
		"y": "47.19135",
		"population": "2465",
		"x": "7.79102",
		"ID": "619"
	},
	"Vinzel": {
		"y": "46.44827",
		"population": "349",
		"x": "6.27817",
		"ID": "35"
	},
	"Saint-Livres": {
		"y": "46.50794",
		"population": "711",
		"x": "6.38753",
		"ID": "50"
	},
	"Durrenroth": {
		"y": "47.08816",
		"population": "1047",
		"x": "7.7913",
		"ID": "617"
	},
	"Hundwil": {
		"y": "47.36464",
		"population": "937",
		"x": "9.31847",
		"ID": "1333"
	},
	"Neuendorf": {
		"y": "47.30083",
		"population": "2036",
		"x": "7.7954",
		"ID": "621"
	},
	"Heimiswil": {
		"y": "47.06755",
		"population": "1580",
		"x": "7.66665",
		"ID": "551"
	},
	"Torbel": {
		"y": "46.23837",
		"population": "465",
		"x": "7.85239",
		"ID": "634"
	},
	"Courchavon": {
		"y": "47.43952",
		"population": "297",
		"x": "7.0546",
		"ID": "244"
	},
	"Campo (Vallemaggia)": {
		"y": "46.28855",
		"population": "56",
		"x": "8.49577",
		"ID": "887"
	},
	"Hasle bei Burgdorf": {
		"y": "47.01436",
		"population": "3276",
		"x": "7.65112",
		"ID": "550"
	},
	"Oberosch": {
		"y": "47.10955",
		"population": "102",
		"x": "7.60805",
		"ID": "518"
	},
	"Truttikon": {
		"y": "47.62908",
		"population": "471",
		"x": "8.72718",
		"ID": "1045"
	},
	"Sigriswil": {
		"y": "46.71656",
		"population": "4634",
		"x": "7.71335",
		"ID": "544"
	},
	"Stadel": {
		"y": "47.5294",
		"population": "2180",
		"x": "8.46353",
		"ID": "911"
	},
	"Zuoz": {
		"y": "46.60209",
		"population": "1133",
		"x": "9.95885",
		"ID": "1509"
	},
	"Haggenschwil": {
		"y": "47.49462",
		"population": "1239",
		"x": "9.34487",
		"ID": "1336"
	},
	"Echichens": {
		"y": "46.53031",
		"population": "2480",
		"x": "6.49681",
		"ID": "69"
	},
	"Attiswil": {
		"y": "47.24673",
		"population": "1389",
		"x": "7.61353",
		"ID": "521"
	},
	"Kussnacht (SZ)": {
		"y": "47.08557",
		"population": "12192",
		"x": "8.44206",
		"ID": "902"
	},
	"Blatten": {
		"y": "46.4207",
		"population": "285",
		"x": "7.81746",
		"ID": "604"
	},
	"Walperswil": {
		"y": "47.06083",
		"population": "986",
		"x": "7.226",
		"ID": "333"
	},
	"Volleges": {
		"y": "46.09196",
		"population": "1876",
		"x": "7.1755",
		"ID": "283"
	},
	"Ermatingen": {
		"y": "47.67057",
		"population": "3147",
		"x": "9.08573",
		"ID": "1222"
	},
	"Hofstetten bei Brienz": {
		"y": "46.75351",
		"population": "535",
		"x": "8.07487",
		"ID": "736"
	},
	"Baulmes": {
		"y": "46.79031",
		"population": "1025",
		"x": "6.52279",
		"ID": "74"
	},
	"Densburen": {
		"y": "47.4526",
		"population": "685",
		"x": "8.0533",
		"ID": "749"
	},
	"Rapperswil (BE)": {
		"y": "47.06316",
		"population": "2395",
		"x": "7.41088",
		"ID": "423"
	},
	"Dintikon": {
		"y": "47.3616",
		"population": "2152",
		"x": "8.22181",
		"ID": "804"
	},
	"Celigny": {
		"y": "46.35069",
		"population": "654",
		"x": "6.195",
		"ID": "24"
	},
	"Troinex": {
		"y": "46.16313",
		"population": "2283",
		"x": "6.14745",
		"ID": "11"
	},
	"Pfyn": {
		"y": "47.59693",
		"population": "1910",
		"x": "8.9542",
		"ID": "1149"
	},
	"Semsales": {
		"y": "46.57375",
		"population": "1402",
		"x": "6.93018",
		"ID": "195"
	},
	"Kappel am Albis": {
		"y": "47.22811",
		"population": "1031",
		"x": "8.52727",
		"ID": "937"
	},
	"Bottenwil": {
		"y": "47.28541",
		"population": "773",
		"x": "8.00464",
		"ID": "717"
	},
	"Kriegstetten": {
		"y": "47.17449",
		"population": "1264",
		"x": "7.59799",
		"ID": "519"
	},
	"Lumnezia": {
		"y": "46.66292",
		"population": "2027",
		"x": "9.1099",
		"ID": "1235"
	},
	"Oberlangenegg": {
		"y": "46.80103",
		"population": "462",
		"x": "7.74181",
		"ID": "579"
	},
	"Unterramsern": {
		"y": "47.11773",
		"population": "203",
		"x": "7.48267",
		"ID": "454"
	},
	"Bettens": {
		"y": "46.62831",
		"population": "557",
		"x": "6.57342",
		"ID": "81"
	},
	"Fahrni": {
		"y": "46.79401",
		"population": "784",
		"x": "7.65502",
		"ID": "546"
	},
	"Birmenstorf (AG)": {
		"y": "47.46152",
		"population": "2896",
		"x": "8.24816",
		"ID": "831"
	},
	"Presinge": {
		"y": "46.21975",
		"population": "579",
		"x": "6.25517",
		"ID": "31"
	},
	"Mettembert": {
		"y": "47.39668",
		"population": "107",
		"x": "7.32047",
		"ID": "400"
	},
	"Steckborn": {
		"y": "47.66667",
		"population": "3660",
		"x": "8.98333",
		"ID": "1150"
	},
	"Celerina/Schlarigna": {
		"y": "46.51217",
		"population": "1527",
		"x": "9.85794",
		"ID": "1480"
	},
	"Muriaux": {
		"y": "47.24575",
		"population": "496",
		"x": "6.9791",
		"ID": "208"
	},
	"Dietikon": {
		"y": "47.40165",
		"population": "26201",
		"x": "8.40015",
		"ID": "880"
	},
	"Agiez": {
		"y": "46.72103",
		"population": "308",
		"x": "6.50751",
		"ID": "72"
	},
	"Andelfingen": {
		"y": "47.61328",
		"population": "2153",
		"x": "8.68124",
		"ID": "1011"
	},
	"Erschwil": {
		"y": "47.37386",
		"population": "900",
		"x": "7.54137",
		"ID": "491"
	},
	"Auboranges": {
		"y": "46.58463",
		"population": "270",
		"x": "6.80445",
		"ID": "145"
	},
	"Wald (ZH)": {
		"y": "47.27595",
		"population": "9284",
		"x": "8.91405",
		"ID": "1143"
	},
	"Orvin": {
		"y": "47.16068",
		"population": "1185",
		"x": "7.21368",
		"ID": "335"
	},
	"Bettlach": {
		"y": "47.50745",
		"population": "4806",
		"x": "7.41281",
		"ID": "431"
	},
	"Beatenberg": {
		"y": "46.69896",
		"population": "1147",
		"x": "7.79428",
		"ID": "610"
	},
	"Murgenthal": {
		"y": "47.27145",
		"population": "2856",
		"x": "7.83935",
		"ID": "621"
	},
	"Dielsdorf": {
		"y": "47.47181",
		"population": "5881",
		"x": "8.45631",
		"ID": "910"
	},
	"Bachs": {
		"y": "47.52385",
		"population": "580",
		"x": "8.43942",
		"ID": "882"
	},
	"Borex": {
		"y": "46.37891",
		"population": "1074",
		"x": "6.1762",
		"ID": "24"
	},
	"Bobikon": {
		"y": "47.55555",
		"population": "163",
		"x": "8.33472",
		"ID": "857"
	},
	"Oberdorf (NW)": {
		"y": "46.96901",
		"population": "3058",
		"x": "8.45791",
		"ID": "900"
	},
	"Sulgen": {
		"y": "47.53967",
		"population": "3615",
		"x": "9.18585",
		"ID": "1283"
	},
	"Grellingen": {
		"y": "47.44231",
		"population": "1833",
		"x": "7.58906",
		"ID": "525"
	},
	"Cuarnens": {
		"y": "46.62545",
		"population": "436",
		"x": "6.43859",
		"ID": "60"
	},
	"Lurtigen": {
		"y": "46.92844",
		"population": "180",
		"x": "7.17329",
		"ID": "299"
	},
	"Ballaigues": {
		"y": "46.73055",
		"population": "1046",
		"x": "6.41556",
		"ID": "62"
	},
	"Saxeten": {
		"y": "46.63658",
		"population": "97",
		"x": "7.83087",
		"ID": "609"
	},
	"Le Vaud": {
		"y": "46.47753",
		"population": "1240",
		"x": "6.23603",
		"ID": "36"
	},
	"Niedergesteln": {
		"y": "46.31243",
		"population": "679",
		"x": "7.78364",
		"ID": "602"
	},
	"Altnau": {
		"y": "47.61052",
		"population": "2135",
		"x": "9.2616",
		"ID": "1313"
	},
	"Echarlens": {
		"y": "46.64778",
		"population": "811",
		"x": "7.0742",
		"ID": "261"
	},
	"Wuppenau": {
		"y": "47.49633",
		"population": "1112",
		"x": "9.10904",
		"ID": "1219"
	},
	"Cheseaux-Noreaz": {
		"y": "46.78935",
		"population": "660",
		"x": "6.68934",
		"ID": "108"
	},
	"Tartegnin": {
		"y": "46.46623",
		"population": "230",
		"x": "6.31246",
		"ID": "43"
	},
	"Vendlincourt": {
		"y": "47.45193",
		"population": "549",
		"x": "7.14692",
		"ID": "309"
	},
	"Reisiswil": {
		"y": "47.16513",
		"population": "187",
		"x": "7.84628",
		"ID": "619"
	},
	"Savosa": {
		"y": "46.01917",
		"population": "2196",
		"x": "8.94467",
		"ID": "1154"
	},
	"Zuchwil": {
		"y": "47.20173",
		"population": "8593",
		"x": "7.56649",
		"ID": "487"
	},
	"Sainte-Croix": {
		"y": "46.82203",
		"population": "4679",
		"x": "6.50283",
		"ID": "74"
	},
	"Morschach": {
		"y": "46.98271",
		"population": "1112",
		"x": "8.61826",
		"ID": "965"
	},
	"Saint-Cergue": {
		"y": "46.4459",
		"population": "2417",
		"x": "6.15737",
		"ID": "26"
	},
	"Bernex": {
		"y": "46.1765",
		"population": "9439",
		"x": "6.07544",
		"ID": "5"
	},
	"Champvent": {
		"y": "46.7829",
		"population": "614",
		"x": "6.57188",
		"ID": "84"
	},
	"Grono": {
		"y": "46.24832",
		"population": "1003",
		"x": "9.14829",
		"ID": "1258"
	},
	"Baldingen": {
		"y": "47.55555",
		"population": "269",
		"x": "8.31667",
		"ID": "833"
	},
	"Hohentannen": {
		"y": "47.51644",
		"population": "610",
		"x": "9.22472",
		"ID": "1282"
	},
	"Kublis": {
		"y": "46.91368",
		"population": "855",
		"x": "9.77199",
		"ID": "1473"
	},
	"Suhr": {
		"y": "47.37172",
		"population": "9682",
		"x": "8.07967",
		"ID": "748"
	},
	"Lully (VD)": {
		"y": "46.50513",
		"population": "760",
		"x": "6.46479",
		"ID": "58"
	},
	"Madiswil": {
		"y": "47.16463",
		"population": "3165",
		"x": "7.79858",
		"ID": "619"
	},
	"Melchnau": {
		"y": "47.18213",
		"population": "1530",
		"x": "7.85128",
		"ID": "619"
	},
	"Les Ponts-de-Martel": {
		"y": "46.99925",
		"population": "1267",
		"x": "6.73356",
		"ID": "132"
	},
	"Pompaples": {
		"y": "46.66758",
		"population": "787",
		"x": "6.51009",
		"ID": "71"
	},
	"Siblingen": {
		"y": "47.71435",
		"population": "829",
		"x": "8.52011",
		"ID": "946"
	},
	"Arni (AG)": {
		"y": "47.31821",
		"population": "1830",
		"x": "8.42465",
		"ID": "878"
	},
	"Le Chatelard": {
		"y": "46.44527",
		"population": "370",
		"x": "6.89908",
		"ID": "165"
	},
	"Breil/Brigels": {
		"y": "46.76986",
		"population": "1232",
		"x": "9.06036",
		"ID": "1205"
	},
	"Finhaut": {
		"y": "46.08381",
		"population": "351",
		"x": "6.97777",
		"ID": "185"
	},
	"Bofflens": {
		"y": "46.7031",
		"population": "186",
		"x": "6.49478",
		"ID": "72"
	},
	"Ruttenen": {
		"y": "47.23053",
		"population": "1484",
		"x": "7.5295",
		"ID": "488"
	},
	"Liddes": {
		"y": "45.99249",
		"population": "746",
		"x": "7.18729",
		"ID": "281"
	},
	"Reinach (BL)": {
		"y": "47.49702",
		"population": "18349",
		"x": "7.59172",
		"ID": "526"
	},
	"Laufenburg": {
		"y": "47.51844",
		"population": "3416",
		"x": "8.03878",
		"ID": "721"
	},
	"Fluelen": {
		"y": "46.90478",
		"population": "1946",
		"x": "8.62396",
		"ID": "964"
	},
	"Bevaix": {
		"y": "46.92958",
		"population": "3776",
		"x": "6.8147",
		"ID": "152"
	},
	"Cronay": {
		"y": "46.75683",
		"population": "364",
		"x": "6.70297",
		"ID": "107"
	},
	"Bannwil": {
		"y": "47.23405",
		"population": "695",
		"x": "7.73101",
		"ID": "588"
	},
	"Sementina": {
		"y": "46.18363",
		"population": "3101",
		"x": "8.99162",
		"ID": "1157"
	},
	"Sion": {
		"y": "46.22739",
		"population": "32692",
		"x": "7.35559",
		"ID": "377"
	},
	"Treiten": {
		"y": "47.00859",
		"population": "430",
		"x": "7.16025",
		"ID": "301"
	},
	"Coldrerio": {
		"y": "45.854",
		"population": "2820",
		"x": "8.98772",
		"ID": "1151"
	},
	"Chardonne": {
		"y": "46.47676",
		"population": "2747",
		"x": "6.8268",
		"ID": "143"
	},
	"Uesslingen-Buch": {
		"y": "47.58146",
		"population": "1081",
		"x": "8.83099",
		"ID": "1077"
	},
	"Penthalaz": {
		"y": "46.61077",
		"population": "3198",
		"x": "6.52519",
		"ID": "70"
	},
	"Vully-les-Lacs": {
		"y": "46.92098",
		"population": "2807",
		"x": "7.01245",
		"ID": "234"
	},
	"Tentlingen": {
		"y": "46.76767",
		"population": "1316",
		"x": "7.20001",
		"ID": "328"
	},
	"St. Gallen": {
		"y": "47.42391",
		"population": "72817",
		"x": "9.37477",
		"ID": "1357"
	},
	"Oetwil am See": {
		"y": "47.27049",
		"population": "4611",
		"x": "8.72023",
		"ID": "1038"
	},
	"Weinfelden": {
		"y": "47.54237",
		"population": "10968",
		"x": "9.15713",
		"ID": "1252"
	},
	"Witterswil": {
		"y": "47.48658",
		"population": "1473",
		"x": "7.52117",
		"ID": "493"
	},
	"Berg am Irchel": {
		"y": "47.56951",
		"population": "571",
		"x": "8.59678",
		"ID": "977"
	},
	"Grenchen": {
		"y": "47.1921",
		"population": "16399",
		"x": "7.39586",
		"ID": "425"
	},
	"Gommiswald": {
		"y": "47.23128",
		"population": "4881",
		"x": "9.02355",
		"ID": "1177"
	},
	"Bretzwil": {
		"y": "47.39783",
		"population": "775",
		"x": "7.65222",
		"ID": "557"
	},
	"Chavannes-des-Bois": {
		"y": "46.31692",
		"population": "870",
		"x": "6.1367",
		"ID": "14"
	},
	"Roches (BE)": {
		"y": "47.30199",
		"population": "209",
		"x": "7.38127",
		"ID": "398"
	},
	"Oekingen": {
		"y": "47.1798",
		"population": "804",
		"x": "7.60237",
		"ID": "520"
	},
	"Stettfurt": {
		"y": "47.52588",
		"population": "1157",
		"x": "8.95317",
		"ID": "1147"
	},
	"Gimel": {
		"y": "46.50945",
		"population": "1812",
		"x": "6.30736",
		"ID": "44"
	},
	"Thayngen": {
		"y": "47.74717",
		"population": "5218",
		"x": "8.70724",
		"ID": "1014"
	},
	"Habkern": {
		"y": "46.72639",
		"population": "635",
		"x": "7.86304",
		"ID": "644"
	},
	"Hermenches": {
		"y": "46.64027",
		"population": "364",
		"x": "6.76271",
		"ID": "125"
	},
	"Recherswil": {
		"y": "47.16258",
		"population": "1795",
		"x": "7.59456",
		"ID": "519"
	},
	"Bellwald": {
		"y": "46.42757",
		"population": "405",
		"x": "8.16144",
		"ID": "759"
	},
	"Villeret": {
		"y": "47.15838",
		"population": "913",
		"x": "7.01889",
		"ID": "239"
	},
	"Aedermannsdorf": {
		"y": "47.30374",
		"population": "541",
		"x": "7.61052",
		"ID": "522"
	},
	"Breggia": {
		"y": "45.89292",
		"population": "2027",
		"x": "9.04672",
		"ID": "1188"
	},
	"Cresciano": {
		"y": "46.27875",
		"population": "687",
		"x": "9.00261",
		"ID": "1159"
	},
	"Fallanden": {
		"y": "47.37169",
		"population": "8305",
		"x": "8.63869",
		"ID": "973"
	},
	"Hendschiken": {
		"y": "47.38648",
		"population": "1150",
		"x": "8.21782",
		"ID": "804"
	},
	"Ligerz": {
		"y": "47.08368",
		"population": "543",
		"x": "7.13476",
		"ID": "302"
	},
	"Kernenried": {
		"y": "47.06968",
		"population": "524",
		"x": "7.54679",
		"ID": "485"
	},
	"Saignelegier": {
		"y": "47.25619",
		"population": "2504",
		"x": "6.99648",
		"ID": "208"
	},
	"Thal": {
		"y": "47.31095",
		"population": "6291",
		"x": "7.63592",
		"ID": "522"
	},
	"Osogna": {
		"y": "46.31208",
		"population": "1040",
		"x": "8.98579",
		"ID": "1160"
	},
	"Malters": {
		"y": "47.03628",
		"population": "6888",
		"x": "8.18193",
		"ID": "797"
	},
	"Grancy": {
		"y": "46.59214",
		"population": "396",
		"x": "6.46391",
		"ID": "59"
	},
	"Rudtligen-Alchenfluh": {
		"y": "47.08486",
		"population": "2411",
		"x": "7.56866",
		"ID": "485"
	},
	"Kaufdorf": {
		"y": "46.84032",
		"population": "1055",
		"x": "7.49679",
		"ID": "449"
	},
	"Wiliberg": {
		"y": "47.26869",
		"population": "167",
		"x": "8.02139",
		"ID": "716"
	},
	"Neuhausen am Rheinfall": {
		"y": "47.68579",
		"population": "10082",
		"x": "8.61474",
		"ID": "979"
	},
	"Elgg": {
		"y": "47.49715",
		"population": "4169",
		"x": "8.86523",
		"ID": "1110"
	},
	"Rufenach": {
		"y": "47.50712",
		"population": "863",
		"x": "8.20903",
		"ID": "806"
	},
	"Laupersdorf": {
		"y": "47.31426",
		"population": "1711",
		"x": "7.65053",
		"ID": "522"
	},
	"Bretonnieres": {
		"y": "46.71236",
		"population": "251",
		"x": "6.46964",
		"ID": "72"
	},
	"Bex": {
		"y": "46.24965",
		"population": "7166",
		"x": "7.0098",
		"ID": "221"
	},
	"Bennwil": {
		"y": "47.40074",
		"population": "641",
		"x": "7.78114",
		"ID": "591"
	},
	"Hauenstein-Ifenthal": {
		"y": "47.37111",
		"population": "312",
		"x": "7.85594",
		"ID": "656"
	},
	"Saint-Imier": {
		"y": "47.15284",
		"population": "4970",
		"x": "6.99692",
		"ID": "206"
	},
	"La Sagne": {
		"y": "47.04591",
		"population": "945",
		"x": "6.80946",
		"ID": "154"
	},
	"Kleinbosingen": {
		"y": "46.89297",
		"population": "601",
		"x": "7.2025",
		"ID": "330"
	},
	"Auw": {
		"y": "47.21082",
		"population": "1954",
		"x": "8.36583",
		"ID": "851"
	},
	"Marbach (SG)": {
		"y": "47.39167",
		"population": "2119",
		"x": "9.5672",
		"ID": "1426"
	},
	"Uetikon am See": {
		"y": "47.26441",
		"population": "5909",
		"x": "8.67925",
		"ID": "1004"
	},
	"Chamblon": {
		"y": "46.77906",
		"population": "563",
		"x": "6.60256",
		"ID": "84"
	},
	"Orny": {
		"y": "46.66758",
		"population": "359",
		"x": "6.52639",
		"ID": "71"
	},
	"Danikon": {
		"y": "47.44674",
		"population": "1881",
		"x": "8.40648",
		"ID": "881"
	},
	"Mont-la-Ville": {
		"y": "46.64661",
		"population": "383",
		"x": "6.40898",
		"ID": "53"
	},
	"Rumlang": {
		"y": "47.45041",
		"population": "7625",
		"x": "8.52993",
		"ID": "941"
	},
	"Niederhasli": {
		"y": "47.48012",
		"population": "8991",
		"x": "8.48576",
		"ID": "910"
	},
	"Saas-Almagell": {
		"y": "46.09347",
		"population": "391",
		"x": "7.95736",
		"ID": "663"
	},
	"Ostermundigen": {
		"y": "46.95694",
		"population": "16479",
		"x": "7.49019",
		"ID": "451"
	},
	"Reichenbach im Kandertal": {
		"y": "46.62541",
		"population": "3501",
		"x": "7.69362",
		"ID": "542"
	},
	"Stans": {
		"y": "46.95805",
		"population": "8069",
		"x": "8.36609",
		"ID": "846"
	},
	"Altendorf": {
		"y": "47.18994",
		"population": "6637",
		"x": "8.83823",
		"ID": "1070"
	},
	"Fiesch": {
		"y": "46.39981",
		"population": "916",
		"x": "8.13533",
		"ID": "759"
	},
	"Augst": {
		"y": "47.53557",
		"population": "922",
		"x": "7.71468",
		"ID": "560"
	},
	"Saillon": {
		"y": "46.17035",
		"population": "2468",
		"x": "7.18771",
		"ID": "316"
	},
	"Vuisternens-devant-Romont": {
		"y": "46.64613",
		"population": "2230",
		"x": "6.934",
		"ID": "196"
	},
	"Kunten": {
		"y": "47.3889",
		"population": "1659",
		"x": "8.33105",
		"ID": "854"
	},
	"Brenzikofen": {
		"y": "46.81812",
		"population": "511",
		"x": "7.61713",
		"ID": "513"
	},
	"Mendrisio": {
		"y": "45.87019",
		"population": "14671",
		"x": "8.9816",
		"ID": "1151"
	},
	"Jaberg": {
		"y": "46.81796",
		"population": "250",
		"x": "7.56919",
		"ID": "480"
	},
	"Kleinlutzel": {
		"y": "47.42537",
		"population": "1238",
		"x": "7.42294",
		"ID": "430"
	},
	"Clos du Doubs": {
		"y": "47.35095",
		"population": "1267",
		"x": "7.12063",
		"ID": "275"
	},
	"Caslano": {
		"y": "45.97364",
		"population": "4235",
		"x": "8.87739",
		"ID": "1081"
	},
	"Treytorrens (Payerne)": {
		"y": "46.77215",
		"population": "122",
		"x": "6.80476",
		"ID": "149"
	},
	"Fontenais": {
		"y": "47.40478",
		"population": "1647",
		"x": "7.08191",
		"ID": "276"
	},
	"Wurenlingen": {
		"y": "47.53356",
		"population": "4544",
		"x": "8.25666",
		"ID": "832"
	},
	"Bubikon": {
		"y": "47.26698",
		"population": "6947",
		"x": "8.8179",
		"ID": "1071"
	},
	"Tevenon": {
		"y": "46.86462",
		"population": "793",
		"x": "6.63414",
		"ID": "97"
	},
	"Bulle": {
		"y": "46.6195",
		"population": "20822",
		"x": "7.05674",
		"ID": "228"
	},
	"Battwil": {
		"y": "47.48954",
		"population": "1188",
		"x": "7.5083",
		"ID": "493"
	},
	"Untereggen": {
		"y": "47.45401",
		"population": "1039",
		"x": "9.45099",
		"ID": "1382"
	},
	"Croglio": {
		"y": "45.98835",
		"population": "868",
		"x": "8.84229",
		"ID": "1081"
	},
	"Denges": {
		"y": "46.52198",
		"population": "1653",
		"x": "6.53932",
		"ID": "79"
	},
	"Wileroltigen": {
		"y": "46.97094",
		"population": "383",
		"x": "7.23922",
		"ID": "332"
	},
	"Monteggio": {
		"y": "45.99614",
		"population": "885",
		"x": "8.80366",
		"ID": "1048"
	},
	"Konolfingen": {
		"y": "46.87909",
		"population": "5081",
		"x": "7.62013",
		"ID": "514"
	},
	"Laufelfingen": {
		"y": "47.39457",
		"population": "1275",
		"x": "7.85578",
		"ID": "657"
	},
	"Weiningen (ZH)": {
		"y": "47.42022",
		"population": "4478",
		"x": "8.43644",
		"ID": "880"
	},
	"Orsieres": {
		"y": "46.02903",
		"population": "3169",
		"x": "7.14437",
		"ID": "282"
	},
	"Inden": {
		"y": "46.34438",
		"population": "120",
		"x": "7.61739",
		"ID": "503"
	},
	"Geuensee": {
		"y": "47.1997",
		"population": "2829",
		"x": "8.10689",
		"ID": "774"
	},
	"Hochwald": {
		"y": "47.4583",
		"population": "1283",
		"x": "7.6418",
		"ID": "525"
	},
	"Muotathal": {
		"y": "46.97676",
		"population": "3431",
		"x": "8.76499",
		"ID": "1066"
	},
	"Schenkon": {
		"y": "47.1683",
		"population": "2721",
		"x": "8.14384",
		"ID": "773"
	},
	"Schoftland": {
		"y": "47.30572",
		"population": "4168",
		"x": "8.05138",
		"ID": "717"
	},
	"Ruderswil": {
		"y": "46.98415",
		"population": "2291",
		"x": "7.72061",
		"ID": "583"
	},
	"Fullinsdorf": {
		"y": "47.50688",
		"population": "4272",
		"x": "7.73129",
		"ID": "593"
	},
	"Hitzkirch": {
		"y": "47.22403",
		"population": "5085",
		"x": "8.26425",
		"ID": "826"
	},
	"Boltigen": {
		"y": "46.6289",
		"population": "1271",
		"x": "7.39111",
		"ID": "385"
	},
	"Mutrux": {
		"y": "46.88085",
		"population": "154",
		"x": "6.72659",
		"ID": "110"
	},
	"Cologny": {
		"y": "46.21672",
		"population": "5334",
		"x": "6.18041",
		"ID": "21"
	},
	"Steinmaur": {
		"y": "47.4971",
		"population": "3332",
		"x": "8.45216",
		"ID": "910"
	},
	"Lalden": {
		"y": "46.29951",
		"population": "664",
		"x": "7.90235",
		"ID": "667"
	},
	"Grandvillard": {
		"y": "46.54029",
		"population": "791",
		"x": "7.08605",
		"ID": "259"
	},
	"Salvan": {
		"y": "46.1189",
		"population": "1312",
		"x": "7.02078",
		"ID": "219"
	},
	"Neckertal": {
		"y": "47.34614",
		"population": "3941",
		"x": "9.16402",
		"ID": "1279"
	},
	"Eclepens": {
		"y": "46.64819",
		"population": "1036",
		"x": "6.53579",
		"ID": "71"
	},
	"Rumisberg": {
		"y": "47.26415",
		"population": "461",
		"x": "7.6403",
		"ID": "521"
	},
	"Arnex-sur-Orbe": {
		"y": "46.69",
		"population": "614",
		"x": "6.51687",
		"ID": "72"
	},
	"Eisten": {
		"y": "46.20075",
		"population": "196",
		"x": "7.89282",
		"ID": "634"
	},
	"Busswil bei Melchnau": {
		"y": "47.18767",
		"population": "169",
		"x": "7.82944",
		"ID": "619"
	},
	"Schotz": {
		"y": "47.16896",
		"population": "4147",
		"x": "7.9887",
		"ID": "714"
	},
	"Kriechenwil": {
		"y": "46.90969",
		"population": "422",
		"x": "7.21957",
		"ID": "330"
	},
	"Chavannes-de-Bogis": {
		"y": "46.34004",
		"population": "1295",
		"x": "6.15448",
		"ID": "14"
	},
	"Ropraz": {
		"y": "46.61462",
		"population": "407",
		"x": "6.75347",
		"ID": "124"
	},
	"Tagertschi": {
		"y": "46.87548",
		"population": "385",
		"x": "7.58529",
		"ID": "514"
	},
	"St. Moritz": {
		"y": "46.4984",
		"population": "5016",
		"x": "9.83909",
		"ID": "1480"
	},
	"Dudingen": {
		"y": "46.84915",
		"population": "7690",
		"x": "7.18848",
		"ID": "329"
	},
	"Stein (AR)": {
		"y": "47.37127",
		"population": "1391",
		"x": "9.34353",
		"ID": "1334"
	},
	"Vufflens-la-Ville": {
		"y": "46.57515",
		"population": "1195",
		"x": "6.53716",
		"ID": "80"
	},
	"Giswil": {
		"y": "46.83333",
		"population": "3542",
		"x": "8.18065",
		"ID": "793"
	},
	"Zweisimmen": {
		"y": "46.55452",
		"population": "2948",
		"x": "7.37385",
		"ID": "413"
	},
	"Wimmis": {
		"y": "46.67587",
		"population": "2396",
		"x": "7.63972",
		"ID": "510"
	},
	"Reichenburg": {
		"y": "47.17097",
		"population": "3389",
		"x": "8.97704",
		"ID": "1176"
	},
	"Gurtnellen": {
		"y": "46.74007",
		"population": "575",
		"x": "8.62468",
		"ID": "961"
	},
	"Personico": {
		"y": "46.37204",
		"population": "340",
		"x": "8.91609",
		"ID": "1125"
	},
	"Ecublens (VD)": {
		"y": "46.52899",
		"population": "11489",
		"x": "6.56261",
		"ID": "79"
	},
	"Hombrechtikon": {
		"y": "47.25298",
		"population": "8336",
		"x": "8.77212",
		"ID": "1071"
	},
	"Unterseen": {
		"y": "46.6853",
		"population": "5591",
		"x": "7.84722",
		"ID": "643"
	},
	"Wisen (SO)": {
		"y": "47.39277",
		"population": "402",
		"x": "7.88509",
		"ID": "657"
	},
	"Aristau": {
		"y": "47.28692",
		"population": "1370",
		"x": "8.36356",
		"ID": "852"
	},
	"Cuarny": {
		"y": "46.76988",
		"population": "214",
		"x": "6.69207",
		"ID": "108"
	},
	"Hittnau": {
		"y": "47.36334",
		"population": "3589",
		"x": "8.82418",
		"ID": "1073"
	},
	"Schupfheim": {
		"y": "46.95161",
		"population": "4083",
		"x": "8.01723",
		"ID": "710"
	},
	"Canobbio": {
		"y": "46.03592",
		"population": "2122",
		"x": "8.96605",
		"ID": "1154"
	},
	"Anwil": {
		"y": "47.45053",
		"population": "575",
		"x": "7.94446",
		"ID": "689"
	},
	"Courroux": {
		"y": "47.36069",
		"population": "3177",
		"x": "7.37371",
		"ID": "399"
	},
	"Buttikon": {
		"y": "47.32856",
		"population": "975",
		"x": "8.26946",
		"ID": "828"
	},
	"Uitikon": {
		"y": "47.36911",
		"population": "4063",
		"x": "8.45699",
		"ID": "908"
	},
	"Roveredo (GR)": {
		"y": "46.23653",
		"population": "2444",
		"x": "9.12748",
		"ID": "1227"
	},
	"Schwadernau": {
		"y": "47.1278",
		"population": "653",
		"x": "7.30778",
		"ID": "364"
	},
	"Schmiedrued": {
		"y": "47.26315",
		"population": "1149",
		"x": "8.11167",
		"ID": "775"
	},
	"Moosseedorf": {
		"y": "47.01562",
		"population": "3958",
		"x": "7.47811",
		"ID": "452"
	},
	"Wilen (TG)": {
		"y": "47.45142",
		"population": "2435",
		"x": "9.03419",
		"ID": "1218"
	},
	"Wattwil": {
		"y": "47.29955",
		"population": "8397",
		"x": "9.08657",
		"ID": "1215"
	},
	"Luterbach": {
		"y": "47.21426",
		"population": "3407",
		"x": "7.58463",
		"ID": "520"
	},
	"Pont-en-Ogoz": {
		"y": "46.68829",
		"population": "1768",
		"x": "7.07683",
		"ID": "262"
	},
	"Ependes (VD)": {
		"y": "46.7428",
		"population": "346",
		"x": "6.6081",
		"ID": "95"
	},
	"Flasch": {
		"y": "47.02567",
		"population": "709",
		"x": "9.51365",
		"ID": "1398"
	},
	"Meiringen": {
		"y": "46.72709",
		"population": "4642",
		"x": "8.1872",
		"ID": "791"
	},
	"Nendaz": {
		"y": "46.18993",
		"population": "6094",
		"x": "7.31209",
		"ID": "346"
	},
	"Walliswil bei Wangen": {
		"y": "47.22885",
		"population": "567",
		"x": "7.6829",
		"ID": "554"
	},
	"Zeneggen": {
		"y": "46.27341",
		"population": "287",
		"x": "7.86535",
		"ID": "635"
	},
	"Cazis": {
		"y": "46.72308",
		"population": "1979",
		"x": "9.42881",
		"ID": "1368"
	},
	"Stein am Rhein": {
		"y": "47.65933",
		"population": "3281",
		"x": "8.85964",
		"ID": "1113"
	},
	"Wagenhausen": {
		"y": "47.66003",
		"population": "1655",
		"x": "8.84782",
		"ID": "1079"
	},
	"Glarus Nord": {
		"y": "47.14995",
		"population": "17497",
		"x": "9.02551",
		"ID": "1176"
	},
	"Ponthaux": {
		"y": "46.81527",
		"population": "681",
		"x": "7.04142",
		"ID": "232"
	},
	"Unterstammheim": {
		"y": "47.63921",
		"population": "914",
		"x": "8.79064",
		"ID": "1079"
	},
	"Lengwil": {
		"y": "47.62519",
		"population": "1643",
		"x": "9.19242",
		"ID": "1284"
	},
	"Mauensee": {
		"y": "47.1715",
		"population": "1316",
		"x": "8.07589",
		"ID": "744"
	},
	"Cossonay": {
		"y": "46.61443",
		"population": "3639",
		"x": "6.50631",
		"ID": "70"
	},
	"Villeneuve (VD)": {
		"y": "46.39869",
		"population": "5461",
		"x": "6.92654",
		"ID": "164"
	},
	"Pfaffnau": {
		"y": "47.22772",
		"population": "2495",
		"x": "7.89719",
		"ID": "653"
	},
	"Schonenwerd": {
		"y": "47.3691",
		"population": "4828",
		"x": "8.00167",
		"ID": "718"
	},
	"Buron": {
		"y": "47.21206",
		"population": "2336",
		"x": "8.09421",
		"ID": "745"
	},
	"Balerna": {
		"y": "45.84638",
		"population": "3324",
		"x": "9.00724",
		"ID": "1187"
	},
	"Venthone": {
		"y": "46.30665",
		"population": "1197",
		"x": "7.52924",
		"ID": "470"
	},
	"Subingen": {
		"y": "47.19852",
		"population": "3034",
		"x": "7.61949",
		"ID": "520"
	},
	"Doppleschwand": {
		"y": "47.01831",
		"population": "737",
		"x": "8.05501",
		"ID": "741"
	},
	"Moutier": {
		"y": "47.27818",
		"population": "7470",
		"x": "7.36951",
		"ID": "397"
	},
	"Maroggia": {
		"y": "45.93521",
		"population": "623",
		"x": "8.97055",
		"ID": "1152"
	},
	"Origlio": {
		"y": "46.0534",
		"population": "1439",
		"x": "8.94656",
		"ID": "1155"
	},
	"Ramsen": {
		"y": "47.70797",
		"population": "1344",
		"x": "8.80949",
		"ID": "1080"
	},
	"Ronco sopra Ascona": {
		"y": "46.14624",
		"population": "610",
		"x": "8.72793",
		"ID": "1016"
	},
	"Bregaglia": {
		"y": "46.33333",
		"population": "1522",
		"x": "9.5",
		"ID": "1385"
	},
	"Alpthal": {
		"y": "47.06954",
		"population": "591",
		"x": "8.71602",
		"ID": "1034"
	},
	"Obergerlafingen": {
		"y": "47.16124",
		"population": "1098",
		"x": "7.58177",
		"ID": "519"
	},
	"Rongellen": {
		"y": "46.67436",
		"population": "59",
		"x": "9.44181",
		"ID": "1367"
	},
	"Spiringen": {
		"y": "46.87259",
		"population": "842",
		"x": "8.73017",
		"ID": "1030"
	},
	"Rheineck": {
		"y": "47.4663",
		"population": "3266",
		"x": "9.59028",
		"ID": "1427"
	},
	"Moleno": {
		"y": "46.26771",
		"population": "123",
		"x": "8.99368",
		"ID": "1159"
	},
	"Rueyres-les-Pres": {
		"y": "46.85865",
		"population": "431",
		"x": "6.91208",
		"ID": "173"
	},
	"Zillis-Reischen": {
		"y": "46.63447",
		"population": "400",
		"x": "9.44477",
		"ID": "1366"
	},
	"La Neuveville": {
		"y": "47.0964",
		"population": "3661",
		"x": "7.11089",
		"ID": "270"
	},
	"Ammerswil": {
		"y": "47.36818",
		"population": "678",
		"x": "8.20737",
		"ID": "804"
	},
	"Wilchingen": {
		"y": "47.66745",
		"population": "1692",
		"x": "8.46774",
		"ID": "914"
	},
	"Wintersingen": {
		"y": "47.49408",
		"population": "607",
		"x": "7.82409",
		"ID": "625"
	},
	"Longirod": {
		"y": "46.49497",
		"population": "464",
		"x": "6.25843",
		"ID": "36"
	},
	"Erlach": {
		"y": "47.04297",
		"population": "1399",
		"x": "7.0996",
		"ID": "269"
	},
	"Schupfart": {
		"y": "47.51372",
		"population": "760",
		"x": "7.96577",
		"ID": "690"
	},
	"Lussery-Villars": {
		"y": "46.63284",
		"population": "421",
		"x": "6.52555",
		"ID": "71"
	},
	"Corbeyrier": {
		"y": "46.35013",
		"population": "410",
		"x": "6.96017",
		"ID": "191"
	},
	"Veytaux": {
		"y": "46.42129",
		"population": "864",
		"x": "6.93048",
		"ID": "192"
	},
	"Monchaltorf": {
		"y": "47.30958",
		"population": "3618",
		"x": "8.72029",
		"ID": "1039"
	},
	"Birrhard": {
		"y": "47.43285",
		"population": "695",
		"x": "8.24498",
		"ID": "805"
	},
	"Mannedorf": {
		"y": "47.25686",
		"population": "10416",
		"x": "8.69893",
		"ID": "1004"
	},
	"Corseaux": {
		"y": "46.47222",
		"population": "2119",
		"x": "6.82942",
		"ID": "143"
	},
	"Riva San Vitale": {
		"y": "45.90123",
		"population": "2582",
		"x": "8.97167",
		"ID": "1152"
	},
	"Wettswil am Albis": {
		"y": "47.33727",
		"population": "4868",
		"x": "8.46993",
		"ID": "907"
	},
	"Riedholz": {
		"y": "47.23158",
		"population": "2252",
		"x": "7.56829",
		"ID": "488"
	},
	"Mulligen": {
		"y": "47.45575",
		"population": "1042",
		"x": "8.2392",
		"ID": "831"
	},
	"Chesalles-sur-Moudon": {
		"y": "46.67465",
		"population": "166",
		"x": "6.83655",
		"ID": "147"
	},
	"Bonigen": {
		"y": "46.68736",
		"population": "2489",
		"x": "7.8935",
		"ID": "643"
	},
	"Oberriet (SG)": {
		"y": "47.32088",
		"population": "8618",
		"x": "9.56808",
		"ID": "1404"
	},
	"Bioley-Orjulaz": {
		"y": "46.62138",
		"population": "447",
		"x": "6.59849",
		"ID": "81"
	},
	"Berken": {
		"y": "47.22578",
		"population": "39",
		"x": "7.70594",
		"ID": "554"
	},
	"Grimisuat": {
		"y": "46.25938",
		"population": "3176",
		"x": "7.38408",
		"ID": "378"
	},
	"Arbon": {
		"y": "47.51667",
		"population": "14006",
		"x": "9.43333",
		"ID": "1359"
	},
	"Hallau": {
		"y": "47.69648",
		"population": "2035",
		"x": "8.45827",
		"ID": "914"
	},
	"Perrefitte": {
		"y": "47.27568",
		"population": "432",
		"x": "7.34161",
		"ID": "397"
	},
	"Romont (FR)": {
		"y": "46.69652",
		"population": "5074",
		"x": "6.91898",
		"ID": "170"
	},
	"Arisdorf": {
		"y": "47.51323",
		"population": "1648",
		"x": "7.76515",
		"ID": "593"
	},
	"Uzwil": {
		"y": "47.43653",
		"population": "12568",
		"x": "9.13422",
		"ID": "1250"
	},
	"Tavannes": {
		"y": "47.22079",
		"population": "3544",
		"x": "7.19759",
		"ID": "336"
	},
	"Ferenbalm": {
		"y": "46.9488",
		"population": "1218",
		"x": "7.21124",
		"ID": "331"
	},
	"Gunzgen": {
		"y": "47.31375",
		"population": "1641",
		"x": "7.83102",
		"ID": "622"
	},
	"Porza": {
		"y": "46.0268",
		"population": "1602",
		"x": "8.94989",
		"ID": "1154"
	},
	"Wegenstetten": {
		"y": "47.49794",
		"population": "1057",
		"x": "7.93159",
		"ID": "690"
	},
	"Ruthi (SG)": {
		"y": "47.2948",
		"population": "2225",
		"x": "9.53857",
		"ID": "1404"
	},
	"Salenstein": {
		"y": "47.65937",
		"population": "1275",
		"x": "9.05736",
		"ID": "1222"
	},
	"Chavornay": {
		"y": "46.70244",
		"population": "4156",
		"x": "6.5694",
		"ID": "82"
	},
	"Senedes": {
		"y": "46.7418",
		"population": "156",
		"x": "7.14185",
		"ID": "296"
	},
	"Oberiberg": {
		"y": "47.04074",
		"population": "865",
		"x": "8.78676",
		"ID": "1067"
	},
	"Muolen": {
		"y": "47.52102",
		"population": "1184",
		"x": "9.32484",
		"ID": "1336"
	},
	"Buttwil": {
		"y": "47.26828",
		"population": "1171",
		"x": "8.31064",
		"ID": "852"
	},
	"Oberbalm": {
		"y": "46.87363",
		"population": "882",
		"x": "7.4028",
		"ID": "419"
	},
	"Oberembrach": {
		"y": "47.4878",
		"population": "1052",
		"x": "8.61828",
		"ID": "975"
	},
	"Mulegns": {
		"y": "46.52421",
		"population": "26",
		"x": "9.62087",
		"ID": "1434"
	},
	"Oberdiessbach": {
		"y": "46.84117",
		"population": "3489",
		"x": "7.6173",
		"ID": "513"
	},
	"Obersiggenthal": {
		"y": "47.4875",
		"population": "8493",
		"x": "8.29652",
		"ID": "832"
	},
	"Perly-Certoux": {
		"y": "46.15698",
		"population": "2988",
		"x": "6.09226",
		"ID": "5"
	},
	"Oberburen": {
		"y": "47.45192",
		"population": "4202",
		"x": "9.15864",
		"ID": "1251"
	},
	"Romainmotier-Envy": {
		"y": "46.69393",
		"population": "528",
		"x": "6.46086",
		"ID": "61"
	},
	"Harkingen": {
		"y": "47.30892",
		"population": "1523",
		"x": "7.81806",
		"ID": "622"
	},
	"Beckenried": {
		"y": "46.96653",
		"population": "3495",
		"x": "8.47575",
		"ID": "900"
	},
	"Ederswiler": {
		"y": "47.42389",
		"population": "113",
		"x": "7.33097",
		"ID": "400"
	},
	"Veltheim (AG)": {
		"y": "47.43796",
		"population": "1427",
		"x": "8.14722",
		"ID": "779"
	},
	"Brot-Dessous": {
		"y": "46.95586",
		"population": "101",
		"x": "6.74775",
		"ID": "131"
	},
	"Fraubrunnen": {
		"y": "47.0678",
		"population": "4844",
		"x": "7.5029",
		"ID": "453"
	},
	"Rickenbach (TG)": {
		"y": "47.44939",
		"population": "2734",
		"x": "9.04843",
		"ID": "1218"
	},
	"Autafond": {
		"y": "46.8129",
		"population": "70",
		"x": "7.07684",
		"ID": "264"
	},
	"Satigny": {
		"y": "46.21462",
		"population": "3923",
		"x": "6.03553",
		"ID": "6"
	},
	"Visp": {
		"y": "46.2937",
		"population": "7478",
		"x": "7.88149",
		"ID": "635"
	},
	"Yvonand": {
		"y": "46.80034",
		"population": "3105",
		"x": "6.74249",
		"ID": "128"
	},
	"Onnens (VD)": {
		"y": "46.83894",
		"population": "490",
		"x": "6.68896",
		"ID": "109"
	},
	"Wunnewil-Flamatt": {
		"y": "46.877",
		"population": "5395",
		"x": "7.28561",
		"ID": "359"
	},
	"Krattigen": {
		"y": "46.66139",
		"population": "1063",
		"x": "7.72777",
		"ID": "577"
	},
	"Tagerig": {
		"y": "47.40565",
		"population": "1445",
		"x": "8.27677",
		"ID": "830"
	},
	"Allmendingen": {
		"y": "46.91472",
		"population": "543",
		"x": "7.52439",
		"ID": "482"
	},
	"Boningen": {
		"y": "47.30857",
		"population": "730",
		"x": "7.85531",
		"ID": "655"
	},
	"Realp": {
		"y": "46.59821",
		"population": "141",
		"x": "8.50282",
		"ID": "924"
	},
	"Fahrwangen": {
		"y": "47.29477",
		"population": "1994",
		"x": "8.24215",
		"ID": "828"
	},
	"Vugelles-La Mothe": {
		"y": "46.82497",
		"population": "134",
		"x": "6.57376",
		"ID": "85"
	},
	"Cugnasco-Gerra": {
		"y": "46.31709",
		"population": "2902",
		"x": "8.80134",
		"ID": "1053"
	},
	"Dottikon": {
		"y": "47.38437",
		"population": "3848",
		"x": "8.23981",
		"ID": "804"
	},
	"Minusio": {
		"y": "46.17769",
		"population": "7075",
		"x": "8.81473",
		"ID": "1085"
	},
	"Klingnau": {
		"y": "47.57998",
		"population": "3264",
		"x": "8.25048",
		"ID": "833"
	},
	"Heimberg": {
		"y": "46.79482",
		"population": "6615",
		"x": "7.60433",
		"ID": "512"
	},
	"Tenniken": {
		"y": "47.43712",
		"population": "889",
		"x": "7.81149",
		"ID": "624"
	},
	"Nebikon": {
		"y": "47.19257",
		"population": "2535",
		"x": "7.97806",
		"ID": "715"
	},
	"Assens": {
		"y": "46.61301",
		"population": "1026",
		"x": "6.62184",
		"ID": "92"
	},
	"Ennetburgen": {
		"y": "46.98423",
		"population": "4536",
		"x": "8.41003",
		"ID": "872"
	},
	"Munster-Geschinen": {
		"y": "46.48688",
		"population": "445",
		"x": "8.26356",
		"ID": "812"
	},
	"Wiedlisbach": {
		"y": "47.25194",
		"population": "2234",
		"x": "7.6461",
		"ID": "521"
	},
	"Waldkirch": {
		"y": "47.46859",
		"population": "3484",
		"x": "9.28665",
		"ID": "1310"
	},
	"Simplon": {
		"y": "46.19451",
		"population": "318",
		"x": "8.05753",
		"ID": "725"
	},
	"Dagmersellen": {
		"y": "47.21366",
		"population": "5173",
		"x": "7.98466",
		"ID": "715"
	},
	"Prato (Leventina)": {
		"y": "46.4824",
		"population": "412",
		"x": "8.757",
		"ID": "1056"
	},
	"Dinhard": {
		"y": "47.55",
		"population": "1483",
		"x": "8.76667",
		"ID": "1043"
	},
	"Cheseaux-sur-Lausanne": {
		"y": "46.58624",
		"population": "4281",
		"x": "6.60587",
		"ID": "92"
	},
	"Landquart": {
		"y": "46.95942",
		"population": "8731",
		"x": "9.55472",
		"ID": "1397"
	},
	"Obersaxen": {
		"y": "46.75",
		"population": "818",
		"x": "9.1",
		"ID": "1237"
	},
	"Ried bei Kerzers": {
		"y": "46.96335",
		"population": "1090",
		"x": "7.18105",
		"ID": "300"
	},
	"Oberhelfenschwil": {
		"y": "47.35673",
		"population": "1282",
		"x": "9.11076",
		"ID": "1249"
	},
	"Wenslingen": {
		"y": "47.44067",
		"population": "722",
		"x": "7.90747",
		"ID": "689"
	},
	"Essertes": {
		"y": "46.56194",
		"population": "326",
		"x": "6.78645",
		"ID": "123"
	},
	"Versoix": {
		"y": "46.28382",
		"population": "12401",
		"x": "6.16214",
		"ID": "22"
	},
	"Ursins": {
		"y": "46.74715",
		"population": "206",
		"x": "6.65231",
		"ID": "95"
	},
	"Masein": {
		"y": "46.70357",
		"population": "474",
		"x": "9.42668",
		"ID": "1368"
	},
	"Welschenrohr": {
		"y": "47.28029",
		"population": "1096",
		"x": "7.52634",
		"ID": "489"
	},
	"Collonge-Bellerive": {
		"y": "46.25039",
		"population": "7779",
		"x": "6.19595",
		"ID": "22"
	},
	"Wattenwil": {
		"y": "46.76973",
		"population": "2833",
		"x": "7.50835",
		"ID": "448"
	},
	"St. Stephan": {
		"y": "46.51168",
		"population": "1314",
		"x": "7.39386",
		"ID": "412"
	},
	"Oberegg": {
		"y": "47.42531",
		"population": "1882",
		"x": "9.55134",
		"ID": "1406"
	},
	"Niederwil (AG)": {
		"y": "47.38039",
		"population": "2740",
		"x": "8.2923",
		"ID": "829"
	},
	"Pailly": {
		"y": "46.70123",
		"population": "533",
		"x": "6.6754",
		"ID": "106"
	},
	"Bellach": {
		"y": "47.21356",
		"population": "5070",
		"x": "7.49924",
		"ID": "456"
	},
	"Reinach (AG)": {
		"y": "47.25944",
		"population": "8040",
		"x": "8.18845",
		"ID": "802"
	},
	"Reigoldswil": {
		"y": "47.39824",
		"population": "1562",
		"x": "7.68718",
		"ID": "557"
	},
	"Ruschegg": {
		"y": "46.77977",
		"population": "1589",
		"x": "7.39167",
		"ID": "417"
	},
	"Grandevent": {
		"y": "46.83793",
		"population": "232",
		"x": "6.60324",
		"ID": "85"
	},
	"Splugen": {
		"y": "46.5531",
		"population": "380",
		"x": "9.3231",
		"ID": "1318"
	},
	"Seuzach": {
		"y": "47.5356",
		"population": "7132",
		"x": "8.73209",
		"ID": "1043"
	},
	"Freimettigen": {
		"y": "46.86636",
		"population": "465",
		"x": "7.63106",
		"ID": "514"
	},
	"Rothrist": {
		"y": "47.30508",
		"population": "8557",
		"x": "7.89196",
		"ID": "655"
	},
	"Holderbank (SO)": {
		"y": "47.33248",
		"population": "626",
		"x": "7.7497",
		"ID": "589"
	},
	"Schlatt-Haslen": {
		"y": "47.36275",
		"population": "1104",
		"x": "9.38324",
		"ID": "1356"
	},
	"Saas-Balen": {
		"y": "46.15439",
		"population": "367",
		"x": "7.92698",
		"ID": "664"
	},
	"Etoy": {
		"y": "46.48587",
		"population": "2793",
		"x": "6.41816",
		"ID": "57"
	},
	"Sommeri": {
		"y": "47.57125",
		"population": "510",
		"x": "9.28383",
		"ID": "1312"
	},
	"Linescio": {
		"y": "46.30921",
		"population": "49",
		"x": "8.58221",
		"ID": "952"
	},
	"Avenches": {
		"y": "46.88004",
		"population": "4017",
		"x": "7.04071",
		"ID": "233"
	},
	"Wachseldorn": {
		"y": "46.82205",
		"population": "235",
		"x": "7.72507",
		"ID": "580"
	},
	"Thundorf": {
		"y": "47.54594",
		"population": "1411",
		"x": "8.96358",
		"ID": "1148"
	},
	"La Brillaz": {
		"y": "46.76695",
		"population": "1885",
		"x": "7.0181",
		"ID": "231"
	},
	"Morel-Filet": {
		"y": "46.36073",
		"population": "685",
		"x": "8.05316",
		"ID": "728"
	},
	"Luterkofen-Ichertswil": {
		"y": "47.16289",
		"population": "756",
		"x": "7.50311",
		"ID": "455"
	},
	"Trullikon": {
		"y": "47.63539",
		"population": "1010",
		"x": "8.68919",
		"ID": "1011"
	},
	"Iserables": {
		"y": "46.16228",
		"population": "853",
		"x": "7.24474",
		"ID": "316"
	},
	"Walchwil": {
		"y": "47.10169",
		"population": "3549",
		"x": "8.51693",
		"ID": "934"
	},
	"Corpataux-Magnedens": {
		"y": "46.74232",
		"population": "1307",
		"x": "7.0932",
		"ID": "263"
	},
	"Romanshorn": {
		"y": "47.56586",
		"population": "10498",
		"x": "9.37869",
		"ID": "1360"
	},
	"Wislikofen": {
		"y": "47.55833",
		"population": "353",
		"x": "8.36389",
		"ID": "857"
	},
	"Sarmenstorf": {
		"y": "47.31022",
		"population": "2776",
		"x": "8.24949",
		"ID": "828"
	},
	"Risch": {
		"y": "47.14054",
		"population": "10179",
		"x": "8.441",
		"ID": "875"
	},
	"Ebersecken": {
		"y": "47.18286",
		"population": "394",
		"x": "7.93185",
		"ID": "684"
	},
	"Gollion": {
		"y": "46.58518",
		"population": "866",
		"x": "6.50974",
		"ID": "70"
	},
	"Champery": {
		"y": "46.17543",
		"population": "1335",
		"x": "6.86903",
		"ID": "160"
	},
	"Farvagny": {
		"y": "46.7277",
		"population": "2210",
		"x": "7.06629",
		"ID": "263"
	},
	"Holderbank (AG)": {
		"y": "47.43093",
		"population": "1141",
		"x": "8.17063",
		"ID": "778"
	},
	"Oberhunigen": {
		"y": "46.88096",
		"population": "311",
		"x": "7.65979",
		"ID": "547"
	},
	"Ueken": {
		"y": "47.48452",
		"population": "894",
		"x": "8.04438",
		"ID": "750"
	},
	"Camorino": {
		"y": "46.16483",
		"population": "2780",
		"x": "9.00547",
		"ID": "1193"
	},
	"Kappel (SO)": {
		"y": "47.32475",
		"population": "3052",
		"x": "7.84647",
		"ID": "622"
	},
	"Au (SG)": {
		"y": "47.43093",
		"population": "7297",
		"x": "9.63448",
		"ID": "1427"
	},
	"Froideville": {
		"y": "46.60015",
		"population": "2427",
		"x": "6.68457",
		"ID": "104"
	},
	"Golaten": {
		"y": "46.98753",
		"population": "311",
		"x": "7.24406",
		"ID": "332"
	},
	"Bleienbach": {
		"y": "47.18493",
		"population": "670",
		"x": "7.7563",
		"ID": "587"
	},
	"Schlierbach": {
		"y": "47.22563",
		"population": "811",
		"x": "8.11066",
		"ID": "745"
	},
	"Grandcour": {
		"y": "46.87185",
		"population": "850",
		"x": "6.9284",
		"ID": "173"
	},
	"Arbaz": {
		"y": "46.2781",
		"population": "1185",
		"x": "7.38542",
		"ID": "378"
	},
	"Bercher": {
		"y": "46.69218",
		"population": "1128",
		"x": "6.70833",
		"ID": "106"
	},
	"Granges-Paccot": {
		"y": "46.8237",
		"population": "3350",
		"x": "7.14836",
		"ID": "297"
	},
	"Zeglingen": {
		"y": "47.41631",
		"population": "476",
		"x": "7.90477",
		"ID": "657"
	},
	"Wengi": {
		"y": "47.08386",
		"population": "601",
		"x": "7.39926",
		"ID": "423"
	},
	"Wohlenschwil": {
		"y": "47.41368",
		"population": "1498",
		"x": "8.25726",
		"ID": "830"
	},
	"Herzogenbuchsee": {
		"y": "47.18795",
		"population": "6883",
		"x": "7.7062",
		"ID": "553"
	},
	"Centovalli": {
		"y": "46.16036",
		"population": "1129",
		"x": "8.65902",
		"ID": "983"
	},
	"Huttlingen": {
		"y": "47.57803",
		"population": "828",
		"x": "8.98081",
		"ID": "1184"
	},
	"Basse-Allaine": {
		"y": "47.47051",
		"population": "1236",
		"x": "7.04245",
		"ID": "245"
	},
	"Gossau (ZH)": {
		"y": "47.3051",
		"population": "9662",
		"x": "8.75831",
		"ID": "1039"
	},
	"Vernayaz": {
		"y": "46.13667",
		"population": "1861",
		"x": "7.03906",
		"ID": "219"
	},
	"Glarus Sud": {
		"y": "46.99541",
		"population": "9393",
		"x": "9.0701",
		"ID": "1209"
	},
	"Emmetten": {
		"y": "46.95658",
		"population": "1367",
		"x": "8.51467",
		"ID": "931"
	},
	"Hemishofen": {
		"y": "47.67659",
		"population": "457",
		"x": "8.82977",
		"ID": "1079"
	},
	"Niederglatt": {
		"y": "47.49066",
		"population": "4697",
		"x": "8.49987",
		"ID": "910"
	},
	"Schmerikon": {
		"y": "47.22538",
		"population": "3645",
		"x": "8.94836",
		"ID": "1142"
	},
	"Gresso": {
		"y": "46.2249",
		"population": "38",
		"x": "8.61631",
		"ID": "951"
	},
	"Mullheim": {
		"y": "47.60195",
		"population": "2856",
		"x": "9.00357",
		"ID": "1184"
	},
	"Buus": {
		"y": "47.50542",
		"population": "989",
		"x": "7.86476",
		"ID": "659"
	},
	"Grolley": {
		"y": "46.8336",
		"population": "1875",
		"x": "7.07116",
		"ID": "265"
	},
	"La Chaux-de-Fonds": {
		"y": "47.09993",
		"population": "38211",
		"x": "6.82586",
		"ID": "155"
	},
	"Val Terbi": {
		"y": "47.35989",
		"population": "2608",
		"x": "7.51099",
		"ID": "459"
	},
	"Meikirch": {
		"y": "47.00719",
		"population": "2356",
		"x": "7.36639",
		"ID": "392"
	},
	"Rolle": {
		"y": "46.4582",
		"population": "5690",
		"x": "6.33499",
		"ID": "43"
	},
	"Attalens": {
		"y": "46.50996",
		"population": "3258",
		"x": "6.84835",
		"ID": "144"
	},
	"Oberbipp": {
		"y": "47.2607",
		"population": "1646",
		"x": "7.66359",
		"ID": "555"
	},
	"Gontenschwil": {
		"y": "47.27166",
		"population": "2051",
		"x": "8.14396",
		"ID": "775"
	},
	"Strengelbach": {
		"y": "47.27917",
		"population": "4539",
		"x": "7.92895",
		"ID": "686"
	},
	"Duillier": {
		"y": "46.40924",
		"population": "1026",
		"x": "6.22979",
		"ID": "34"
	},
	"Genthod": {
		"y": "46.26642",
		"population": "2661",
		"x": "6.15406",
		"ID": "22"
	},
	"Hohenrain": {
		"y": "47.18083",
		"population": "2514",
		"x": "8.31802",
		"ID": "850"
	},
	"Ossingen": {
		"y": "47.61175",
		"population": "1408",
		"x": "8.72781",
		"ID": "1045"
	},
	"Maschwanden": {
		"y": "47.23431",
		"population": "638",
		"x": "8.42709",
		"ID": "877"
	},
	"Zell (ZH)": {
		"y": "47.44607",
		"population": "5594",
		"x": "8.82176",
		"ID": "1075"
	},
	"Ecublens (FR)": {
		"y": "46.60735",
		"population": "330",
		"x": "6.80895",
		"ID": "146"
	},
	"Zuzwil (SG)": {
		"y": "47.47452",
		"population": "4746",
		"x": "9.11196",
		"ID": "1251"
	},
	"Massongex": {
		"y": "46.24267",
		"population": "1761",
		"x": "6.98885",
		"ID": "221"
	},
	"Ueberstorf": {
		"y": "46.86587",
		"population": "2333",
		"x": "7.30998",
		"ID": "359"
	},
	"Saas": {
		"y": "46.10805",
		"population": "729",
		"x": "7.92741",
		"ID": "663"
	},
	"Wiesendangen": {
		"y": "47.5217",
		"population": "6162",
		"x": "8.78967",
		"ID": "1076"
	},
	"Dierikon": {
		"y": "47.09677",
		"population": "1423",
		"x": "8.36948",
		"ID": "874"
	},
	"Orzens": {
		"y": "46.72282",
		"population": "212",
		"x": "6.67892",
		"ID": "107"
	},
	"Duggingen": {
		"y": "47.4518",
		"population": "1491",
		"x": "7.60511",
		"ID": "525"
	},
	"Kirchberg (SG)": {
		"y": "47.41159",
		"population": "8690",
		"x": "9.0402",
		"ID": "1217"
	},
	"Penthaz": {
		"y": "46.59875",
		"population": "1652",
		"x": "6.54135",
		"ID": "70"
	},
	"Corcelles-Cormondreche": {
		"y": "46.98125",
		"population": "4677",
		"x": "6.86774",
		"ID": "175"
	},
	"Kolliken": {
		"y": "47.33882",
		"population": "4240",
		"x": "8.02644",
		"ID": "718"
	},
	"Wangi": {
		"y": "47.49654",
		"population": "4511",
		"x": "8.95325",
		"ID": "1147"
	},
	"Brunisried": {
		"y": "46.75738",
		"population": "654",
		"x": "7.27636",
		"ID": "357"
	},
	"Huttwil": {
		"y": "47.11502",
		"population": "4655",
		"x": "7.86209",
		"ID": "651"
	},
	"Neuenegg": {
		"y": "46.89416",
		"population": "5137",
		"x": "7.30282",
		"ID": "360"
	},
	"Feuerthalen": {
		"y": "47.69054",
		"population": "3498",
		"x": "8.64357",
		"ID": "979"
	},
	"Cresuz": {
		"y": "46.62056",
		"population": "328",
		"x": "7.14257",
		"ID": "293"
	},
	"Diemtigen": {
		"y": "46.64928",
		"population": "2145",
		"x": "7.56477",
		"ID": "477"
	},
	"Sisikon": {
		"y": "46.94915",
		"population": "375",
		"x": "8.62003",
		"ID": "965"
	},
	"Ilanz/Glion": {
		"y": "46.77413",
		"population": "4463",
		"x": "9.20461",
		"ID": "1268"
	},
	"Zihlschlacht-Sitterdorf": {
		"y": "47.51401",
		"population": "2225",
		"x": "9.26776",
		"ID": "1311"
	},
	"Aarwangen": {
		"y": "47.23845",
		"population": "4327",
		"x": "7.76854",
		"ID": "588"
	},
	"Deitingen": {
		"y": "47.21579",
		"population": "2194",
		"x": "7.61988",
		"ID": "520"
	},
	"Riederalp": {
		"y": "46.37637",
		"population": "498",
		"x": "8.02611",
		"ID": "699"
	},
	"Lonay": {
		"y": "46.52877",
		"population": "2530",
		"x": "6.51944",
		"ID": "69"
	},
	"Flumenthal": {
		"y": "47.23548",
		"population": "945",
		"x": "7.59851",
		"ID": "521"
	},
	"Morbio Inferiore": {
		"y": "45.84915",
		"population": "4585",
		"x": "9.01907",
		"ID": "1187"
	},
	"Soazza": {
		"y": "46.36637",
		"population": "332",
		"x": "9.22199",
		"ID": "1289"
	},
	"Tschugg": {
		"y": "47.02534",
		"population": "440",
		"x": "7.08103",
		"ID": "269"
	},
	"Niederrohrdorf": {
		"y": "47.42352",
		"population": "3663",
		"x": "8.30643",
		"ID": "830"
	},
	"Bargen (SH)": {
		"y": "47.79189",
		"population": "289",
		"x": "8.61022",
		"ID": "981"
	},
	"Corcelles-sur-Chavornay": {
		"y": "46.70273",
		"population": "336",
		"x": "6.60463",
		"ID": "94"
	},
	"Villmergen": {
		"y": "47.34917",
		"population": "6942",
		"x": "8.24583",
		"ID": "829"
	},
	"Obergoms": {
		"y": "46.53308",
		"population": "643",
		"x": "8.3707",
		"ID": "863"
	},
	"Rumlingen": {
		"y": "47.42435",
		"population": "383",
		"x": "7.84839",
		"ID": "657"
	},
	"Steffisburg": {
		"y": "46.77807",
		"population": "15467",
		"x": "7.63249",
		"ID": "512"
	},
	"Prevonloup": {
		"y": "46.70081",
		"population": "171",
		"x": "6.88529",
		"ID": "170"
	},
	"Nusshof": {
		"y": "47.49144",
		"population": "259",
		"x": "7.80073",
		"ID": "625"
	},
	"Bursins": {
		"y": "46.45276",
		"population": "777",
		"x": "6.29139",
		"ID": "43"
	},
	"Buttisholz": {
		"y": "47.11442",
		"population": "3218",
		"x": "8.09425",
		"ID": "743"
	},
	"Oberglatt": {
		"y": "47.47576",
		"population": "6752",
		"x": "8.51896",
		"ID": "941"
	},
	"Vernier": {
		"y": "46.21702",
		"population": "33047",
		"x": "6.08497",
		"ID": "6"
	},
	"Hellikon": {
		"y": "47.50943",
		"population": "803",
		"x": "7.92423",
		"ID": "690"
	},
	"Reitnau": {
		"y": "47.25102",
		"population": "1238",
		"x": "8.04889",
		"ID": "716"
	},
	"Vechigen": {
		"y": "46.94616",
		"population": "5184",
		"x": "7.56065",
		"ID": "483"
	},
	"Ausserberg": {
		"y": "46.31386",
		"population": "626",
		"x": "7.85299",
		"ID": "636"
	},
	"Ferreyres": {
		"y": "46.65886",
		"population": "311",
		"x": "6.48485",
		"ID": "71"
	},
	"Magliaso": {
		"y": "45.98122",
		"population": "1464",
		"x": "8.88796",
		"ID": "1118"
	},
	"Gansingen": {
		"y": "47.54444",
		"population": "984",
		"x": "8.13478",
		"ID": "781"
	},
	"Langnau im Emmental": {
		"y": "46.93936",
		"population": "8915",
		"x": "7.78738",
		"ID": "614"
	},
	"Geroldswil": {
		"y": "47.42213",
		"population": "4809",
		"x": "8.41085",
		"ID": "880"
	},
	"Baretswil": {
		"y": "47.33709",
		"population": "4920",
		"x": "8.85645",
		"ID": "1107"
	},
	"Bullet": {
		"y": "46.83119",
		"population": "605",
		"x": "6.55403",
		"ID": "85"
	},
	"Burchen": {
		"y": "46.28053",
		"population": "731",
		"x": "7.81506",
		"ID": "602"
	},
	"Eischoll": {
		"y": "46.29352",
		"population": "449",
		"x": "7.77995",
		"ID": "602"
	},
	"Adelboden": {
		"y": "46.49142",
		"population": "3381",
		"x": "7.56031",
		"ID": "474"
	},
	"Diessenhofen": {
		"y": "47.68908",
		"population": "3633",
		"x": "8.74958",
		"ID": "1046"
	},
	"Goldach": {
		"y": "47.47401",
		"population": "8967",
		"x": "9.46711",
		"ID": "1383"
	},
	"Grosshochstetten": {
		"y": "46.90671",
		"population": "3455",
		"x": "7.63782",
		"ID": "514"
	},
	"Flawil": {
		"y": "47.41301",
		"population": "10248",
		"x": "9.18324",
		"ID": "1280"
	},
	"Noreaz": {
		"y": "46.80145",
		"population": "616",
		"x": "7.02784",
		"ID": "232"
	},
	"Gletterens": {
		"y": "46.89489",
		"population": "998",
		"x": "6.93689",
		"ID": "201"
	},
	"Val-d'Illiez": {
		"y": "46.2036",
		"population": "1873",
		"x": "6.891",
		"ID": "160"
	},
	"Kaisten": {
		"y": "47.539",
		"population": "2564",
		"x": "8.04491",
		"ID": "751"
	},
	"Schwende": {
		"y": "47.30298",
		"population": "2152",
		"x": "9.43674",
		"ID": "1379"
	},
	"Belp": {
		"y": "46.89129",
		"population": "11384",
		"x": "7.49825",
		"ID": "450"
	},
	"Demoret": {
		"y": "46.74691",
		"population": "123",
		"x": "6.76086",
		"ID": "127"
	},
	"Riehen": {
		"y": "47.57884",
		"population": "20310",
		"x": "7.64683",
		"ID": "527"
	},
	"Haute-Sorne": {
		"y": "47.31985",
		"population": "6742",
		"x": "7.24314",
		"ID": "338"
	},
	"Lausanne": {
		"y": "46.516",
		"population": "132019",
		"x": "6.63282",
		"ID": "90"
	},
	"Gordola": {
		"y": "46.18256",
		"population": "4454",
		"x": "8.86657",
		"ID": "1085"
	},
	"Ins": {
		"y": "47.00584",
		"population": "3402",
		"x": "7.10609",
		"ID": "268"
	},
	"Zell (LU)": {
		"y": "47.13673",
		"population": "1969",
		"x": "7.92495",
		"ID": "683"
	},
	"Essertines-sur-Rolle": {
		"y": "46.49307",
		"population": "696",
		"x": "6.31765",
		"ID": "43"
	},
	"Iragna": {
		"y": "46.32571",
		"population": "565",
		"x": "8.96656",
		"ID": "1160"
	},
	"Scuol": {
		"y": "46.79676",
		"population": "4610",
		"x": "10.30595",
		"ID": "1564"
	},
	"Hildisrieden": {
		"y": "47.15068",
		"population": "2104",
		"x": "8.22582",
		"ID": "800"
	},
	"Cressier (FR)": {
		"y": "46.8979",
		"population": "927",
		"x": "7.14071",
		"ID": "299"
	},
	"Illgau": {
		"y": "46.98764",
		"population": "785",
		"x": "8.72509",
		"ID": "1032"
	},
	"St. Antoni": {
		"y": "46.82207",
		"population": "1999",
		"x": "7.26091",
		"ID": "358"
	},
	"Vaumarcus": {
		"y": "46.87909",
		"population": "276",
		"x": "6.75728",
		"ID": "129"
	},
	"Tafers": {
		"y": "46.81483",
		"population": "3249",
		"x": "7.21852",
		"ID": "329"
	},
	"Hori": {
		"y": "47.5075",
		"population": "2605",
		"x": "8.50244",
		"ID": "910"
	},
	"Salmsach": {
		"y": "47.55433",
		"population": "1393",
		"x": "9.37229",
		"ID": "1337"
	},
	"Montpreveyres": {
		"y": "46.58264",
		"population": "623",
		"x": "6.74114",
		"ID": "124"
	},
	"Tegerfelden": {
		"y": "47.55809",
		"population": "1152",
		"x": "8.28914",
		"ID": "833"
	},
	"Courlevon": {
		"y": "46.88929",
		"population": "292",
		"x": "7.11057",
		"ID": "266"
	},
	"Vinelz": {
		"y": "47.034",
		"population": "850",
		"x": "7.11606",
		"ID": "269"
	},
	"Altdorf (UR)": {
		"y": "46.88042",
		"population": "8953",
		"x": "8.64441",
		"ID": "997"
	},
	"Sils im Engadin/Segl": {
		"y": "46.42886",
		"population": "746",
		"x": "9.76364",
		"ID": "1464"
	},
	"Bulach": {
		"y": "47.49706",
		"population": "19035",
		"x": "8.56764",
		"ID": "942"
	},
	"Kandersteg": {
		"y": "46.49467",
		"population": "1272",
		"x": "7.67326",
		"ID": "540"
	},
	"Fislisbach": {
		"y": "47.43904",
		"population": "5470",
		"x": "8.29687",
		"ID": "831"
	},
	"Gurbru": {
		"y": "46.96485",
		"population": "246",
		"x": "7.21527",
		"ID": "331"
	},
	"Nyon": {
		"y": "46.38318",
		"population": "19935",
		"x": "6.23955",
		"ID": "34"
	},
	"Granichen": {
		"y": "47.3593",
		"population": "7349",
		"x": "8.10243",
		"ID": "777"
	},
	"Urnasch": {
		"y": "47.31669",
		"population": "2205",
		"x": "9.2795",
		"ID": "1307"
	},
	"Aefligen": {
		"y": "47.09571",
		"population": "1057",
		"x": "7.55175",
		"ID": "485"
	},
	"Brissago": {
		"y": "46.12013",
		"population": "1711",
		"x": "8.71181",
		"ID": "1016"
	},
	"Gals": {
		"y": "47.02841",
		"population": "767",
		"x": "7.05183",
		"ID": "236"
	},
	"Liedertswil": {
		"y": "47.39051",
		"population": "160",
		"x": "7.72065",
		"ID": "557"
	},
	"Soyhieres": {
		"y": "47.38884",
		"population": "479",
		"x": "7.3662",
		"ID": "400"
	},
	"Frenkendorf": {
		"y": "47.50686",
		"population": "6406",
		"x": "7.71648",
		"ID": "593"
	},
	"Burg (AG)": {
		"y": "47.23389",
		"population": "966",
		"x": "8.17797",
		"ID": "801"
	},
	"Ulmiz": {
		"y": "46.93187",
		"population": "410",
		"x": "7.19783",
		"ID": "331"
	},
	"Ernen": {
		"y": "46.39684",
		"population": "504",
		"x": "8.14166",
		"ID": "759"
	},
	"Wollerau": {
		"y": "47.19478",
		"population": "6985",
		"x": "8.71903",
		"ID": "1036"
	},
	"Safnern": {
		"y": "47.14996",
		"population": "1925",
		"x": "7.32314",
		"ID": "395"
	},
	"Regensberg": {
		"y": "47.48295",
		"population": "467",
		"x": "8.43791",
		"ID": "910"
	},
	"Lutschental": {
		"y": "46.63727",
		"population": "217",
		"x": "7.9499",
		"ID": "674"
	},
	"Terre di Pedemonte": {
		"y": "46.19281",
		"population": "2577",
		"x": "8.72402",
		"ID": "1017"
	},
	"Kestenholz": {
		"y": "47.28039",
		"population": "1756",
		"x": "7.75291",
		"ID": "588"
	},
	"Seehof": {
		"y": "47.30467",
		"population": "66",
		"x": "7.52496",
		"ID": "489"
	},
	"Rudolfstetten-Friedlisberg": {
		"y": "47.37101",
		"population": "4355",
		"x": "8.38083",
		"ID": "879"
	},
	"Hubersdorf": {
		"y": "47.24629",
		"population": "713",
		"x": "7.58945",
		"ID": "521"
	},
	"Eggiwil": {
		"y": "46.87575",
		"population": "2387",
		"x": "7.79567",
		"ID": "613"
	},
	"Rhazuns": {
		"y": "46.79861",
		"population": "1410",
		"x": "9.39837",
		"ID": "1345"
	},
	"Chalais": {
		"y": "46.26758",
		"population": "3371",
		"x": "7.51145",
		"ID": "438"
	},
	"Samedan": {
		"y": "46.53399",
		"population": "2965",
		"x": "9.87276",
		"ID": "1494"
	},
	"Oberwil im Simmental": {
		"y": "46.65688",
		"population": "803",
		"x": "7.43513",
		"ID": "415"
	},
	"Naters": {
		"y": "46.32536",
		"population": "9669",
		"x": "7.98912",
		"ID": "698"
	},
	"Arbedo-Castione": {
		"y": "46.2013",
		"population": "4754",
		"x": "9.07764",
		"ID": "1226"
	},
	"Valbroye": {
		"y": "46.7249",
		"population": "2950",
		"x": "6.89202",
		"ID": "170"
	},
	"Hettlingen": {
		"y": "47.5461",
		"population": "3094",
		"x": "8.70532",
		"ID": "1010"
	},
	"Stalden (VS)": {
		"y": "46.23341",
		"population": "1082",
		"x": "7.87273",
		"ID": "634"
	},
	"Goumoens": {
		"y": "46.65922",
		"population": "1016",
		"x": "6.60398",
		"ID": "93"
	},
	"Preverenges": {
		"y": "46.51854",
		"population": "5236",
		"x": "6.52682",
		"ID": "68"
	},
	"Cureglia": {
		"y": "46.03736",
		"population": "1347",
		"x": "8.94437",
		"ID": "1154"
	},
	"Premier": {
		"y": "46.70575",
		"population": "185",
		"x": "6.44991",
		"ID": "61"
	},
	"Vilters-Wangs": {
		"y": "47.0097",
		"population": "4602",
		"x": "9.4253",
		"ID": "1349"
	},
	"Villars-Epeney": {
		"y": "46.78261",
		"population": "90",
		"x": "6.69762",
		"ID": "108"
	},
	"Schofflisdorf": {
		"y": "47.5003",
		"population": "1380",
		"x": "8.41754",
		"ID": "882"
	},
	"Luins": {
		"y": "46.44203",
		"population": "630",
		"x": "6.27275",
		"ID": "35"
	},
	"Schlossrued": {
		"y": "47.29119",
		"population": "807",
		"x": "8.0884",
		"ID": "746"
	},
	"Huniken": {
		"y": "47.18473",
		"population": "94",
		"x": "7.63627",
		"ID": "520"
	},
	"Turbenthal": {
		"y": "47.43633",
		"population": "4420",
		"x": "8.84629",
		"ID": "1109"
	}
};


//////////////////
// WEBPACK FOOTER
// ../res/cities.json
// module id = 14
// module chunks = 0